// @ts-nocheck

/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Podium API Documentation
 * Everything you need to know to consume the Podium REST API
 * OpenAPI spec version: 0.0.1
 */
import { useCallback } from 'react';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';
import { useCustomAxios } from './customAxios';
import { useCustomBinaryAxios } from './customAxios';
import { useCustomFilterTalentsQueryOptions } from './infiniteQueryOptions';
import { useCustomGetProcessTalentsQueryOptions } from './infiniteQueryOptions';
import { useCustomFilterProcessesQueryOptions } from './infiniteQueryOptions';
import { useCustomFilterOrganizationsQueryOptions } from './infiniteQueryOptions';
import { useCustomGetUserRoleAssignmentsByLocationQueryOptions } from './infiniteQueryOptions';
import { useCustomFilterUserOrganizationAssignmentsQueryOptions } from './infiniteQueryOptions';
import { useCustomFilterOrganizationItemsQueryOptions } from './infiniteQueryOptions';
import { useCustomGetMidotUsersQueryOptions } from './infiniteQueryOptions';
import { useCustomGetMidotRolesQueryOptions } from './infiniteQueryOptions';
export type GetReportPdfMode = (typeof GetReportPdfMode)[keyof typeof GetReportPdfMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportPdfMode = {
  inline: 'inline',
  attachment: 'attachment'
} as const;

export type GetReportPdfParams = {
  /**
   * The language code for the report content (e.g., en-US, es-ES)
   */
  locale?: PlatformLocale;
  /**
   * The mode of the report content (e.g., inline, attachment)
   */
  mode?: GetReportPdfMode;
};

export type DeleteFolderItem200 = { [key: string]: unknown };

export type DeleteOrganization200 = { [key: string]: unknown };

export type _DeleteParams = {
  key: string;
};

export type DownloadBasicExport200 = { [key: string]: unknown };

export type DownloadBasicExportParams = {
  orgId: string;
};

export type DownloadPIIExport200 = { [key: string]: unknown };

export type DownloadPIIExportParams = {
  orgId: string;
};

export type GetFolder1200 = { [key: string]: unknown };

export type GetAdminMenu200 = { [key: string]: unknown };

export type GetOrgSettingsMenu200 = { [key: string]: unknown };

export type GetReportsMenu200 = { [key: string]: unknown };

export type GetOrganizationSettings200 = { [key: string]: unknown };

export type CheckGlobalAdmin200 = { [key: string]: unknown };

export type CheckPermission200 = { [key: string]: unknown };

export type CheckPermissionParams = {
  resourceType: string;
  resourceId: string;
  permission: string;
};

export type GetProtectedLocation200 = { [key: string]: unknown };

export type GetProtectedOrganization200 = { [key: string]: unknown };

export type GetViewableOrganizations200 = { [key: string]: unknown };

export type GetClients200 = { [key: string]: unknown };

export type ExistsParams = {
  key: string;
};

export type Get200 = { [key: string]: unknown };

export type GetParams = {
  key: string;
};

export type AcceptAccountParams = {
  /**
   * User ID from the invitation link
   */
  userId: string;
  /**
   * Comma-separated list of office slugs
   */
  offices?: string;
  /**
   * Invitation token from the email link
   */
  token: string;
};

export type GetAuthenticationOptionsParams = {
  email: string;
};

export type GetCatalogItemDetailsLocale =
  (typeof GetCatalogItemDetailsLocale)[keyof typeof GetCatalogItemDetailsLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCatalogItemDetailsLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type GetCatalogItemDetailsParams = {
  /**
   * The locale for the catalog
   */
  locale: GetCatalogItemDetailsLocale;
};

export type GetTestCatalogLocale = (typeof GetTestCatalogLocale)[keyof typeof GetTestCatalogLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTestCatalogLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type GetTestCatalogParams = {
  /**
   * The type of assessment for the catalog (input parameter, but response field will be 'assesmentType')
   */
  assessmentType?: string;
  /**
   * The locale for the catalog
   */
  locale?: GetTestCatalogLocale;
  /**
   * The slug of the location
   */
  location_slug: string;
  /**
   * The type of location
   */
  location_type: string;
};

export type DebugAuthStatus200 = { [key: string]: unknown };

export type TestApiKey200 = { [key: string]: unknown };

export type GetCurrentUserInfo200 = { [key: string]: unknown };

export type GenerateJwtParams = {
  /**
   * Email address for the JWT token
   */
  email: string;
};

export type CheckConfig200 = { [key: string]: unknown };

export type GetAllRolesParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
  /**
   * Filter by user name, email, or phone
   */
  name?: string;
  /**
   * Filter by role type
   */
  type?: string;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort direction
   */
  sortDirection?: string;
};

export type GetRolesParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
  /**
   * Filter by user name, email, or phone
   */
  name?: string;
  /**
   * Filter by role type
   */
  type?: string;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort direction
   */
  sortDirection?: string;
};

export type GetMidotUsersParams = {
  /**
   * Search term to filter users by first name, last name, full name, office, email, or role name
   */
  query?: string;
  /**
   * Office slug(s) to filter users; can be repeated for multiple offices (e.g. office_slug=tel-aviv&office_slug=haifa)
   */
  office_slug?: string[];
  /**
   * Role ID to filter users by specific role
   */
  role_id?: string;
  /**
   * Page number (0-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
  /**
   * Field to sort by (e.g., 'fullName', 'email', 'createdAt')
   */
  sort?: string;
  /**
   * Sort direction: 'asc' for ascending or 'desc' for descending
   */
  direction?: string;
};

export type GetMidotEmployeeUsersBySearchParams = {
  search?: string;
};

export type GetOfficesParams = {
  organizationSlug?: string;
};

export type AutosuggestionOrganizationsParams = {
  /**
   * The search string to match organization names or legal names
   */
  search: string;
};

export type DebugAuth200 = { [key: string]: unknown };

export type DebugAuthParams = {
  userEmail?: string;
};

export type GetFolderRoleAssignmentsByUserParams = {
  /**
   * Page number (1-based). Default: 1
   */
  page?: number;
  /**
   * Number of items per page. Default: 10
   */
  size?: number;
};

export type GetFolderRoleAssignmentsParams = {
  /**
   * Optional role ID to filter assignments
   */
  roleId?: string;
  /**
   * Whether to include user count per role in response
   */
  includeStats?: boolean;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
};

export type GetOrganizationItemLocationType =
  (typeof GetOrganizationItemLocationType)[keyof typeof GetOrganizationItemLocationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrganizationItemLocationType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export type GetOrganizationItemParams = {
  /**
   * Type of the location (organization, suborganization, folder, subfolder)
   */
  locationType: GetOrganizationItemLocationType;
};

export type GetOrganizationItemsLocationType =
  (typeof GetOrganizationItemsLocationType)[keyof typeof GetOrganizationItemsLocationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrganizationItemsLocationType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export type GetOrganizationItemsParams = {
  /**
   * Slug of the location within the organization.
   */
  locationSlug: string;
  /**
   * Type of the location (e.g., organization, suborganization, folder, subfolder).
   */
  locationType: GetOrganizationItemsLocationType;
  /**
   * Page number for pagination.
   */
  page: number;
  /**
   * Number of items per page.
   */
  size?: number;
};

export type GetProcessesParams = {
  /**
   * Search string to filter processes by name
   */
  search?: string;
};

export type GetProcessMessagesLocale = (typeof GetProcessMessagesLocale)[keyof typeof GetProcessMessagesLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProcessMessagesLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type GetProcessMessagesParams = {
  /**
   * Locale for the messages. If not provided or not available, returns default language.
   */
  locale?: GetProcessMessagesLocale;
};

export type GetSession200 = { [key: string]: unknown };

export type GetSessionParams = {
  sessionId: string;
};

export type ListUsers200 = { [key: string]: unknown };

export type AutosuggestTalentsParams = {
  /**
   * Search string to match talents
   */
  search: string;
};

export type GetReportLocale = (typeof GetReportLocale)[keyof typeof GetReportLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type GetReportParams = {
  /**
   * The language code for the report content (e.g., en-US, es-ES)
   */
  locale?: GetReportLocale;
};

export type GetTestTypeNormsParams = {
  /**
   * Page number for pagination (0-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
  /**
   * Free-text search over norms (searches in title)
   */
  q?: string;
};

export type GetUserOrganizationAssignmentsParams = {
  /**
   * Search term to filter users by first name, last name, full name, organization name, or email
   */
  query?: string;
  /**
   * Organization ID to filter assignments
   */
  organization_id?: string;
  /**
   * Page number (0-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
  /**
   * Field to sort by (e.g., 'fullName', 'email', 'createdAt')
   */
  sort?: string;
  /**
   * Sort direction: 'asc' for ascending or 'desc' for descending
   */
  direction?: string;
};

export type AutocompleteUsersParams = {
  q?: string;
  organizationId?: string;
  page?: number;
  size?: number;
};

export type GetUsersByIdsParams = {
  /**
   * Comma-separated list of User ids
   */
  id: string[];
};

export type GetUserOrganizationsParams = {
  /**
   * If true, only return organizations where the user is an admin
   */
  adminOnly?: boolean;
};

export type GetUserRoleAssignmentsByLocationParams = {
  /**
   * Page number (0-based)
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
  /**
   * Sort field (organization.name, location.name)
   */
  sort?: string;
  /**
   * Sort direction (asc/desc)
   */
  direction?: string;
};

export type GetUsersBySearchParams = {
  search?: string;
};

export type PreviewEmailLanguage = (typeof PreviewEmailLanguage)[keyof typeof PreviewEmailLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreviewEmailLanguage = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type PreviewEmailParams = {
  firstName?: string;
  orgName?: string;
  templateType?: string;
  language?: PreviewEmailLanguage;
};

export type SendEmailParams = {
  userEmail: string;
  firstName?: string;
  orgName?: string;
};

export type TestHtmlEmailParams = {
  userEmail: string;
};

export type GetOrganizationBySlugParams = {
  /**
   * If true, returns additional organization details
   */
  isFull?: boolean;
};

export type CreateFolderItem200 = { [key: string]: unknown };

export type CreateFolderItemBody = { [key: string]: unknown };

export type CreateOrganizationUser200 = { [key: string]: unknown };

export type CreateOrganizationUserBody = { [key: string]: unknown };

export type TestAuthorization200 = { [key: string]: unknown };

export type TestAuthorizationBody = { [key: string]: unknown };

export type ManageOrganization200 = { [key: string]: unknown };

export type CreateUserOrganizationRelationship200 = { [key: string]: string };

export type CreateUserOrganizationRelationshipParams = {
  userId: string;
  organizationId: string;
  relation: string;
};

export type IntrospectToken200 = { [key: string]: unknown };

export type IntrospectTokenParams = {
  token: string;
};

export type IssueToken401 = { [key: string]: unknown };

export type IssueToken400 = { [key: string]: unknown };

export type IssueTokenParams = {
  /**
   * Must be 'client_credentials'
   */
  grant_type: string;
  /**
   * Your client identifier
   */
  client_id: string;
  /**
   * Your client secret
   */
  client_secret: string;
  /**
   * Requested scope (optional)
   */
  scope?: string;
};

export type SaveWithExpirationParams = {
  key: string;
  value: string;
  timeout: number;
};

export type SaveParams = {
  key: string;
  value: string;
};

export type CreateApiKey200 = { [key: string]: unknown };

export type ValidateApiKey200 = { [key: string]: unknown };

export type Validate200 = { [key: string]: unknown };

export type ValidateJwt200 = { [key: string]: unknown };

export type CreateTalentViaDataProcessor500 = { [key: string]: unknown };

export type CreateTalentViaDataProcessor404 = { [key: string]: unknown };

export type CreateTalentViaDataProcessor400 = { [key: string]: unknown };

export type CreateTalent500 = { [key: string]: unknown };

export type CreateTalent404 = { [key: string]: unknown };

export type CreateTalent400 = { [key: string]: unknown };

export type CreateTalentParams = {
  /**
   * Flag to indicate if this is a Player registration that requires additional validation
   */
  isPlayerRegistration?: boolean;
};

export type GetProcessTalentsParams = {
  /**
   * Search query for talents
   */
  q?: string;
  /**
   * Page number for pagination
   */
  page?: number;
  /**
   * Number of results per page
   */
  size?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  /**
   * Direction to sort (ASC/DESC)
   */
  sortDirection?: string;
  /**
   * Whether to include talent stats in the response
   */
  includeStats?: boolean;
};

export type UploadFileBody = {
  file: Blob;
};

export type CreateProcess500 = { [key: string]: unknown };

export type CreateProcess400 = { [key: string]: unknown };

export type ConvertJwtToSession200 = { [key: string]: unknown };

export type Login200 = { [key: string]: unknown };

export type Logout200 = { [key: string]: unknown };

export type LogoutParams = {
  sessionId: string;
};

export type FilterTalentsParams = {
  /**
   * Flag to indicate if total counts are required
   */
  includeStats?: boolean;
  talentStatus?: string;
};

export type EditAccount200 = { [key: string]: unknown };

export type EditAccountBody = { [key: string]: unknown };

export type GetAccount200 = { [key: string]: unknown };

export type GetOrganizationMessagesParams = {
  /**
   * Preferred locale for messages (e.g., en-US, fr-FR). If not specified or not available, returns default locale.
   */
  locale?: string;
};

export type UpdateTalentLocations500 = { [key: string]: unknown };

export interface ProcessTalentStatsDTO {
  completed?: number;
  inProgress?: number;
  registered?: number;
  total?: number;
}

export type LatestProcessCriteriaDTOTalentStatus =
  (typeof LatestProcessCriteriaDTOTalentStatus)[keyof typeof LatestProcessCriteriaDTOTalentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LatestProcessCriteriaDTOTalentStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  COMPLETED: 'COMPLETED',
  REFUSED: 'REFUSED',
  __NULL__: '__NULL__'
} as const;

export interface LatestProcessCriteriaDTO {
  talentStatus?: LatestProcessCriteriaDTOTalentStatus;
}

export type ProcessDTOTalentStatus = (typeof ProcessDTOTalentStatus)[keyof typeof ProcessDTOTalentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessDTOTalentStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  HIRED: 'HIRED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

export interface ProcessDTO {
  createdBy?: UserDTO;
  id?: string;
  name?: string;
  status?: string;
  talentStatus?: ProcessDTOTalentStatus;
}

export type PlatformLocale = (typeof PlatformLocale)[keyof typeof PlatformLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX'
} as const;

export type TestSessionStatus = (typeof TestSessionStatus)[keyof typeof TestSessionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSessionStatus = {
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  REFUSED: 'REFUSED',
  RE_TEST: 'RE_TEST'
} as const;

export interface DeleteProcessTalentsDTO {
  talentIds?: string[];
}

export type UserSessionStatus = (typeof UserSessionStatus)[keyof typeof UserSessionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSessionStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  INVALIDATED: 'INVALIDATED',
  LOCKED: 'LOCKED'
} as const;

export type UserSessionAttributes = { [key: string]: unknown };

export interface UserSession {
  attributes?: UserSessionAttributes;
  authorities?: string[];
  createdAt: string;
  deviceType?: string;
  /** @minLength 1 */
  email: string;
  expired?: boolean;
  expiresAt?: string;
  firstName?: string;
  fullName?: string;
  ipAddress?: string;
  lastAccessedAt: string;
  lastName?: string;
  loginMethod?: string;
  midotEmployee?: boolean;
  organizationId?: string;
  sessionId?: string;
  status?: UserSessionStatus;
  userAgent?: string;
  /** @minLength 1 */
  userId: string;
}

export type AuthenticationOptionsDtoPreferredOtpMethod =
  (typeof AuthenticationOptionsDtoPreferredOtpMethod)[keyof typeof AuthenticationOptionsDtoPreferredOtpMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthenticationOptionsDtoPreferredOtpMethod = {
  whatsapp: 'whatsapp',
  phone: 'phone',
  email: 'email',
  auth: 'auth',
  none: 'none'
} as const;

export type AuthenticationOptionsDtoPreferredLoginMethod =
  (typeof AuthenticationOptionsDtoPreferredLoginMethod)[keyof typeof AuthenticationOptionsDtoPreferredLoginMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthenticationOptionsDtoPreferredLoginMethod = {
  sso: 'sso',
  outlook: 'outlook',
  passkey: 'passkey',
  magic: 'magic',
  microsoft: 'microsoft',
  google: 'google',
  none: 'none'
} as const;

export type AuthenticationOptionsDtoLastOtpMethod =
  (typeof AuthenticationOptionsDtoLastOtpMethod)[keyof typeof AuthenticationOptionsDtoLastOtpMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthenticationOptionsDtoLastOtpMethod = {
  whatsapp: 'whatsapp',
  phone: 'phone',
  email: 'email',
  auth: 'auth',
  none: 'none'
} as const;

export type AuthenticationOptionsDtoLastLoginMethod =
  (typeof AuthenticationOptionsDtoLastLoginMethod)[keyof typeof AuthenticationOptionsDtoLastLoginMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthenticationOptionsDtoLastLoginMethod = {
  sso: 'sso',
  outlook: 'outlook',
  passkey: 'passkey',
  magic: 'magic',
  microsoft: 'microsoft',
  google: 'google',
  none: 'none'
} as const;

export interface AuthenticationOptionsDto {
  activeAndDescopeAuth?: boolean;
  email?: string;
  lastLoginMethod?: AuthenticationOptionsDtoLastLoginMethod;
  lastOtpDone?: string;
  lastOtpMethod?: AuthenticationOptionsDtoLastOtpMethod;
  preferredLoginMethod?: AuthenticationOptionsDtoPreferredLoginMethod;
  preferredOtpMethod?: AuthenticationOptionsDtoPreferredOtpMethod;
  userTenant?: string;
}

export interface InfoGridItem {
  caption?: string;
  label?: string;
}

export interface CategoryDTO {
  assessmentType?: string;
  iconUrl?: string;
  id?: string;
  name?: string;
}

export interface CatalogItemDetailsDTO {
  assessmentType?: string;
  catalogId?: string;
  category?: CategoryDTO;
  description?: string;
  estimatedDuration?: number;
  iconUrl?: string;
  infoGrid?: InfoGridItem[];
  isAvailable?: boolean;
  itemCount?: number;
  locale?: string;
  name?: string;
  supportedLocales?: string[];
}

export interface CatalogDTO {
  assessmentType?: string;
  catalogId?: string;
  category?: CategoryDTO;
  description?: string;
  estimatedDuration?: number;
  iconUrl?: string;
  infoGrid?: InfoGridItem[];
  isAvailable?: boolean;
  itemCount?: number;
  name?: string;
  order?: number;
  supportedLocales?: string[];
  testCategory?: string;
}

export interface TestCatalogResponseDTO {
  catalog?: CatalogDTO[];
}

export interface JwtResponse {
  email?: string;
  instructions?: string;
  jwt?: string;
  warning?: string;
  whitelisted?: boolean;
}

export interface WebcamConfig {
  captureFrequencySeconds?: number;
  isEnabled?: boolean;
  isMandatory?: boolean;
}

export type TalentQuestionDtoType = (typeof TalentQuestionDtoType)[keyof typeof TalentQuestionDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentQuestionDtoType = {
  TEXT: 'TEXT',
  LONG_TEXT: 'LONG_TEXT',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  SELECT: 'SELECT',
  FILE: 'FILE',
  YEAR: 'YEAR'
} as const;

export interface TalentQuestionDto {
  id?: string;
  isActive?: boolean;
  isExternal?: boolean;
  isKnockout?: boolean;
  isRequired?: boolean;
  optionValues?: string[];
  type?: TalentQuestionDtoType;
  validation?: TalentQuestionValidation;
}

export type QuestionTranslationDtoOptionLabels = { [key: string]: string };

export interface QuestionTranslationDto {
  label?: string;
  optionLabels?: QuestionTranslationDtoOptionLabels;
}

export type PodiumInvitationDTOAccessMode =
  (typeof PodiumInvitationDTOAccessMode)[keyof typeof PodiumInvitationDTOAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PodiumInvitationDTOAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface PodiumInvitationDTO {
  accessKey?: string;
  accessMode?: PodiumInvitationDTOAccessMode;
  additionalQuestions?: AdditionalQuestionDto[];
  catalogItems?: CatalogItemDTO[];
  fatherId?: string;
  id?: string;
  organizationSlug?: string;
  passwordHash?: string;
  processId?: string;
  registeredBy?: string;
  shaHash?: string;
  talent?: TalentDTO;
  url?: string;
}

export interface InvitationResultDTO {
  invitation?: PodiumInvitationDTO;
  killbillApproved?: boolean;
  locationCriteria?: LocationCriteriaDTO;
  timestamp?: string;
  webcamConfig?: WebcamConfig;
}

export interface AdditionalQuestionDto {
  answer?: unknown;
  talentQuestion?: TalentQuestionDto;
  translation?: QuestionTranslationDto;
}

/**
 * Midot Role Data Transfer Object
 */
export interface MidotRoleDTO {
  /** Unique identifier of the role */
  id?: string;
  /** Name of the role */
  name?: string;
  /** Number of users assigned to this role */
  usersCount?: number;
  /** Summary of up to 5 users assigned to this role */
  usersSummary?: UserSummaryDTO[];
}

/**
 * Response DTO for Midot Roles API
 */
export interface MidotRolesResponseDTO {
  /** Pagination metadata */
  metadata?: PagedMetadata;
  /** List of Midot roles */
  roles?: MidotRoleDTO[];
}

/**
 * Role assignment summary
 */
export interface RoleAssignmentSummaryDTO {
  /** Role ID */
  id?: string;
  /** Role name */
  name?: string;
}

/**
 * Midot user information
 */
export interface MidotUserDTO {
  /** Account creation timestamp */
  createdAt?: string;
  /** User who created this account */
  createdBy?: CreatedByUserDTO;
  /** User's email address */
  email?: string;
  /** User's first name */
  firstName?: string;
  /** User's full name */
  fullName?: string;
  /** User's unique identifier */
  id?: string;
  /** Whether user is a Midot employee */
  isMidotEmployee?: boolean;
  /** Last login timestamp */
  lastLoginAt?: string;
  /** User's last name */
  lastName?: string;
  /** List of office slugs the user belongs to */
  offices?: string[];
  /** User's phone number */
  phone?: string;
  /** Total number of role assignments */
  roleAssignmentCount?: number;
  /** Summary of first 3 role assignments */
  roleAssignmentsSummary?: RoleAssignmentSummaryDTO[];
  /** User's status */
  status?: string;
  /** User's job title */
  title?: string;
}

/**
 * Response containing Midot users with pagination metadata
 */
export interface MidotUsersResponseDTO {
  /** Whether this is the first page */
  first?: boolean;
  /** Whether this is the last page */
  last?: boolean;
  /** Number of elements in current page */
  numberOfElements?: number;
  /** Current page number (0-based) */
  page?: number;
  /** Number of items per page */
  size?: number;
  /** Total number of items */
  total?: number;
  /** Total number of pages */
  totalPages?: number;
  /** List of Midot users */
  users?: MidotUserDTO[];
}

export interface OfficeDTO {
  key?: string;
  name?: string;
  slug?: string;
}

export interface OrganizationAutosuggestDTO {
  /** Legal name of the organization */
  legalName?: string;
  /** Name of the organization */
  name?: string;
  /** Slug of the organization */
  slug?: string;
}

/**
 * Folder permissions
 */
export interface FolderPermissionsDTO {
  /** Whether the user can create processes */
  canCreateProcesses?: boolean;
  /** Whether the user can create subfolders */
  canCreateSubfolders?: boolean;
  /** Whether the user can create talents */
  canCreateTalents?: boolean;
  /** Whether the user can update basic info */
  canUpdateBasicInfo?: boolean;
  /** Whether the user can update roles and users */
  canUpdateRolesAndUsers?: boolean;
  /** Whether the user can view basic info */
  canViewBasicInfo?: boolean;
  /** Whether the user can view roles and users */
  canViewRolesAndUsers?: boolean;
}

export interface LocationUserRoleAssignmentsResponse {
  locationUserRolesAssignments?: LocationUserRolesAssignment[];
}

export interface UserInfo {
  avatarUrl?: string;
  email?: string;
  id?: string;
  name?: string;
}

export interface RoleInfo {
  id?: string;
  name?: string;
}

export interface LocationUserRolesAssignment {
  id?: string;
  roles?: RoleInfo[];
  user?: UserInfo;
}

export interface RoleAssignmentWithUserDto {
  /** Role information */
  role?: RoleInfo;
  /** User information */
  user?: UserInfo;
}

/**
 * Optional stats showing user count per role. Only present if includeStats is true
 */
export type PagedRoleAssignmentsDtoStats = { [key: string]: number };

/**
 * Paginated response containing role assignments with optional stats
 */
export interface PagedRoleAssignmentsDto {
  /** Current page number (1-based) */
  page?: number;
  /** List of role assignments */
  roleAssignments?: RoleAssignmentWithUserDto[];
  /** Number of items per page */
  size?: number;
  /** Optional stats showing user count per role. Only present if includeStats is true */
  stats?: PagedRoleAssignmentsDtoStats;
  /** Total number of elements */
  totalElements?: number;
  /** Total number of pages */
  totalPages?: number;
}

export type OrganizationItemDtoType = (typeof OrganizationItemDtoType)[keyof typeof OrganizationItemDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationItemDtoType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

/**
 * Organization item (organization, suborganization, folder, or subfolder)
 */
export interface OrganizationItemDto {
  countries?: string[];
  industry?: string;
  lastActivity?: string;
  name?: string;
  offices?: string[];
  slug?: string;
  /** The status of the item (e.g. ACTIVE, DRAFT). */
  status?: string;
  talentStats?: ProcessTalentStatsDTO;
  type?: OrganizationItemDtoType;
  userCount?: number;
  users?: UserDTO[];
}

/**
 * Paginated response of organization items (suborganizations, folders, or subfolders)
 */
export interface OrganizationItemsResponseDto {
  /** List of organization items */
  organizationItemDtos?: OrganizationItemDto[];
  page?: number;
  total?: number;
}

/**
 * Organization permissions
 */
export interface OrganizationPermissionsDTO {
  /** Whether the user can activate organization */
  canActivate?: boolean;
  /** Whether the user can create folders */
  canCreateFolders?: boolean;
  /** Whether the user can create processes */
  canCreateProcesses?: boolean;
  /** Whether the user can create suborganizations */
  canCreateSuborganizations?: boolean;
  /** Whether the user can create talents */
  canCreateTalents?: boolean;
  /** Whether the user can deactivate organization */
  canDeactivate?: boolean;
  /** Whether the user can delete organization */
  canDelete?: boolean;
  /** Whether the user can hold organization */
  canHold?: boolean;
  /** Whether the user can invite users */
  canInviteUsers?: boolean;
  /** Whether the user can update basic info */
  canUpdateBasicInfo?: boolean;
  /** Whether the user can update identification and norms */
  canUpdateIdentificationAndNorms?: boolean;
  /** Whether the user can update process settings for access and invitation */
  canUpdateProcessSettingsAccessAndInvitation?: boolean;
  /** Whether the user can update process settings for messages */
  canUpdateProcessSettingsMessages?: boolean;
  /** Whether the user can update process settings for talent registration */
  canUpdateProcessSettingsTalentRegistration?: boolean;
  /** Whether the user can update process settings for test properties */
  canUpdateProcessSettingsTestProperties?: boolean;
  /** Whether the user can update roles and users */
  canUpdateRolesAndUsers?: boolean;
  /** Whether the user can view basic info */
  canViewBasicInfo?: boolean;
  /** Whether the user can view identification and norms */
  canViewIdentificationAndNorms?: boolean;
  /** Whether the user can view process settings */
  canViewProcessSettings?: boolean;
  /** Whether the user can view roles and users */
  canViewRolesAndUsers?: boolean;
}

export interface SubOrganizationBaseDTO {
  name?: string;
  parent?: ParentStruct;
  slug?: string;
}

export type OrganizationStructureDTOStatus =
  (typeof OrganizationStructureDTOStatus)[keyof typeof OrganizationStructureDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationStructureDTOStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export interface OrganizationStructureDTO {
  folders?: FolderDTO[];
  name?: string;
  slug?: string;
  status?: OrganizationStructureDTOStatus;
  subFolders?: FolderDTO[];
  subOrganizations?: SubOrganizationBaseDTO[];
}

export interface SubfolderPermissionsDTO {
  canUpdateBasicInfo?: boolean;
  canUpdateRolesAndUsers?: boolean;
  canViewBasicInfo?: boolean;
  canViewRolesAndUsers?: boolean;
}

export interface PodiumPermissionsDTO {
  canAssignMidotRoles?: boolean;
  canCreateClientUsers?: boolean;
  canCreateMidotUsers?: boolean;
  canCreateOrganizations?: boolean;
  canDeleteOnboardingUsers?: boolean;
  canSeeMidotRoles?: boolean;
  canSeeMoreThanOneOrg?: boolean;
  canSeeRolesTab?: boolean;
  canSeeUsersInNavigation?: boolean;
  canUpdateSystemIds?: boolean;
  canViewMidotUsers?: boolean;
  canViewSystemIds?: boolean;
}

export interface ProcessShortDto {
  assessmentType?: string;
  description?: string;
  id?: string;
  location?: LocationDTO;
  name?: string;
  organization?: OrganizationDTO;
  processSettings?: ProcessSettings;
}

export type TalentProcessResponseDTOStatus =
  (typeof TalentProcessResponseDTOStatus)[keyof typeof TalentProcessResponseDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentProcessResponseDTOStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

/**
 * Talent information for a specific process, extending TalentResponseDTO
 */
export interface TalentProcessResponseDTO {
  createdBy?: UserDTO;
  email?: string;
  firstName?: string;
  id?: string;
  /** ID number of the talent */
  idNumber?: string;
  lastName?: string;
  latestProcess?: ProcessDTO;
  /** Latest test session for this talent in this process */
  latestTestSession?: TestSessionSummaryDTO;
  organization?: TalentListOrganizationDTO;
  phone?: string;
  processesCount?: number;
  status?: TalentProcessResponseDTOStatus;
  /** Test sessions for this talent in this process */
  testSessions?: TestSessionSummaryDTO[];
  /** Total count of test sessions for this talent in this process */
  testSessionsCount?: number;
  type?: string;
}

/**
 * Paginated response containing talents for a process with optional stats
 */
export interface PagedProcessTalentsResponseDTO {
  /** Whether this is the first page */
  first?: boolean;
  /** Whether this is the last page */
  last?: boolean;
  /** Number of elements in current page */
  numberOfElements?: number;
  /** Current page number (0-based) */
  page?: number;
  /** Number of items per page */
  size?: number;
  /** Optional stats showing talent counts by status. Only present if includeStats is true */
  stats?: ProcessTalentStatsDTO;
  /** List of talents for the process */
  talents?: TalentProcessResponseDTO[];
  /** Total number of items */
  total?: number;
  /** Total number of pages */
  totalPages?: number;
}

export interface ProcessPermissionsDTO {
  canAddTalents?: boolean;
  canCancelProcess?: boolean;
  canChangeToComplete?: boolean;
  canChangeToOnHold?: boolean;
  canCopyLink?: boolean;
  canDownloadAdvancedExcelWithoutPersonalInfo?: boolean;
  canDownloadAdvancedExcelWithPersonalInfo?: boolean;
  canDownloadApplicationForm?: boolean;
  canDownloadBasicExcel?: boolean;
  canEnableDisableCamera?: boolean;
  canMakeDecision?: boolean;
  /** Whether the user may change test setup for the process. Always false when process.status is ACTIVE. */
  canManageTests?: boolean;
  canPublishProcess?: boolean;
  canRemoveTalents?: boolean;
  canSendInvitation?: boolean;
  canUpdateSettings?: boolean;
  canViewReportsPersonal?: boolean;
}

/**
 * Result type for this test
 */
export type ProcessTestSummaryDTOResultType =
  (typeof ProcessTestSummaryDTOResultType)[keyof typeof ProcessTestSummaryDTOResultType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTestSummaryDTOResultType = {
  evaluation: 'evaluation',
  score: 'score'
} as const;

/**
 * Summary information for a test in the process
 */
export interface ProcessTestSummaryDTO {
  /** Catalog item identifier (test ID) */
  catalogItemId: string;
  /** Test name */
  name: string;
  /**
   * Test order in the process
   * @minimum 1
   */
  order: number;
  /** Result type for this test */
  resultType: ProcessTestSummaryDTOResultType;
}

/**
 * Donut chart data series for test result visualization
 */
export interface DonutSeriesDTO {
  /** Hex colors for each segment (aligned with labels/values by index) */
  colors?: string[];
  /** Labels for each segment of the donut chart */
  labels: string[];
  /**
   * Number of talents missing results for this test
   * @minimum 0
   */
  missing?: number;
  /**
   * Total number of talents in the process
   * @minimum 0
   */
  total?: number;
  /** Values for each segment (aligned with labels by index) */
  values: number[];
}

/**
 * Per-test donut series for the 'Tests' tab, keyed by catalogItemId
 */
export type GetProcessStatsResponseDTOTestStats = { [key: string]: DonutSeriesDTO };

/**
 * Aggregated statistics for a process (right-side panel)
 */
export interface GetProcessStatsResponseDTO {
  /** Talent statistics grouped by status */
  talents: ProcessTalentStatsDTO;
  /** List of tests in the process with basic information */
  tests: ProcessTestSummaryDTO[];
  /** Per-test donut series for the 'Tests' tab, keyed by catalogItemId */
  testStats: GetProcessStatsResponseDTOTestStats;
}

export interface PreSignedUrlResponseDTO {
  presignedUrl?: string;
}

export interface ProcessTalentFilesResponseDTO {
  files?: FileMetadataDTO[];
}

export interface SuborganizationPermissionsDTO {
  canActivate?: boolean;
  canCreateFolders?: boolean;
  canCreateProcesses?: boolean;
  canDeactivate?: boolean;
  canDelete?: boolean;
  canHold?: boolean;
  canUpdateBasicInfo?: boolean;
  canUpdateIdentificationAndNorms?: boolean;
  canUpdateProcessSettingsAccessAndInvitation?: boolean;
  canUpdateProcessSettingsMessages?: boolean;
  canUpdateProcessSettingsTalentRegistration?: boolean;
  canUpdateProcessSettingsTestProperties?: boolean;
  canUpdateRolesAndUsers?: boolean;
  canViewBasicInfo?: boolean;
  canViewIdentificationAndNorms?: boolean;
  canViewProcessSettings?: boolean;
  canViewRolesAndUsers?: boolean;
}

export interface MiniTalent {
  /**
   * @minLength 0
   * @maxLength 50
   */
  firstName?: string;
  id?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  lastName?: string;
}

export type ProcessTalentResponseDTOTalentStatus =
  (typeof ProcessTalentResponseDTOTalentStatus)[keyof typeof ProcessTalentResponseDTOTalentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentResponseDTOTalentStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

export type ProcessTalentResponseDTOStatus =
  (typeof ProcessTalentResponseDTOStatus)[keyof typeof ProcessTalentResponseDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentResponseDTOStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED'
} as const;

export type ProcessTalentResponseDTOSendModesItem =
  (typeof ProcessTalentResponseDTOSendModesItem)[keyof typeof ProcessTalentResponseDTOSendModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentResponseDTOSendModesItem = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessTalentResponseDTOAccessModesItem =
  (typeof ProcessTalentResponseDTOAccessModesItem)[keyof typeof ProcessTalentResponseDTOAccessModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentResponseDTOAccessModesItem = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessTalentResponseDTO {
  accessModes?: ProcessTalentResponseDTOAccessModesItem[];
  assessmentType?: string;
  id?: string;
  location?: LocationDTO;
  name?: string;
  sendModes?: ProcessTalentResponseDTOSendModesItem[];
  status?: ProcessTalentResponseDTOStatus;
  talentStatus?: ProcessTalentResponseDTOTalentStatus;
  testSessionSummaries?: TestSessionSummaryDTO[];
}

export interface TalentProcessesResponseDTO {
  processes?: ProcessTalentResponseDTO[];
}

export interface TalentPermissionsDTO {
  canUpdate?: boolean;
}

export type TalentDTOType = (typeof TalentDTOType)[keyof typeof TalentDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentDTOType = {
  CANDIDATE: 'CANDIDATE',
  EMPLOYEE: 'EMPLOYEE'
} as const;

export type TalentDTOStatus = (typeof TalentDTOStatus)[keyof typeof TalentDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentDTOStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

export interface OrganizationShortDTO {
  name?: string;
  offices?: string[];
  slug?: string;
}

export interface LocationShortDTO {
  name?: string;
  slug?: string;
  suborganization?: SubOrganizationDTO;
  type?: string;
}

export interface TalentDTO {
  availability?: Availability;
  avatarUrl?: string;
  createdAt?: string;
  createdBy?: UserDTO;
  email?: string;
  firstName?: string;
  id?: string;
  idNumber?: string;
  lastActivity?: string;
  lastName?: string;
  locations?: LocationDTO[];
  locationsShort?: LocationShortDTO[];
  organization?: OrganizationShortDTO;
  passportNumber?: string;
  phone?: string;
  progress?: ProgressDTO;
  status?: TalentDTOStatus;
  supportedFiles?: TalentDTOSupportedFiles;
  type?: TalentDTOType;
  updatedAt?: string;
}

export interface FileMetadataDTO {
  fileName?: string;
  id?: string;
  isReadOnly?: boolean;
}

export type TalentDTOSupportedFiles = { [key: string]: FileMetadataDTO[] };

export type ReportTemplate = (typeof ReportTemplate)[keyof typeof ReportTemplate];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportTemplate = {
  integritest: 'integritest',
  trustee: 'trustee',
  extension: 'extension',
  knowledge: 'knowledge'
} as const;

export type ReportLocale = (typeof ReportLocale)[keyof typeof ReportLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export interface Report {
  locale?: ReportLocale;
  report?: ReportDataDTO;
  template?: ReportTemplate;
}

export interface Scale {
  color?: string;
  from?: number;
  to?: number;
}

export interface RegisteredBy {
  email?: string;
}

export interface TestSession {
  endDate?: string;
  enteredFrom?: string;
  isAiAnalysisEnabled?: boolean;
  linkSentAt?: string;
  locale?: string;
  registeredBy?: RegisteredBy;
  registrationDate?: string;
  registrationFrom?: string;
  startDate?: string;
}

export interface RecommendedQuestion {
  label?: string;
}

export interface Question {
  answer?: string;
  clarificationQuestion?: string;
  comment?: string;
  commentDeclined?: boolean;
  icon?: string;
  label?: string;
  responseTime?: number;
  translatedComment?: string;
}

export interface QuestionBlockDTO {
  description?: string;
  questions?: Question[];
  title?: string;
}

export interface Process {
  name?: string;
}

export interface OverallScore {
  description?: string;
  scales?: Scale[];
  value?: number;
}

export interface MoreInfo {
  label?: string;
  value?: string;
}

export interface Invite {
  sentDate?: string;
}

export interface Category {
  iconUrl?: string;
  name?: string;
}

export interface CatalogItem {
  category?: Category;
  name?: string;
  type?: string;
}

export interface Anchors {
  left?: string;
  right?: string;
}

export interface CompetencyScore {
  anchors?: Anchors;
  cutOff?: number;
  description?: string;
  scales?: Scale[];
  title?: string;
  value?: number;
}

export type WebcamDataAiViolation = (typeof WebcamDataAiViolation)[keyof typeof WebcamDataAiViolation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebcamDataAiViolation = {
  NO_FACE_DETECTED: 'NO_FACE_DETECTED',
  MORE_THAN_ONE_FACE_DETECTED: 'MORE_THAN_ONE_FACE_DETECTED',
  FACE_DIFFERENT_FROM_PROFILE: 'FACE_DIFFERENT_FROM_PROFILE'
} as const;

export interface WebcamData {
  aiViolation?: WebcamDataAiViolation;
  imageUrl?: string;
  timestamp?: string;
}

export interface ReportDataDTO {
  catalogItem?: CatalogItem;
  competencyScores?: CompetencyScore[];
  extendedQuestionBlocks?: QuestionBlockDTO[];
  invite?: Invite;
  moreInfo?: MoreInfo[];
  organization?: Organization;
  overallScore?: OverallScore;
  process?: Process;
  questionBlocks?: QuestionBlockDTO[];
  recommendedFollowUpQuestions?: RecommendedQuestion[];
  talent?: TalentInfo;
  test?: TestInfo;
  testSession?: TestSession;
  webcamData?: WebcamData[];
}

export interface TestSessionFeaturedWebcamCapturesDto {
  featuredCaptures?: WebcamData[];
}

export interface WebcamSettingsInfo {
  captureFrequencySeconds?: number;
  isAiAnalysisEnabled?: boolean;
  isEnabled?: boolean;
  isMandatory?: boolean;
}

export type TestSessionDetailDTOStatusUpdates = { [key: string]: string };

export type TestSessionDetailDTOStatus = (typeof TestSessionDetailDTOStatus)[keyof typeof TestSessionDetailDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSessionDetailDTOStatus = {
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  REFUSED: 'REFUSED'
} as const;

export type TestSessionDetailDTOLocale = (typeof TestSessionDetailDTOLocale)[keyof typeof TestSessionDetailDTOLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSessionDetailDTOLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type TestSessionDetailDTOAiAnalysisStatus =
  (typeof TestSessionDetailDTOAiAnalysisStatus)[keyof typeof TestSessionDetailDTOAiAnalysisStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSessionDetailDTOAiAnalysisStatus = {
  FAIL: 'FAIL',
  PASS: 'PASS',
  INSPECTION_NEEDED: 'INSPECTION_NEEDED'
} as const;

export interface TestInfo {
  hiringDecision?: string;
  name?: string;
}

export interface TalentInfo {
  avatarUrl?: string;
  email?: string;
  firstName?: string;
  idNumber?: string;
  lastName?: string;
  phone?: string;
}

export interface SettingsInfo {
  isClarificationQuestionsEnabled?: boolean;
  webcamSettings?: WebcamSettingsInfo;
}

export interface TestSessionDetailDTO {
  aiAnalysisStatus?: TestSessionDetailDTOAiAnalysisStatus;
  catalogItem?: CatalogItemInfo;
  endDate?: string;
  evaluation?: string;
  id?: string;
  invite?: InviteInfo;
  isRetest?: boolean;
  locale?: TestSessionDetailDTOLocale;
  process?: ProcessInfo;
  score?: number;
  settings?: SettingsInfo;
  startDate?: string;
  status?: TestSessionDetailDTOStatus;
  statusUpdates?: TestSessionDetailDTOStatusUpdates;
  talent?: TalentInfo;
  test?: TestInfo;
  updatedAt?: string;
}

export type ProcessInfoStatus = (typeof ProcessInfoStatus)[keyof typeof ProcessInfoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessInfoStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED'
} as const;

export interface ProcessInfo {
  id?: string;
  name?: string;
  status?: ProcessInfoStatus;
}

export type InviteInfoSendMode = (typeof InviteInfoSendMode)[keyof typeof InviteInfoSendMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InviteInfoSendMode = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type InviteInfoAccessMode = (typeof InviteInfoAccessMode)[keyof typeof InviteInfoAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InviteInfoAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface InviteInfo {
  accessMode?: InviteInfoAccessMode;
  createdAt?: string;
  sendMode?: InviteInfoSendMode;
}

export interface CatalogItemInfo {
  id?: string;
  name?: string;
}

/**
 * Pagination metadata
 */
export interface PagedMetadata {
  /** Current page number */
  page?: number;
  /** Number of items per page */
  size?: number;
  /** Total number of items */
  total?: number;
  /** Total number of pages */
  totalPages?: number;
}

/**
 * Response containing test type norms with pagination metadata
 */
export interface GetTestTypeNormsResponseDto {
  /** List of norms */
  norms?: NormDTO[];
  /** Pagination metadata */
  pagination?: PagedMetadata;
}

/**
 * Role information
 */
export interface RoleInfoDTO {
  /** Role ID */
  id?: string;
  /** Role name */
  name?: string;
}

/**
 * Organization information
 */
export interface OrganizationInfoDTO {
  /** Organization avatar URL */
  avatarUrl?: string;
  /** Organization ID */
  id?: string;
  /** Organization name */
  name?: string;
  /** Organization slug */
  slug?: string;
}

/**
 * Location role assignment summary
 */
export interface LocationRoleAssignmentSummaryDTO {
  /** Location name */
  name?: string;
  /** Role information */
  role?: RoleInfoDTO;
  /** Location slug */
  slug?: string;
  /** Location type (folder or suborganization) */
  type?: string;
}

/**
 * User who created the account
 */
export interface CreatedByUserDTO {
  /** Avatar URL */
  avatarUrl?: string;
  /** First name */
  firstName?: string;
  /** User ID */
  id?: string;
  /** Last name */
  lastName?: string;
}

/**
 * User organization assignment information
 */
export interface UserOrganizationAssignmentDTO {
  /** User's avatar URL */
  avatarUrl?: string;
  /** Assignment creation timestamp */
  createdAt?: string;
  /** User who created this assignment */
  createdBy?: CreatedByUserDTO;
  /** User's email address */
  email?: string;
  /** User's first name */
  firstName?: string;
  /** User's full name */
  fullName?: string;
  /** User's job title */
  jobTitle?: string;
  /** Last login timestamp */
  lastLoginAt?: string;
  /** User's last name */
  lastName?: string;
  /** Count of location role assignments */
  locationRoleAssignmentsCount?: number;
  /** Summary of first three location role assignments */
  locationRoleAssignmentsSummary?: LocationRoleAssignmentSummaryDTO[];
  /** Organization information */
  organization?: OrganizationInfoDTO;
  /** User's phone number */
  phone?: string;
  /** User's status */
  status?: string;
  /** User ID */
  userId?: string;
}

/**
 * Response containing user organization assignments with pagination metadata
 */
export interface UserOrganizationAssignmentsResponseDTO {
  /** Whether this is the first page */
  first?: boolean;
  /** Whether this is the last page */
  last?: boolean;
  /** Number of elements in current page */
  numberOfElements?: number;
  /** Current page number (0-based) */
  page?: number;
  /** Number of items per page */
  size?: number;
  /** Total number of items */
  total?: number;
  /** Total number of pages */
  totalPages?: number;
  /** List of user organization assignments */
  userOrganizationAssignments?: UserOrganizationAssignmentDTO[];
}

export interface UserSummaryDTO {
  avatarUrl?: string;
  email?: string;
  fullName?: string;
  id?: string;
}

export interface AutocompleteUsersResponseDto {
  page?: number;
  total?: number;
  userSummaries?: UserSummaryDTO[];
}

/**
 * Minimal organization card for membership surfaces
 */
export interface UserOrganizationCardDto {
  admin?: boolean;
  /** Organization avatar URL */
  avatarUrl?: string;
  /** Organization ID */
  id?: string;
  /** Organization name */
  name?: string;
  /** Organization slug */
  slug?: string;
}

/**
 * Response containing user's organization memberships
 */
export interface GetUserOrganizationsResponseDto {
  /** List of organizations the user is a member of */
  organizations?: UserOrganizationCardDto[];
}

export interface UserPermissionsDTO {
  canUpdate?: boolean;
}

export interface UserLocationRoleAssignmentsResponse {
  hasNext?: boolean;
  hasPrevious?: boolean;
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
  userLocationRoleAssignments?: UserLocationRoleAssignmentDto[];
}

export interface RoleInfoDto {
  id?: string;
  name?: string;
}

export interface OrganizationInfoDto {
  avatarUrl?: string;
  id?: string;
  name?: string;
  slug?: string;
}

export interface LocationInfoDto {
  id?: string;
  name?: string;
  slug?: string;
  type?: string;
}

export interface UserLocationRoleAssignmentDto {
  id?: string;
  location?: LocationInfoDto;
  organization?: OrganizationInfoDto;
  roles?: RoleInfoDto[];
}

/**
 * User permission key
 */
export type PermissionEnumsDtoUserPermissionKey =
  (typeof PermissionEnumsDtoUserPermissionKey)[keyof typeof PermissionEnumsDtoUserPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoUserPermissionKey = {
  UsercanUpdate: 'User.canUpdate'
} as const;

/**
 * Talent permission key
 */
export type PermissionEnumsDtoTalentPermissionKey =
  (typeof PermissionEnumsDtoTalentPermissionKey)[keyof typeof PermissionEnumsDtoTalentPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoTalentPermissionKey = {
  TalentcanUpdate: 'Talent.canUpdate'
} as const;

/**
 * Suborganization permission key
 */
export type PermissionEnumsDtoSuborganizationPermissionKey =
  (typeof PermissionEnumsDtoSuborganizationPermissionKey)[keyof typeof PermissionEnumsDtoSuborganizationPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoSuborganizationPermissionKey = {
  SuborganizationcanViewProcessSettings: 'Suborganization.canViewProcessSettings',
  SuborganizationcanUpdateProcessSettingsAccessAndInvitation:
    'Suborganization.canUpdateProcessSettingsAccessAndInvitation',
  SuborganizationcanUpdateProcessSettingsTestProperties: 'Suborganization.canUpdateProcessSettingsTestProperties',
  SuborganizationcanUpdateProcessSettingsTalentRegistration:
    'Suborganization.canUpdateProcessSettingsTalentRegistration',
  SuborganizationcanUpdateProcessSettingsMessages: 'Suborganization.canUpdateProcessSettingsMessages',
  SuborganizationcanDeactivate: 'Suborganization.canDeactivate',
  SuborganizationcanDelete: 'Suborganization.canDelete',
  SuborganizationcanHold: 'Suborganization.canHold',
  SuborganizationcanActivate: 'Suborganization.canActivate',
  SuborganizationcanViewIdentificationAndNorms: 'Suborganization.canViewIdentificationAndNorms',
  SuborganizationcanUpdateIdentificationAndNorms: 'Suborganization.canUpdateIdentificationAndNorms',
  SuborganizationcanCreateFolders: 'Suborganization.canCreateFolders',
  SuborganizationcanCreateProcesses: 'Suborganization.canCreateProcesses',
  SuborganizationcanViewBasicInfo: 'Suborganization.canViewBasicInfo',
  SuborganizationcanUpdateBasicInfo: 'Suborganization.canUpdateBasicInfo',
  SuborganizationcanViewRolesAndUsers: 'Suborganization.canViewRolesAndUsers',
  SuborganizationcanUpdateRolesAndUsers: 'Suborganization.canUpdateRolesAndUsers'
} as const;

/**
 * Subfolder permission key
 */
export type PermissionEnumsDtoSubfolderPermissionKey =
  (typeof PermissionEnumsDtoSubfolderPermissionKey)[keyof typeof PermissionEnumsDtoSubfolderPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoSubfolderPermissionKey = {
  SubfoldercanViewBasicInfo: 'Subfolder.canViewBasicInfo',
  SubfoldercanUpdateBasicInfo: 'Subfolder.canUpdateBasicInfo'
} as const;

/**
 * Process permission key
 */
export type PermissionEnumsDtoProcessPermissionKey =
  (typeof PermissionEnumsDtoProcessPermissionKey)[keyof typeof PermissionEnumsDtoProcessPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoProcessPermissionKey = {
  ProcesscanUpdateSettings: 'Process.canUpdateSettings',
  ProcesscanManageTests: 'Process.canManageTests',
  ProcesscanCancelProcess: 'Process.canCancelProcess',
  ProcesscanAddTalents: 'Process.canAddTalents',
  ProcesscanRemoveTalents: 'Process.canRemoveTalents',
  ProcesscanSendInvitation: 'Process.canSendInvitation'
} as const;

/**
 * Platform permission key
 */
export type PermissionEnumsDtoPlatformPermissionKey =
  (typeof PermissionEnumsDtoPlatformPermissionKey)[keyof typeof PermissionEnumsDtoPlatformPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoPlatformPermissionKey = {
  PlatformcanCreateOrganizations: 'Platform.canCreateOrganizations',
  PlatformcanCreateClientUsers: 'Platform.canCreateClientUsers',
  PlatformcanCreateMidotUsers: 'Platform.canCreateMidotUsers',
  PlatformcanAssignMidotRoles: 'Platform.canAssignMidotRoles'
} as const;

/**
 * Organization permission key
 */
export type PermissionEnumsDtoOrganizationPermissionKey =
  (typeof PermissionEnumsDtoOrganizationPermissionKey)[keyof typeof PermissionEnumsDtoOrganizationPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoOrganizationPermissionKey = {
  OrganizationcanViewProcessSettings: 'Organization.canViewProcessSettings',
  OrganizationcanUpdateProcessSettingsAccessAndInvitation: 'Organization.canUpdateProcessSettingsAccessAndInvitation',
  OrganizationcanUpdateProcessSettingsTestProperties: 'Organization.canUpdateProcessSettingsTestProperties',
  OrganizationcanUpdateProcessSettingsTalentRegistration: 'Organization.canUpdateProcessSettingsTalentRegistration',
  OrganizationcanUpdateProcessSettingsMessages: 'Organization.canUpdateProcessSettingsMessages',
  OrganizationcanDeactivate: 'Organization.canDeactivate',
  OrganizationcanDelete: 'Organization.canDelete',
  OrganizationcanHold: 'Organization.canHold',
  OrganizationcanActivate: 'Organization.canActivate',
  OrganizationcanCreateSuborganizations: 'Organization.canCreateSuborganizations',
  OrganizationcanViewIdentificationAndNorms: 'Organization.canViewIdentificationAndNorms',
  OrganizationcanUpdateIdentificationAndNorms: 'Organization.canUpdateIdentificationAndNorms',
  OrganizationcanCreateFolders: 'Organization.canCreateFolders',
  OrganizationcanCreateProcesses: 'Organization.canCreateProcesses',
  OrganizationcanCreateTalents: 'Organization.canCreateTalents',
  OrganizationcanViewBasicInfo: 'Organization.canViewBasicInfo',
  OrganizationcanUpdateBasicInfo: 'Organization.canUpdateBasicInfo',
  OrganizationcanViewRolesAndUsers: 'Organization.canViewRolesAndUsers',
  OrganizationcanUpdateRolesAndUsers: 'Organization.canUpdateRolesAndUsers',
  OrganizationcanInviteUsers: 'Organization.canInviteUsers'
} as const;

/**
 * Folder permission key
 */
export type PermissionEnumsDtoFolderPermissionKey =
  (typeof PermissionEnumsDtoFolderPermissionKey)[keyof typeof PermissionEnumsDtoFolderPermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionEnumsDtoFolderPermissionKey = {
  FoldercanCreateSubfolders: 'Folder.canCreateSubfolders',
  FoldercanCreateProcesses: 'Folder.canCreateProcesses',
  FoldercanCreateTalents: 'Folder.canCreateTalents',
  FoldercanUpdateBasicInfo: 'Folder.canUpdateBasicInfo',
  FoldercanViewBasicInfo: 'Folder.canViewBasicInfo',
  FoldercanViewRolesAndUsers: 'Folder.canViewRolesAndUsers',
  FoldercanUpdateRolesAndUsers: 'Folder.canUpdateRolesAndUsers'
} as const;

/**
 * Permission key enums reference - ensures enum schemas appear as separate components
 */
export interface PermissionEnumsDto {
  /** Folder permission key */
  folderPermissionKey?: PermissionEnumsDtoFolderPermissionKey;
  /** Organization permission key */
  organizationPermissionKey?: PermissionEnumsDtoOrganizationPermissionKey;
  /** Platform permission key */
  platformPermissionKey?: PermissionEnumsDtoPlatformPermissionKey;
  /** Process permission key */
  processPermissionKey?: PermissionEnumsDtoProcessPermissionKey;
  /** Subfolder permission key */
  subfolderPermissionKey?: PermissionEnumsDtoSubfolderPermissionKey;
  /** Suborganization permission key */
  suborganizationPermissionKey?: PermissionEnumsDtoSuborganizationPermissionKey;
  /** Talent permission key */
  talentPermissionKey?: PermissionEnumsDtoTalentPermissionKey;
  /** User permission key */
  userPermissionKey?: PermissionEnumsDtoUserPermissionKey;
}

/**
 * User-level permission keys
 */
export type PermissionKeysDtoUserPermissions =
  (typeof PermissionKeysDtoUserPermissions)[keyof typeof PermissionKeysDtoUserPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoUserPermissions = {
  UsercanUpdate: 'User.canUpdate'
} as const;

/**
 * Talent-level permission keys
 */
export type PermissionKeysDtoTalentPermissions =
  (typeof PermissionKeysDtoTalentPermissions)[keyof typeof PermissionKeysDtoTalentPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoTalentPermissions = {
  TalentcanUpdate: 'Talent.canUpdate'
} as const;

/**
 * Suborganization-level permission keys
 */
export type PermissionKeysDtoSuborganizationPermissions =
  (typeof PermissionKeysDtoSuborganizationPermissions)[keyof typeof PermissionKeysDtoSuborganizationPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoSuborganizationPermissions = {
  SuborganizationcanViewProcessSettings: 'Suborganization.canViewProcessSettings',
  SuborganizationcanUpdateProcessSettingsAccessAndInvitation:
    'Suborganization.canUpdateProcessSettingsAccessAndInvitation',
  SuborganizationcanUpdateProcessSettingsTestProperties: 'Suborganization.canUpdateProcessSettingsTestProperties',
  SuborganizationcanUpdateProcessSettingsTalentRegistration:
    'Suborganization.canUpdateProcessSettingsTalentRegistration',
  SuborganizationcanUpdateProcessSettingsMessages: 'Suborganization.canUpdateProcessSettingsMessages',
  SuborganizationcanDeactivate: 'Suborganization.canDeactivate',
  SuborganizationcanDelete: 'Suborganization.canDelete',
  SuborganizationcanHold: 'Suborganization.canHold',
  SuborganizationcanActivate: 'Suborganization.canActivate',
  SuborganizationcanViewIdentificationAndNorms: 'Suborganization.canViewIdentificationAndNorms',
  SuborganizationcanUpdateIdentificationAndNorms: 'Suborganization.canUpdateIdentificationAndNorms',
  SuborganizationcanCreateFolders: 'Suborganization.canCreateFolders',
  SuborganizationcanCreateProcesses: 'Suborganization.canCreateProcesses',
  SuborganizationcanViewBasicInfo: 'Suborganization.canViewBasicInfo',
  SuborganizationcanUpdateBasicInfo: 'Suborganization.canUpdateBasicInfo',
  SuborganizationcanViewRolesAndUsers: 'Suborganization.canViewRolesAndUsers',
  SuborganizationcanUpdateRolesAndUsers: 'Suborganization.canUpdateRolesAndUsers'
} as const;

/**
 * Subfolder-level permission keys
 */
export type PermissionKeysDtoSubfolderPermissions =
  (typeof PermissionKeysDtoSubfolderPermissions)[keyof typeof PermissionKeysDtoSubfolderPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoSubfolderPermissions = {
  SubfoldercanViewBasicInfo: 'Subfolder.canViewBasicInfo',
  SubfoldercanUpdateBasicInfo: 'Subfolder.canUpdateBasicInfo'
} as const;

/**
 * Process-level permission keys
 */
export type PermissionKeysDtoProcessPermissions =
  (typeof PermissionKeysDtoProcessPermissions)[keyof typeof PermissionKeysDtoProcessPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoProcessPermissions = {
  ProcesscanUpdateSettings: 'Process.canUpdateSettings',
  ProcesscanManageTests: 'Process.canManageTests',
  ProcesscanCancelProcess: 'Process.canCancelProcess',
  ProcesscanAddTalents: 'Process.canAddTalents',
  ProcesscanRemoveTalents: 'Process.canRemoveTalents',
  ProcesscanSendInvitation: 'Process.canSendInvitation'
} as const;

/**
 * Platform-level permission keys
 */
export type PermissionKeysDtoPlatformPermissions =
  (typeof PermissionKeysDtoPlatformPermissions)[keyof typeof PermissionKeysDtoPlatformPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoPlatformPermissions = {
  PlatformcanCreateOrganizations: 'Platform.canCreateOrganizations',
  PlatformcanCreateClientUsers: 'Platform.canCreateClientUsers',
  PlatformcanCreateMidotUsers: 'Platform.canCreateMidotUsers',
  PlatformcanAssignMidotRoles: 'Platform.canAssignMidotRoles'
} as const;

/**
 * Organization-level permission keys
 */
export type PermissionKeysDtoOrganizationPermissions =
  (typeof PermissionKeysDtoOrganizationPermissions)[keyof typeof PermissionKeysDtoOrganizationPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoOrganizationPermissions = {
  OrganizationcanViewProcessSettings: 'Organization.canViewProcessSettings',
  OrganizationcanUpdateProcessSettingsAccessAndInvitation: 'Organization.canUpdateProcessSettingsAccessAndInvitation',
  OrganizationcanUpdateProcessSettingsTestProperties: 'Organization.canUpdateProcessSettingsTestProperties',
  OrganizationcanUpdateProcessSettingsTalentRegistration: 'Organization.canUpdateProcessSettingsTalentRegistration',
  OrganizationcanUpdateProcessSettingsMessages: 'Organization.canUpdateProcessSettingsMessages',
  OrganizationcanDeactivate: 'Organization.canDeactivate',
  OrganizationcanDelete: 'Organization.canDelete',
  OrganizationcanHold: 'Organization.canHold',
  OrganizationcanActivate: 'Organization.canActivate',
  OrganizationcanCreateSuborganizations: 'Organization.canCreateSuborganizations',
  OrganizationcanViewIdentificationAndNorms: 'Organization.canViewIdentificationAndNorms',
  OrganizationcanUpdateIdentificationAndNorms: 'Organization.canUpdateIdentificationAndNorms',
  OrganizationcanCreateFolders: 'Organization.canCreateFolders',
  OrganizationcanCreateProcesses: 'Organization.canCreateProcesses',
  OrganizationcanCreateTalents: 'Organization.canCreateTalents',
  OrganizationcanViewBasicInfo: 'Organization.canViewBasicInfo',
  OrganizationcanUpdateBasicInfo: 'Organization.canUpdateBasicInfo',
  OrganizationcanViewRolesAndUsers: 'Organization.canViewRolesAndUsers',
  OrganizationcanUpdateRolesAndUsers: 'Organization.canUpdateRolesAndUsers',
  OrganizationcanInviteUsers: 'Organization.canInviteUsers'
} as const;

/**
 * Folder-level permission keys
 */
export type PermissionKeysDtoFolderPermissions =
  (typeof PermissionKeysDtoFolderPermissions)[keyof typeof PermissionKeysDtoFolderPermissions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKeysDtoFolderPermissions = {
  FoldercanCreateSubfolders: 'Folder.canCreateSubfolders',
  FoldercanCreateProcesses: 'Folder.canCreateProcesses',
  FoldercanCreateTalents: 'Folder.canCreateTalents',
  FoldercanUpdateBasicInfo: 'Folder.canUpdateBasicInfo',
  FoldercanViewBasicInfo: 'Folder.canViewBasicInfo',
  FoldercanViewRolesAndUsers: 'Folder.canViewRolesAndUsers',
  FoldercanUpdateRolesAndUsers: 'Folder.canUpdateRolesAndUsers'
} as const;

/**
 * Permission keys reference - lists all available permission keys by type
 */
export interface PermissionKeysDto {
  /** Folder-level permission keys */
  folderPermissions?: PermissionKeysDtoFolderPermissions;
  /** Organization-level permission keys */
  organizationPermissions?: PermissionKeysDtoOrganizationPermissions;
  /** Platform-level permission keys */
  platformPermissions?: PermissionKeysDtoPlatformPermissions;
  /** Process-level permission keys */
  processPermissions?: PermissionKeysDtoProcessPermissions;
  /** Subfolder-level permission keys */
  subfolderPermissions?: PermissionKeysDtoSubfolderPermissions;
  /** Suborganization-level permission keys */
  suborganizationPermissions?: PermissionKeysDtoSuborganizationPermissions;
  /** Talent-level permission keys */
  talentPermissions?: PermissionKeysDtoTalentPermissions;
  /** User-level permission keys */
  userPermissions?: PermissionKeysDtoUserPermissions;
}

/**
 * Camera capture data transfer object containing capture information
 */
export interface CameraCaptureDTO {
  /** Timestamp when the capture was created */
  createdAt?: string;
  /** Whether a face was detected in the capture */
  isFaceDetected?: boolean;
  /** URL of the captured image */
  url?: string;
}

/**
 * Test data transfer object containing test information and metadata
 */
export interface TestDTO {
  /** Access key for the test session */
  accessKey?: string;
  aiCapture?: boolean;
  cameraCapture?: boolean;
  /** List of camera captures associated with this test */
  cameraCaptures?: CameraCaptureDTO[];
  /** Timestamp when the test was created */
  createdAt?: string;
  /** User who created the test */
  createdBy?: User;
  /** Test end date and time */
  endDate?: string;
  /** Test metadata in JSON format */
  metadata?: string;
  retest?: boolean;
  /** Test start date and time */
  startDate?: string;
  /** Timestamp indicating when the test data was last updated */
  upToDate?: string;
}

export type UpdateFolderParentDTOType = (typeof UpdateFolderParentDTOType)[keyof typeof UpdateFolderParentDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateFolderParentDTOType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export interface UpdateFolderParentDTO {
  slug?: string;
  type?: UpdateFolderParentDTOType;
}

export interface UpdateFolderRequestBody {
  legacyId?: string;
  name?: string;
  parent?: UpdateFolderParentDTO;
}

export type OrganizationUpdateRequestDTOUserInviteEmailLanguage =
  (typeof OrganizationUpdateRequestDTOUserInviteEmailLanguage)[keyof typeof OrganizationUpdateRequestDTOUserInviteEmailLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUpdateRequestDTOUserInviteEmailLanguage = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type OrganizationUpdateRequestDTOTalentUniqueFieldsItem =
  (typeof OrganizationUpdateRequestDTOTalentUniqueFieldsItem)[keyof typeof OrganizationUpdateRequestDTOTalentUniqueFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUpdateRequestDTOTalentUniqueFieldsItem = {
  ID_NUMBER: 'ID_NUMBER',
  PASSPORT_NUMBER: 'PASSPORT_NUMBER',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL'
} as const;

export type OrganizationUpdateRequestDTOTalentInviteEmailLanguage =
  (typeof OrganizationUpdateRequestDTOTalentInviteEmailLanguage)[keyof typeof OrganizationUpdateRequestDTOTalentInviteEmailLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUpdateRequestDTOTalentInviteEmailLanguage = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

/**
 * @pattern ^[a-z]{2}-[A-Z]{2}$
 */
export type OrganizationUpdateRequestDTOLocalesItem =
  (typeof OrganizationUpdateRequestDTOLocalesItem)[keyof typeof OrganizationUpdateRequestDTOLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUpdateRequestDTOLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type OrganizationUpdateRequestDTOEmployeeCount =
  (typeof OrganizationUpdateRequestDTOEmployeeCount)[keyof typeof OrganizationUpdateRequestDTOEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUpdateRequestDTOEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export type OrganizationUpdateRequestDTOAnonymizationPolicy =
  (typeof OrganizationUpdateRequestDTOAnonymizationPolicy)[keyof typeof OrganizationUpdateRequestDTOAnonymizationPolicy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUpdateRequestDTOAnonymizationPolicy = {
  DISABLED: 'DISABLED',
  INHERIT: 'INHERIT',
  CUSTOM: 'CUSTOM'
} as const;

export interface OrganizationUpdateRequestDTO {
  admins?: AdminDTO[];
  anonymizationDurationMonths?: number;
  anonymizationPolicy?: OrganizationUpdateRequestDTOAnonymizationPolicy;
  authConfig?: AuthConfigDTO;
  countries?: string[];
  employeeCount?: OrganizationUpdateRequestDTOEmployeeCount;
  idValidation?: IdValidationConfig;
  industry?: string;
  jiraId?: string;
  keyAccountManagers?: string[];
  legacyId?: string;
  legalName?: string;
  locales?: OrganizationUpdateRequestDTOLocalesItem[];
  name?: string;
  offices?: string[];
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  talentInviteEmailLanguage?: OrganizationUpdateRequestDTOTalentInviteEmailLanguage;
  talentUniqueFields?: OrganizationUpdateRequestDTOTalentUniqueFieldsItem[];
  testValidityDays?: number;
  userInviteEmailLanguage?: OrganizationUpdateRequestDTOUserInviteEmailLanguage;
}

export type AuthConfigDTOPreferredOtpMethod =
  (typeof AuthConfigDTOPreferredOtpMethod)[keyof typeof AuthConfigDTOPreferredOtpMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthConfigDTOPreferredOtpMethod = {
  whatsapp: 'whatsapp',
  phone: 'phone',
  email: 'email',
  auth: 'auth',
  none: 'none'
} as const;

export type AuthConfigDTOPreferredLoginMethod =
  (typeof AuthConfigDTOPreferredLoginMethod)[keyof typeof AuthConfigDTOPreferredLoginMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthConfigDTOPreferredLoginMethod = {
  sso: 'sso',
  outlook: 'outlook',
  passkey: 'passkey',
  magic: 'magic',
  microsoft: 'microsoft',
  google: 'google',
  none: 'none'
} as const;

export interface AuthConfigDTO {
  app?: boolean;
  call?: boolean;
  invalidateAfterDays?: number;
  passkey?: boolean;
  preferredLoginMethod?: AuthConfigDTOPreferredLoginMethod;
  preferredOtpMethod?: AuthConfigDTOPreferredOtpMethod;
  sms?: boolean;
  whatsapp?: boolean;
}

export type SuborganizationDTOStatus = (typeof SuborganizationDTOStatus)[keyof typeof SuborganizationDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuborganizationDTOStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export type SuborganizationDTOEmployeeCount =
  (typeof SuborganizationDTOEmployeeCount)[keyof typeof SuborganizationDTOEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuborganizationDTOEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface SuborganizationDTO {
  countries?: string[];
  createdAt?: string;
  createdBy?: UserDTO;
  employeeCount?: SuborganizationDTOEmployeeCount;
  id?: string;
  industry?: IndustryDTO;
  jiraId?: string;
  keyAccountManagers?: UserDTO[];
  legacyId?: string;
  legalName?: string;
  name?: string;
  norms?: OrganizationNormsResponse;
  offices?: string[];
  parent?: ParentStruct;
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  slug?: string;
  status?: SuborganizationDTOStatus;
  testValidityDays?: number;
  updatedAt?: string;
}

export type ParentStructType = (typeof ParentStructType)[keyof typeof ParentStructType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParentStructType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export interface ParentStruct {
  id?: string;
  name?: string;
  slug?: string;
  type?: ParentStructType;
}

export type UpdateSuborganizationRequestBodyUserInviteEmailLanguage =
  (typeof UpdateSuborganizationRequestBodyUserInviteEmailLanguage)[keyof typeof UpdateSuborganizationRequestBodyUserInviteEmailLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSuborganizationRequestBodyUserInviteEmailLanguage = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type UpdateSuborganizationRequestBodyLocalesItem =
  (typeof UpdateSuborganizationRequestBodyLocalesItem)[keyof typeof UpdateSuborganizationRequestBodyLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSuborganizationRequestBodyLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type UpdateSuborganizationRequestBodyEmployeeCount =
  (typeof UpdateSuborganizationRequestBodyEmployeeCount)[keyof typeof UpdateSuborganizationRequestBodyEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSuborganizationRequestBodyEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface UpdateSuborganizationRequestBody {
  admins?: string[];
  countries?: string[];
  employeeCount?: UpdateSuborganizationRequestBodyEmployeeCount;
  industry?: string;
  jiraId?: string;
  keyAccountManagers?: string[];
  legacyId?: string;
  legalName?: string;
  locales?: UpdateSuborganizationRequestBodyLocalesItem[];
  name?: string;
  norms?: NormsUpdateRequest;
  offices?: string[];
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  testValidityDays?: number;
  userInviteEmailLanguage?: UpdateSuborganizationRequestBodyUserInviteEmailLanguage;
}

export interface NormsUpdateItem {
  defaultNormId?: string;
  testName?: string;
  testTypeId?: string;
}

export interface NormsUpdateRequest {
  items?: NormsUpdateItem[];
}

export type ProcessUpdateDtoSendModesItem =
  (typeof ProcessUpdateDtoSendModesItem)[keyof typeof ProcessUpdateDtoSendModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessUpdateDtoSendModesItem = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessUpdateDtoDefaultLocale =
  (typeof ProcessUpdateDtoDefaultLocale)[keyof typeof ProcessUpdateDtoDefaultLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessUpdateDtoDefaultLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type ProcessUpdateDtoAssessmentType =
  (typeof ProcessUpdateDtoAssessmentType)[keyof typeof ProcessUpdateDtoAssessmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessUpdateDtoAssessmentType = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  ANY: 'ANY'
} as const;

export type ProcessUpdateDtoAccessModesItem =
  (typeof ProcessUpdateDtoAccessModesItem)[keyof typeof ProcessUpdateDtoAccessModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessUpdateDtoAccessModesItem = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessUpdateDto {
  accessModes?: ProcessUpdateDtoAccessModesItem[];
  assessmentType?: ProcessUpdateDtoAssessmentType;
  catalogItems?: string[];
  /**
   * @minimum 60
   * @maximum 129600
   */
  continueReminderMinutes?: number;
  createdBy?: string;
  defaultLocale?: ProcessUpdateDtoDefaultLocale;
  description?: string;
  /**
   * Deprecated — no longer used. Will be removed in a future version.
   * @deprecated
   */
  endDate?: string;
  location?: LocationUpdateDTO;
  name?: string;
  organization?: string;
  sendModes?: ProcessUpdateDtoSendModesItem[];
  /**
   * Deprecated — no longer used. Will be removed in a future version.
   * @deprecated
   */
  startDate?: string;
  /**
   * @minimum 60
   * @maximum 129600
   */
  startReminderMinutes?: number;
  testSettings?: TestSettings;
}

export interface UpdateProcessCatalogItemsResponse {
  catalogItems?: string[];
}

export interface UpdateProcessCatalogItemsRequest {
  catalogItems?: string[];
}

export type UpdateTalentRequestType = (typeof UpdateTalentRequestType)[keyof typeof UpdateTalentRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTalentRequestType = {
  CANDIDATE: 'CANDIDATE',
  EMPLOYEE: 'EMPLOYEE'
} as const;

export interface UpdateTalentRequest {
  availability?: Availability;
  avatarUrl?: string;
  email?: string;
  firstName?: string;
  idNumber?: string;
  labelSlug?: string;
  lastName?: string;
  organizationSlug?: string;
  passportNumber?: string;
  phone?: string;
  type?: UpdateTalentRequestType;
}

export interface UpdateUserOfficesRequest {
  /** @minItems 1 */
  offices: string[];
}

export interface UpdateUserDTO {
  fullName?: string;
  jobTitle?: string;
  legacyId?: string;
  /** @pattern ^(MM/DD/YYYY|DD/MM/YYYY|YYYY-MM-DD|YYYY/MM/DD)$ */
  preferredDateFormat?: string;
  /** @pattern ^[a-z]{2}-[A-Z]{2}$ */
  preferredLocale?: string;
  /** @pattern ^(UTC|[A-Za-z_]+/[A-Za-z_]+)$ */
  preferredTimezone?: string;
}

export interface CreateApiKeyRequest {
  description?: string;
  name?: string;
  role?: string;
}

export interface ApiKeyValidateRequest {
  apiKey?: string;
}

export interface EmailRequest {
  email?: string;
}

export interface TokenRequest {
  refreshToken?: string;
  sessionToken?: string;
}

export interface SelectedItem {
  bpId?: number;
  itemId?: string;
  name?: string;
  testType?: string;
}

export interface CatalogRefinementResponse {
  contextRefinedCatalogIds?: string[];
  finalBpId?: string;
  refinedCatalogId?: string;
  refinement?: Refinement;
  selectedItems?: SelectedItem[];
  testType?: string;
}

/**
 * The locale/language for the catalog. Must match supported LanguageEnum values.
 */
export type CatalogRefinementRequestLocale =
  (typeof CatalogRefinementRequestLocale)[keyof typeof CatalogRefinementRequestLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CatalogRefinementRequestLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export interface CatalogRefinementRequest {
  /**
   * The ID of the catalog to refine
   * @minLength 1
   */
  catalogId: string;
  /** Catalog IDs already refined in this context (e.g. path of refinement steps) */
  contextRefinedCatalogIds?: string[];
  /** The locale/language for the catalog. Must match supported LanguageEnum values. */
  locale: CatalogRefinementRequestLocale;
  /** List of refinement criteria */
  refinements: RefinementRequest[];
}

export interface JwtValidateRequest {
  jwt?: string;
}

/**
 * The access mode for the invitation
 */
export type CreateInvitationRequestAccessMode =
  (typeof CreateInvitationRequestAccessMode)[keyof typeof CreateInvitationRequestAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInvitationRequestAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

/**
 * Request DTO for creating a new invitation
 */
export interface CreateInvitationRequest {
  /** The access mode for the invitation */
  accessMode: CreateInvitationRequestAccessMode;
  /**
   * The ID of the process for the invitation
   * @minLength 1
   */
  processId: string;
  /**
   * The ID of the talent being invited
   * @minLength 1
   */
  talentId: string;
}

/**
 * The access mode for the invitation
 */
export type CreateInvitationResponseAccessMode =
  (typeof CreateInvitationResponseAccessMode)[keyof typeof CreateInvitationResponseAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInvitationResponseAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface CatalogItemDTO {
  bpId?: string;
  catalogItemId?: string;
  extensions?: number[];
  isExtension?: boolean;
  language?: string;
  name?: string;
  normId?: string;
  testType?: string;
}

/**
 * Response DTO for created invitation
 */
export interface CreateInvitationResponse {
  /** The access mode for the invitation */
  accessMode?: CreateInvitationResponseAccessMode;
  /** List of catalog items */
  catalogItems?: CatalogItemDTO[];
  /** When the invitation was created */
  createdAt?: string;
  /** When the invitation expires */
  expiresAt?: string;
  /** The unique ID of the created invitation */
  id?: string;
  /** The ID of the process for the invitation */
  processId?: string;
  /** The ID of the talent being invited */
  talentId?: string;
}

/**
 * Response for Midot user assignments
 */
export interface MidotUserAssignmentResponse {
  /** Unique identifier for this batch of assignments */
  batchId?: string;
  /** Number of existing users to be updated */
  existingUsersCount?: number;
  /** List of email addresses that were ignored due to unauthorized domains */
  ignoredEmails?: string[];
  /** Status message */
  message?: string;
  /** Number of new users to be invited */
  newUsersCount?: number;
  /** Timestamp when the processing started */
  processedAt?: string;
  /** Total number of assignments being processed */
  totalAssignments?: number;
}

/**
 * User identifier - either by ID or email
 */
export interface UserIdentifier {
  /** User's email address. Required for new users. Must be from an authorized Midot domain. */
  email?: string;
  /**
   * User's ID. Optional, used to identify existing users.
   * @pattern ^[a-f0-9]{24}$
   */
  id?: string;
  /** Optional phone number in international format (any format accepted, validated by service) */
  phone?: string;
}

/**
 * Single assignment containing users and their roles/offices
 */
export interface MidotAssignment {
  /**
   * List of office slugs to assign
   * @minItems 1
   */
  offices: string[];
  /**
   * List of role IDs to assign
   * @minItems 1
   */
  roleIds: string[];
  /**
   * List of users to assign roles and offices to
   * @minItems 1
   */
  users: UserIdentifier[];
}

/**
 * Request to assign roles and offices to Midot users
 */
export interface MidotUserAssignmentRequest {
  /**
   * List of assignments to process
   * @minItems 1
   */
  midotAssignments: MidotAssignment[];
}

export interface ProgressDTO {
  /** Completed */
  completed?: number;
  /** Total */
  total?: number;
}

export type OrganizationFilterDTOStatusItem =
  (typeof OrganizationFilterDTOStatusItem)[keyof typeof OrganizationFilterDTOStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationFilterDTOStatusItem = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export interface OrganizationFilterDTO {
  createdAt?: DateRangeDTO;
  createdBy?: string[];
  industry?: string[];
  lastActivity?: DateRangeDTO;
  office?: string;
  search?: string;
  status?: OrganizationFilterDTOStatusItem[];
}

export interface OrganizationRequestDTO {
  /** Filters for organizations */
  organization?: OrganizationFilterDTO;
  /** Page number */
  page?: number;
  /** Progress-related filtering criteria */
  process?: ProgressDTO;
  /** Page size */
  size?: number;
  /** Property to sort by */
  sortBy?: string;
  /** Sort direction (asc/desc) */
  sortDirection?: string;
}

export interface CreateFolderRequestBody {
  legacyId?: string;
  name?: string;
  parent?: ParentInfo;
}

/**
 * Validation constraints. Only populated fields are returned.
 */
export interface TalentQuestionValidationDTO {
  /** Allowed file extensions for file upload questions */
  allowedFileExtensions?: string[];
  /** Maximum value or length */
  max?: number;
  /** Maximum file size for file upload questions */
  maxFileSize?: number;
  /** Minimum value or length */
  min?: number;
  /** Pattern for validation */
  pattern?: string;
  /** Validation rule type, e.g., Alphanumeric */
  rule?: string;
}

/**
 * Map of option values and their labels in the specified language
 */
export type QuestionTranslationDTOOptionLabels = { [key: string]: string };

export interface QuestionTranslationDTO {
  /** Label of the question in the specified language */
  label?: string;
  /** Map of option values and their labels in the specified language */
  optionLabels?: QuestionTranslationDTOOptionLabels;
}

export type TalentQuestionsResponseDTOTranslations = { [key: string]: { [key: string]: QuestionTranslationDTO } };

/**
 * Type of the talent question
 */
export type FullTalentQuestionDTOType = (typeof FullTalentQuestionDTOType)[keyof typeof FullTalentQuestionDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullTalentQuestionDTOType = {
  TEXT: 'TEXT',
  LONG_TEXT: 'LONG_TEXT',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  SELECT: 'SELECT',
  YEAR: 'YEAR'
} as const;

export interface FullTalentQuestionDTO {
  /** Unique identifier for the talent question */
  id?: string;
  /** Type of the talent identity */
  identityType?: FullTalentQuestionDTOIdentityType;
  /** Indicates if the question is active */
  isActive?: boolean;
  /** Indicates if the question is a knockout question */
  isKnockout?: boolean;
  /** Indicates if the question is required */
  isRequired?: boolean;
  /** Indicates if the question is editable by talent */
  isTalentEditable?: boolean;
  /** List of option values for the question */
  optionValues?: string[];
  /** Type of the talent question */
  type?: FullTalentQuestionDTOType;
  /** Optional validation rules. Omitted when not configured. */
  validation?: TalentQuestionValidationDTO;
}

export interface TalentQuestionsResponseDTO {
  external?: FullTalentQuestionDTO[];
  internal?: FullTalentQuestionDTO[];
  translations?: TalentQuestionsResponseDTOTranslations;
}

/**
 * Type of the talent identity
 */
export type FullTalentQuestionDTOIdentityType =
  (typeof FullTalentQuestionDTOIdentityType)[keyof typeof FullTalentQuestionDTOIdentityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullTalentQuestionDTOIdentityType = {
  ID_NUMBER: 'ID_NUMBER',
  PASSPORT_NUMBER: 'PASSPORT_NUMBER',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL'
} as const;

/**
 * Organization information for talent response
 */
export interface TalentOrganizationInfoDTO {
  /** Organization ID */
  id?: string;
  /** Organization name */
  name?: string;
  /** Organization slug */
  slug?: string;
}

/**
 * Talent type
 */
export type PostTalentsResponseType = (typeof PostTalentsResponseType)[keyof typeof PostTalentsResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostTalentsResponseType = {
  CANDIDATE: 'CANDIDATE',
  EMPLOYEE: 'EMPLOYEE'
} as const;

/**
 * Response DTO for talent creation
 */
export interface PostTalentsResponse {
  /** Email address */
  email?: string;
  /** First name */
  firstName?: string;
  /** Talent ID */
  id?: string;
  /** Identification number */
  idNumber?: string;
  /** Access key for the new unique link invitation */
  invitationAccessKey?: string;
  /** Full URL for the new unique link invitation */
  invitationUrl?: string;
  /** Last name */
  lastName?: string;
  /** Locations where the talent is available */
  locations?: LocationDTO[];
  /** Organization information */
  organization?: TalentOrganizationInfoDTO;
  /** Passport number */
  passportNumber?: string;
  /** Phone number */
  phone?: string;
  /** Podium-side ProcessInvitation ID created during registration */
  podiumInvitationId?: string;
  /** Talent type */
  type?: PostTalentsResponseType;
}

export type FolderDTOType = (typeof FolderDTOType)[keyof typeof FolderDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FolderDTOType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export type FolderDTOStatus = (typeof FolderDTOStatus)[keyof typeof FolderDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FolderDTOStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE'
} as const;

export interface FolderDTO {
  id?: string;
  legacyId?: string;
  /**
   * @minLength 0
   * @maxLength 30
   */
  name?: string;
  parent?: LocationDTO;
  slug?: string;
  status?: FolderDTOStatus;
  type?: FolderDTOType;
}

export type SubFolderDtoType = (typeof SubFolderDtoType)[keyof typeof SubFolderDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubFolderDtoType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export type SubFolderDtoStatus = (typeof SubFolderDtoStatus)[keyof typeof SubFolderDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubFolderDtoStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE'
} as const;

export interface SubFolderDto {
  id?: string;
  legacyId?: string;
  /**
   * @minLength 0
   * @maxLength 30
   */
  name?: string;
  parent?: LocationDTO;
  slug?: string;
  status?: SubFolderDtoStatus;
  type?: SubFolderDtoType;
}

export type ParentInfoType = (typeof ParentInfoType)[keyof typeof ParentInfoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParentInfoType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export interface ParentInfo {
  slug?: string;
  type?: ParentInfoType;
}

export interface CreateSubfolderRequestBody {
  legacyId?: string;
  name?: string;
  parent?: ParentInfo;
}

export interface UserRef {
  email?: string;
  id?: string;
}

export interface RoleAssignmentRequest {
  roleId: string;
  user: UserRef;
}

export interface RoleAssignmentRequestDto {
  /** @minItems 1 */
  roleAssignments: RoleAssignmentRequest[];
}

export type CreateSuborganizationResponseDtoStatus =
  (typeof CreateSuborganizationResponseDtoStatus)[keyof typeof CreateSuborganizationResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSuborganizationResponseDtoStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export type CreateSuborganizationResponseDtoEmployeeCount =
  (typeof CreateSuborganizationResponseDtoEmployeeCount)[keyof typeof CreateSuborganizationResponseDtoEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSuborganizationResponseDtoEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface CreateSuborganizationResponseDto {
  countries?: string[];
  createdAt?: string;
  createdBy?: UserDTO;
  employeeCount?: CreateSuborganizationResponseDtoEmployeeCount;
  id?: string;
  jiraId?: string;
  keyAccountManagers?: UserDTO[];
  legacyId?: string;
  legalName?: string;
  name?: string;
  offices?: string[];
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  slug?: string;
  status?: CreateSuborganizationResponseDtoStatus;
  testValidityDays?: number;
  updatedAt?: string;
}

export type CreateSuborganizationRequestLocalesItem =
  (typeof CreateSuborganizationRequestLocalesItem)[keyof typeof CreateSuborganizationRequestLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSuborganizationRequestLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type CreateSuborganizationRequestEmployeeCount =
  (typeof CreateSuborganizationRequestEmployeeCount)[keyof typeof CreateSuborganizationRequestEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSuborganizationRequestEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface CreateSuborganizationRequest {
  countries?: string[];
  employeeCount?: CreateSuborganizationRequestEmployeeCount;
  jiraId?: string;
  keyAccountManagers?: string[];
  legacyId?: string;
  legalName?: string;
  locales?: CreateSuborganizationRequestLocalesItem[];
  /** @minLength 1 */
  name: string;
  offices?: string[];
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  testValidityDays?: number;
}

export type CreateOrganizationResponseDtoTalentUniqueFieldsItem =
  (typeof CreateOrganizationResponseDtoTalentUniqueFieldsItem)[keyof typeof CreateOrganizationResponseDtoTalentUniqueFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationResponseDtoTalentUniqueFieldsItem = {
  ID_NUMBER: 'ID_NUMBER',
  PASSPORT_NUMBER: 'PASSPORT_NUMBER',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL'
} as const;

export type CreateOrganizationResponseDtoStatus =
  (typeof CreateOrganizationResponseDtoStatus)[keyof typeof CreateOrganizationResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationResponseDtoStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export type CreateOrganizationResponseDtoLocalesItem =
  (typeof CreateOrganizationResponseDtoLocalesItem)[keyof typeof CreateOrganizationResponseDtoLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationResponseDtoLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type CreateOrganizationResponseDtoEmployeeCount =
  (typeof CreateOrganizationResponseDtoEmployeeCount)[keyof typeof CreateOrganizationResponseDtoEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationResponseDtoEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface CreateOrganizationResponseDto {
  admins?: AdminDTO[];
  countries?: string[];
  createdAt?: string;
  createdBy?: UserDTO;
  employeeCount?: CreateOrganizationResponseDtoEmployeeCount;
  id?: string;
  idValidation?: IdValidationConfig;
  isEnterprise?: boolean;
  jiraId?: string;
  keyAccountManagers?: string[];
  legacyId?: string;
  legalName?: string;
  locales?: CreateOrganizationResponseDtoLocalesItem[];
  name?: string;
  offices?: string[];
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  slug?: string;
  status?: CreateOrganizationResponseDtoStatus;
  talentUniqueFields?: CreateOrganizationResponseDtoTalentUniqueFieldsItem[];
  testValidityDays?: number;
  updatedAt?: string;
}

export type CreateOrganizationRequestLocalesItem =
  (typeof CreateOrganizationRequestLocalesItem)[keyof typeof CreateOrganizationRequestLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationRequestLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type CreateOrganizationRequestEmployeeCount =
  (typeof CreateOrganizationRequestEmployeeCount)[keyof typeof CreateOrganizationRequestEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationRequestEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface AdminDTO {
  email?: string;
  id?: string;
  phone?: string;
}

export interface CreateOrganizationRequest {
  admins?: AdminDTO[];
  countries?: string[];
  employeeCount?: CreateOrganizationRequestEmployeeCount;
  isEnterprise?: boolean;
  jiraId?: string;
  keyAccountManagers?: string[];
  legacyId?: string;
  legalName?: string;
  locales?: CreateOrganizationRequestLocalesItem[];
  /** @minLength 1 */
  name: string;
  offices?: string[];
  pipedriveId?: string;
}

export type TestTemplateFiltersAiWebcamItem =
  (typeof TestTemplateFiltersAiWebcamItem)[keyof typeof TestTemplateFiltersAiWebcamItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestTemplateFiltersAiWebcamItem = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  ALERT: 'ALERT'
} as const;

/**
 * Filter criteria for test templates
 */
export interface TestTemplateFilters {
  /** AI webcam results */
  aiWebcam?: TestTemplateFiltersAiWebcamItem[];
  /** Score range for filtering templates */
  score?: string;
  /** Search string for test templates */
  search?: string;
  /** Status of the test template */
  status?: string;
}

/**
 * Range of talents count for filtering
 */
export interface TalentsCount {
  /** Maximum number of talents */
  max?: number;
  /** Minimum number of talents */
  min?: number;
}

/**
 * Filter criteria for talents
 */
export interface TalentFilters {
  /** Creation date range for filtering talents */
  createdAt?: DateRangeDTO;
  /** Search by talent email */
  searchByEmail?: string;
  /** Search by talent name */
  searchByName?: string;
  /** Search by talent phone */
  searchByPhone?: string;
  /** Status of the talent */
  status?: string;
  /** Type of talent */
  type?: string;
  /** Last updated date range for filtering talents */
  updatedAt?: DateRangeDTO;
}

/**
 * Availability window for a process or entity
 */
export interface Availability {
  /** End time of availability */
  end?: string;
  /** Start time of availability */
  start?: string;
}

/**
 * Filter criteria for processes
 */
export interface ProcessFilters {
  /** List of assessment types */
  assessmentType?: string[];
  /** Availability window for process */
  availability?: Availability;
  /** List of users who created the process */
  createdBy?: string[];
  /** List of key account managers */
  kam?: string[];
  /** Array of location objects to filter by; each element has slug and type (e.g. FOLDER, ORGANIZATION). Required to be an array, not a single object. */
  locations?: LocationDTO[];
  /** Office slug for filtering processes */
  office?: string;
  /** Organization slug for filtering processes */
  organization?: string;
  /** Process features filter (e.g., CAMERA_ON, AI_WEBCAM, PUBLIC_LINK, LIMITED) */
  processFeatures?: string[];
  /** Search string for process */
  search?: string;
  /** List of process statuses */
  status?: string[];
  /** Range for number of talents */
  talentsCount?: TalentsCount;
}

/**
 * Data Transfer Object for querying processes with filters, pagination, and test templates
 */
export interface ProcessQueryDTO {
  /** Page number for pagination */
  page?: number;
  /** Filter criteria for processes */
  process?: ProcessFilters;
  /** Number of records per page */
  size?: number;
  /** Filter criteria for talents */
  talents?: TalentFilters;
  /** Filter criteria for test templates */
  testTemplates?: TestTemplateFilters;
}

export type TalentRegistrationFormAnswersDtoTranslations = { [key: string]: { [key: string]: QuestionTranslation } };

export interface TalentRegistrationFormAnswersDto {
  external?: ProcessTalentRegistrationFormDto[];
  internal?: ProcessTalentRegistrationFormDto[];
  translations?: TalentRegistrationFormAnswersDtoTranslations;
}

export type ProcessTalentRegistrationFormDtoType =
  (typeof ProcessTalentRegistrationFormDtoType)[keyof typeof ProcessTalentRegistrationFormDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentRegistrationFormDtoType = {
  TEXT: 'TEXT',
  LONG_TEXT: 'LONG_TEXT',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  SELECT: 'SELECT',
  YEAR: 'YEAR'
} as const;

export type ProcessTalentRegistrationFormDtoTranslations = { [key: string]: { [key: string]: QuestionTranslation } };

export type ProcessTalentRegistrationFormDtoIdentityType =
  (typeof ProcessTalentRegistrationFormDtoIdentityType)[keyof typeof ProcessTalentRegistrationFormDtoIdentityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentRegistrationFormDtoIdentityType = {
  ID_NUMBER: 'ID_NUMBER',
  PASSPORT_NUMBER: 'PASSPORT_NUMBER',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL'
} as const;

export type ProcessTalentRegistrationFormDtoAnswer = SingleAnswer | ArrayAnswer;

/**
 * Process Talent Registration Form DTO that extends TalentRegistrationFormDto
 */
export interface ProcessTalentRegistrationFormDto {
  answer?: ProcessTalentRegistrationFormDtoAnswer;
  id?: string;
  identityType?: ProcessTalentRegistrationFormDtoIdentityType;
  isActive?: boolean;
  isExternal?: boolean;
  isKnockout?: boolean;
  isRequired?: boolean;
  isTalentEditable?: boolean;
  optionValues?: string[];
  translations?: ProcessTalentRegistrationFormDtoTranslations;
  type?: ProcessTalentRegistrationFormDtoType;
  validation?: TalentQuestionValidation;
}

export interface ProcessAddTalentsRequest {
  /** List of talent IDs to add to the process */
  talentIds?: string[];
}

export interface RefinementOption {
  id?: string;
  label?: string;
}

export interface Refinement {
  id?: string;
  label?: string;
  maximumOptions?: number;
  minimumOptions?: number;
  options?: RefinementOption[];
}

export interface AddProcessCatalogItemsResponse {
  catalogItems?: string[];
  refinement?: Refinement;
}

export interface RefinementRequest {
  id?: string;
  values?: string[];
}

export type AddProcessCatalogItemsRequestLocale =
  (typeof AddProcessCatalogItemsRequestLocale)[keyof typeof AddProcessCatalogItemsRequestLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddProcessCatalogItemsRequestLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export interface AddProcessCatalogItemsRequest {
  catalogId?: string;
  locale?: AddProcessCatalogItemsRequestLocale;
  refinements?: RefinementRequest[];
}

export type ProcessInvitationTalentErrorItemError =
  (typeof ProcessInvitationTalentErrorItemError)[keyof typeof ProcessInvitationTalentErrorItemError];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessInvitationTalentErrorItemError = {
  UNSUPPORTED_SEND_MODE: 'UNSUPPORTED_SEND_MODE',
  NOT_FOUND: 'NOT_FOUND',
  BLOCKED: 'BLOCKED'
} as const;

export interface ProcessInvitationTalentErrorItem {
  error?: ProcessInvitationTalentErrorItemError;
  talentId?: string;
}

export interface ProcessInvitationResponse {
  errors?: ProcessInvitationTalentErrorItem[];
  invitations?: ProcessInvitationItem[];
  url?: string;
}

export type ProcessInvitationItemSendMode =
  (typeof ProcessInvitationItemSendMode)[keyof typeof ProcessInvitationItemSendMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessInvitationItemSendMode = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessInvitationItemAccessMode =
  (typeof ProcessInvitationItemAccessMode)[keyof typeof ProcessInvitationItemAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessInvitationItemAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessInvitationItem {
  accessMode?: ProcessInvitationItemAccessMode;
  createdAt?: string;
  expiresAt?: string;
  id?: string;
  password?: string;
  processId?: string;
  sendMode?: ProcessInvitationItemSendMode;
  talentId?: string;
  url?: string;
}

export type ProcessInvitationRequestSendMode =
  (typeof ProcessInvitationRequestSendMode)[keyof typeof ProcessInvitationRequestSendMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessInvitationRequestSendMode = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessInvitationRequestAccessMode =
  (typeof ProcessInvitationRequestAccessMode)[keyof typeof ProcessInvitationRequestAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessInvitationRequestAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessInvitationRequest {
  accessMode?: ProcessInvitationRequestAccessMode;
  sendMode?: ProcessInvitationRequestSendMode;
  talentIds?: string[];
}

export interface ProcessTalentFileUploadResponseDTO {
  id?: string;
  name?: string;
  readOnly?: boolean;
}

export type ProcessTalentInvitationResponseSendMode =
  (typeof ProcessTalentInvitationResponseSendMode)[keyof typeof ProcessTalentInvitationResponseSendMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentInvitationResponseSendMode = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessTalentInvitationResponseAccessMode =
  (typeof ProcessTalentInvitationResponseAccessMode)[keyof typeof ProcessTalentInvitationResponseAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentInvitationResponseAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessTalentInvitationResponse {
  accessKey?: string;
  accessMode?: ProcessTalentInvitationResponseAccessMode;
  createdAt?: string;
  expiresAt?: string;
  id?: string;
  processId?: string;
  sendMode?: ProcessTalentInvitationResponseSendMode;
  talentId?: string;
  url?: string;
}

export type ProcessTalentInvitationRequestSendMode =
  (typeof ProcessTalentInvitationRequestSendMode)[keyof typeof ProcessTalentInvitationRequestSendMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentInvitationRequestSendMode = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessTalentInvitationRequestAccessMode =
  (typeof ProcessTalentInvitationRequestAccessMode)[keyof typeof ProcessTalentInvitationRequestAccessMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessTalentInvitationRequestAccessMode = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessTalentInvitationRequest {
  accessMode?: ProcessTalentInvitationRequestAccessMode;
  sendMode?: ProcessTalentInvitationRequestSendMode;
}

/**
 * Represents multiple string answers
 */
export interface ArrayAnswer {
  value?: string[];
}

/**
 * Represents a single string answer
 */
export interface SingleAnswer {
  /** The answer */
  value?: string;
}

export type TalentRegistrationFormAnswerPostDTOAnswer = SingleAnswer | ArrayAnswer;

/**
 * Represents an individual answer in the talent registration form
 */
export interface TalentRegistrationFormAnswerPostDTO {
  answer?: TalentRegistrationFormAnswerPostDTOAnswer;
  /** The ID of the question being answered */
  talentQuestionId?: string;
}

/**
 * DTO representing a list of answers for a talent registration form
 */
export interface AnswerTalentRegistrationFormDto {
  /** List of answers submitted for the talent registration form */
  answers?: TalentRegistrationFormAnswerPostDTO[];
}

export type ProcessResponseDTOStatus = (typeof ProcessResponseDTOStatus)[keyof typeof ProcessResponseDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessResponseDTOStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED'
} as const;

export type ProcessResponseDTOSendModesItem =
  (typeof ProcessResponseDTOSendModesItem)[keyof typeof ProcessResponseDTOSendModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessResponseDTOSendModesItem = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessResponseDTODefaultLocale =
  (typeof ProcessResponseDTODefaultLocale)[keyof typeof ProcessResponseDTODefaultLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessResponseDTODefaultLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type ProcessResponseDTOAssessmentType =
  (typeof ProcessResponseDTOAssessmentType)[keyof typeof ProcessResponseDTOAssessmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessResponseDTOAssessmentType = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  ANY: 'ANY'
} as const;

export type ProcessResponseDTOAccessModesItem =
  (typeof ProcessResponseDTOAccessModesItem)[keyof typeof ProcessResponseDTOAccessModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessResponseDTOAccessModesItem = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessResponseDTO {
  accessModes?: ProcessResponseDTOAccessModesItem[];
  assessmentType?: ProcessResponseDTOAssessmentType;
  catalogItems?: string[];
  /**
   * @minimum 60
   * @maximum 129600
   */
  continueReminderMinutes?: number;
  createdAt?: string;
  createdBy?: UserDTO;
  defaultLocale?: ProcessResponseDTODefaultLocale;
  description?: string;
  /**
   * Deprecated — no longer used. Will be removed in a future version.
   * @deprecated
   */
  endDate?: string;
  id?: string;
  location?: LocationDTO;
  name?: string;
  organization?: OrganizationDTO;
  publicLink?: string;
  sendModes?: ProcessResponseDTOSendModesItem[];
  /**
   * Deprecated — no longer used. Will be removed in a future version.
   * @deprecated
   */
  startDate?: string;
  /**
   * @minimum 60
   * @maximum 129600
   */
  startReminderMinutes?: number;
  status?: ProcessResponseDTOStatus;
  talentsCount?: number;
  testSettings?: TestSettings;
  updatedAt?: string;
}

export type OrganizationDTOTalentUniqueFieldsItem =
  (typeof OrganizationDTOTalentUniqueFieldsItem)[keyof typeof OrganizationDTOTalentUniqueFieldsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationDTOTalentUniqueFieldsItem = {
  ID_NUMBER: 'ID_NUMBER',
  PASSPORT_NUMBER: 'PASSPORT_NUMBER',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL'
} as const;

export type OrganizationDTOStatus = (typeof OrganizationDTOStatus)[keyof typeof OrganizationDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationDTOStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export type OrganizationDTOLocalesItem = (typeof OrganizationDTOLocalesItem)[keyof typeof OrganizationDTOLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationDTOLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export interface NormSettingsDTO {
  defaultNorm?: string;
  normOptions?: string[];
}

export type OrganizationDTONorms = { [key: string]: NormSettingsDTO };

export interface IndustryDTO {
  id?: string;
  key?: string;
  label?: string;
}

export interface OrganizationDTO {
  admins?: UserDTO[];
  anonymizationDurationMonths?: number;
  countries?: string[];
  createdAt?: string;
  createdBy?: UserDTO;
  defaultNorm?: string;
  id?: string;
  idValidation?: IdValidationConfig;
  industry?: IndustryDTO;
  isEnterprise?: boolean;
  jiraId?: string;
  keyAccountManagers?: UserDTO[];
  lastActivity?: string;
  legacyId?: string;
  legalName?: string;
  locales?: OrganizationDTOLocalesItem[];
  name?: string;
  norms?: OrganizationDTONorms;
  offices?: string[];
  pipedriveId?: string;
  slug?: string;
  status?: OrganizationDTOStatus;
  talentPropertyValidation?: TalentPropertyValidation;
  talentUniqueFields?: OrganizationDTOTalentUniqueFieldsItem[];
  testValidityDays?: number;
  userCount?: number;
  users?: UserDTO[];
}

export type LocationUpdateDTOType = (typeof LocationUpdateDTOType)[keyof typeof LocationUpdateDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationUpdateDTOType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export interface LocationUpdateDTO {
  /** @minLength 1 */
  slug: string;
  type: LocationUpdateDTOType;
}

export type CreateProcessRequestDtoAssessmentType =
  (typeof CreateProcessRequestDtoAssessmentType)[keyof typeof CreateProcessRequestDtoAssessmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateProcessRequestDtoAssessmentType = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  ANY: 'ANY'
} as const;

export interface CreateProcessRequestDto {
  assessmentType: CreateProcessRequestDtoAssessmentType;
  catalogItems?: string[];
  createdBy?: string;
  description?: string;
  /**
   * Deprecated — no longer used. Will be removed in a future version.
   * @deprecated
   */
  endDate?: string;
  location: LocationUpdateDTO;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  organization: string;
  /**
   * Deprecated — no longer used. Will be removed in a future version.
   * @deprecated
   */
  startDate?: string;
}

export interface JwtRequest {
  email?: string;
  jwtToken?: string;
}

export interface LoginRequest {
  email?: string;
}

export interface WebcamSettings {
  captureFrequencySeconds?: number;
  isAiAnalysisEnabled?: boolean;
  isEnabled?: boolean;
  isMandatory?: boolean;
}

export type UserUserType = (typeof UserUserType)[keyof typeof UserUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserUserType = {
  MIDOT_ADMIN: 'MIDOT_ADMIN',
  CS: 'CS',
  KAM: 'KAM',
  ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
  BASIC: 'BASIC',
  ADMIN: 'ADMIN'
} as const;

export type UserPreferredOtpMethod = (typeof UserPreferredOtpMethod)[keyof typeof UserPreferredOtpMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPreferredOtpMethod = {
  whatsapp: 'whatsapp',
  phone: 'phone',
  email: 'email',
  auth: 'auth',
  none: 'none'
} as const;

export type UserPreferredLoginMethod = (typeof UserPreferredLoginMethod)[keyof typeof UserPreferredLoginMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPreferredLoginMethod = {
  sso: 'sso',
  outlook: 'outlook',
  passkey: 'passkey',
  magic: 'magic',
  microsoft: 'microsoft',
  google: 'google',
  none: 'none'
} as const;

export type UserLastOtpMethod = (typeof UserLastOtpMethod)[keyof typeof UserLastOtpMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserLastOtpMethod = {
  whatsapp: 'whatsapp',
  phone: 'phone',
  email: 'email',
  auth: 'auth',
  none: 'none'
} as const;

export type UserLastLoginMethod = (typeof UserLastLoginMethod)[keyof typeof UserLastLoginMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserLastLoginMethod = {
  sso: 'sso',
  outlook: 'outlook',
  passkey: 'passkey',
  magic: 'magic',
  microsoft: 'microsoft',
  google: 'google',
  none: 'none'
} as const;

export interface User {
  adminLocationIds?: string[];
  adminOrganizationIds?: string[];
  assignedLocationIds?: string[];
  assignedOfficeIds?: string[];
  assignedRoles?: RoleAssignment[];
  avatarUrl?: string;
  createdAt?: string;
  createdBy?: string;
  customerSuccess?: boolean;
  /**
   * @minLength 0
   * @maxLength 100
   */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  firstName?: string;
  /**
   * @minLength 0
   * @maxLength 101
   */
  fullName?: string;
  id?: string;
  isCS?: boolean;
  isGlobalAdmin?: boolean;
  isKAM?: boolean;
  isLocationAdmin?: boolean;
  isOrgAdmin?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   */
  jobTitle?: string;
  kamOrganizationIds?: string[];
  keyAccountManager?: boolean;
  lastLoginAt?: string;
  lastLoginMethod?: UserLastLoginMethod;
  /**
   * @minLength 0
   * @maxLength 50
   */
  lastName?: string;
  lastOtpDone?: string;
  lastOtpMethod?: UserLastOtpMethod;
  lastSessionAt?: string;
  legacyId?: string;
  locationAdmin?: boolean;
  officeIds?: string[];
  offices?: string[];
  organizationAdmin?: boolean;
  organizationId?: string;
  permissionHierarchyLevel?: number;
  /**
   * @minLength 0
   * @maxLength 16
   */
  phone?: string;
  preferredDateFormat?: string;
  preferredLocale?: string;
  preferredLoginMethod?: UserPreferredLoginMethod;
  preferredOtpMethod?: UserPreferredOtpMethod;
  preferredTimezone?: string;
  regularCustomer?: boolean;
  status?: string;
  suborganizationAdmin?: boolean;
  suborganizationScope?: string[];
  userType: UserUserType;
}

export interface TestSettings {
  isClarificationQuestionsEnabled?: boolean;
  webcamSettings?: WebcamSettings;
}

export interface TalentQuestionValidation {
  allowedFileExtensions?: string[];
  max?: number;
  maxFileSize?: number;
  min?: number;
  pattern?: string;
  rule?: string;
}

export type TalentPropertyValidationIdValidationPreset =
  (typeof TalentPropertyValidationIdValidationPreset)[keyof typeof TalentPropertyValidationIdValidationPreset];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentPropertyValidationIdValidationPreset = {
  ISRAEL: 'ISRAEL',
  MEXICO: 'MEXICO',
  CUSTOM: 'CUSTOM',
  NONE: 'NONE'
} as const;

export interface TalentPropertyValidation {
  allowDigits?: boolean;
  allowLetters?: boolean;
  idValidationPreset?: TalentPropertyValidationIdValidationPreset;
  maxLength?: number;
}

export type SubOrganizationUserInviteEmailLanguage =
  (typeof SubOrganizationUserInviteEmailLanguage)[keyof typeof SubOrganizationUserInviteEmailLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubOrganizationUserInviteEmailLanguage = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type SubOrganizationTalentInviteEmailLanguage =
  (typeof SubOrganizationTalentInviteEmailLanguage)[keyof typeof SubOrganizationTalentInviteEmailLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubOrganizationTalentInviteEmailLanguage = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type SubOrganizationStatus = (typeof SubOrganizationStatus)[keyof typeof SubOrganizationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubOrganizationStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ONBOARDING: 'ONBOARDING',
  INACTIVE: 'INACTIVE',
  ON_HOLD: 'ON_HOLD'
} as const;

export type SubOrganizationLocalesItem = (typeof SubOrganizationLocalesItem)[keyof typeof SubOrganizationLocalesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubOrganizationLocalesItem = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type SubOrganizationEmployeeCount =
  (typeof SubOrganizationEmployeeCount)[keyof typeof SubOrganizationEmployeeCount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubOrganizationEmployeeCount = {
  RANGE_0_20: 'RANGE_0_20',
  RANGE_21_99: 'RANGE_21_99',
  RANGE_100_299: 'RANGE_100_299',
  RANGE_300_499: 'RANGE_300_499',
  RANGE_500_999: 'RANGE_500_999',
  RANGE_1000_1999: 'RANGE_1000_1999',
  MORE_THAN_2000: 'MORE_THAN_2000'
} as const;

export interface RoleAssignment {
  active: boolean;
  assignedAt: string;
  assignedBy?: string;
  departmentId?: string;
  organizationId?: string;
  /** @minLength 1 */
  roleId: string;
  /** @minLength 1 */
  roleName: string;
  scope?: string;
  scopeId?: string;
}

export type QuestionTranslationOptionLabels = { [key: string]: string };

export interface QuestionTranslation {
  label?: string;
  optionLabels?: QuestionTranslationOptionLabels;
}

export type ProcessSettingsSendModesItem =
  (typeof ProcessSettingsSendModesItem)[keyof typeof ProcessSettingsSendModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessSettingsSendModesItem = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  WHATSAPP: 'WHATSAPP'
} as const;

export type ProcessSettingsDefaultLocale =
  (typeof ProcessSettingsDefaultLocale)[keyof typeof ProcessSettingsDefaultLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessSettingsDefaultLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export type ProcessSettingsAccessModesItem =
  (typeof ProcessSettingsAccessModesItem)[keyof typeof ProcessSettingsAccessModesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessSettingsAccessModesItem = {
  PASSWORD: 'PASSWORD',
  UNIQUE_LINK: 'UNIQUE_LINK',
  PUBLIC_LINK: 'PUBLIC_LINK'
} as const;

export interface ProcessSettings {
  accessModes?: ProcessSettingsAccessModesItem[];
  /**
   * @minimum 60
   * @maximum 129600
   */
  continueReminderMinutes?: number;
  defaultLocale?: ProcessSettingsDefaultLocale;
  sendModes?: ProcessSettingsSendModesItem[];
  /**
   * @minimum 60
   * @maximum 129600
   */
  startReminderMinutes?: number;
  testSettings?: TestSettings;
}

export interface OrganizationNorm {
  isDefault?: boolean;
  normId?: string;
  testTypeId?: string;
}

export interface Organization {
  name?: string;
}

export interface Office {
  id?: string;
  key?: string;
  /**
   * @minLength 0
   * @maxLength 30
   */
  name?: string;
  slug?: string;
}

export type LocationType = (typeof LocationType)[keyof typeof LocationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export interface Location {
  id?: string;
  name?: string;
  organization?: Organization;
  organizationSlug?: string;
  parent?: Location;
  slug?: string;
  suborganization?: SubOrganization;
  subOrganizationSlug?: string;
  type?: LocationType;
}

export interface Industry {
  id?: string;
  key?: string;
  label?: string;
}

export interface SubOrganization {
  admins?: User[];
  countries?: string[];
  createdAt?: string;
  createdBy?: string;
  employeeCount?: SubOrganizationEmployeeCount;
  id?: string;
  industry?: Industry;
  jiraId?: string;
  keyAccountManagers?: User[];
  lastActivity?: string;
  legacyId?: string;
  /**
   * @minLength 0
   * @maxLength 30
   */
  legalName?: string;
  locales?: SubOrganizationLocalesItem[];
  location?: Location;
  /**
   * @minLength 0
   * @maxLength 30
   */
  name?: string;
  offices?: Office[];
  organizationNorms?: OrganizationNorm[];
  parent?: Organization;
  pipedriveId?: string;
  processSettings?: ProcessSettings;
  slug?: string;
  status?: SubOrganizationStatus;
  talentInviteEmailLanguage?: SubOrganizationTalentInviteEmailLanguage;
  testValidityDays?: number;
  updatedAt?: string;
  userInviteEmailLanguage?: SubOrganizationUserInviteEmailLanguage;
  users?: User[];
}

export type IdValidationConfigPreset = (typeof IdValidationConfigPreset)[keyof typeof IdValidationConfigPreset];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdValidationConfigPreset = {
  ISRAEL: 'ISRAEL',
  MEXICO: 'MEXICO',
  CUSTOM: 'CUSTOM',
  NONE: 'NONE'
} as const;

export interface IdValidationConfig {
  allowDigits?: boolean;
  allowLetters?: boolean;
  maxLength?: number;
  preset?: IdValidationConfigPreset;
}

export type FolderType = (typeof FolderType)[keyof typeof FolderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FolderType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export type FolderFolderStatus = (typeof FolderFolderStatus)[keyof typeof FolderFolderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FolderFolderStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE'
} as const;

export interface Folder {
  createdAt?: string;
  folderStatus?: FolderFolderStatus;
  id?: string;
  legacyId?: string;
  location?: Location;
  /**
   * @minLength 0
   * @maxLength 30
   */
  name?: string;
  slug?: string;
  suborganization?: SubOrganization;
  type?: FolderType;
}

export type TestSessionSummaryDTOStatus =
  (typeof TestSessionSummaryDTOStatus)[keyof typeof TestSessionSummaryDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSessionSummaryDTOStatus = {
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  REFUSED: 'REFUSED'
} as const;

export type TestSessionSummaryDTOAiAnalysisStatus =
  (typeof TestSessionSummaryDTOAiAnalysisStatus)[keyof typeof TestSessionSummaryDTOAiAnalysisStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSessionSummaryDTOAiAnalysisStatus = {
  FAIL: 'FAIL',
  PASS: 'PASS',
  INSPECTION_NEEDED: 'INSPECTION_NEEDED'
} as const;

export interface TestDefinitionNameDTO {
  id?: string;
  name?: string;
}

export interface TestSessionSummaryDTO {
  aiAnalysisStatus?: TestSessionSummaryDTOAiAnalysisStatus;
  evaluation?: string;
  id?: string;
  isAiAnalysisEnabled?: boolean;
  isWebcamEnabled?: boolean;
  order?: number;
  retest?: boolean;
  score?: number;
  status?: TestSessionSummaryDTOStatus;
  testDefinition?: TestDefinitionNameDTO;
  updatedAt?: string;
}

export interface TalentsResponseStatsDTO {
  completed?: number;
  ghost?: number;
  inTest?: number;
  registered?: number;
}

export interface TalentsResponseDTO {
  currentPage?: number;
  size?: number;
  stats?: TalentsResponseStatsDTO;
  talents?: TalentResponseDTO[];
  totalElements?: number;
  totalPages?: number;
}

export type TalentResponseDTOStatus = (typeof TalentResponseDTOStatus)[keyof typeof TalentResponseDTOStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentResponseDTOStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

/**
 * Simplified organization information for talent list
 */
export interface TalentListOrganizationDTO {
  /** Organization ID */
  id?: string;
  /** Organization name */
  name?: string;
  /** Organization slug */
  slug?: string;
}

export interface TalentResponseDTO {
  createdBy?: UserDTO;
  email?: string;
  firstName?: string;
  id?: string;
  idNumber?: string;
  lastName?: string;
  latestProcess?: ProcessDTO;
  latestTestSession?: TestSessionSummaryDTO;
  organization?: TalentListOrganizationDTO;
  phone?: string;
  processesCount?: number;
  status?: TalentResponseDTOStatus;
  testSessionsCount?: number;
  type?: string;
}

export interface TestTemplatesCriteriaDTO {
  tbd?: unknown;
}

export type TalentsCriteriaDTOType = (typeof TalentsCriteriaDTOType)[keyof typeof TalentsCriteriaDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentsCriteriaDTOType = {
  CANDIDATE: 'CANDIDATE',
  EMPLOYEE: 'EMPLOYEE'
} as const;

export interface TalentListRequestDTO {
  excludeProcessIds?: string[];
  organizationSlug?: string;
  /** Page number for pagination. */
  page?: number;
  process?: ProcessCriteriaDTO;
  /** Number of items per page. */
  size?: number;
  sortBy?: string;
  sortDirection?: string;
  talents?: TalentsCriteriaDTO;
  testTemplates?: TestTemplatesCriteriaDTO;
}

export interface LocationCriteriaDTO {
  slug?: string;
  type?: string;
}

/**
 * Date range with start and end times
 */
export interface DateRangeDTO {
  /** End timestamp of the range */
  end?: string;
  /** Start timestamp of the range */
  start?: string;
}

export interface TalentsCriteriaDTO {
  createdAt?: DateRangeDTO;
  createdBy?: string[];
  excludeProcessIds?: string[];
  kam?: string[];
  latestProcess?: LatestProcessCriteriaDTO;
  limitedTalent?: unknown;
  locations?: LocationCriteriaDTO[];
  office?: string;
  organization?: string;
  searchByEmail?: string;
  searchByName?: string;
  searchByPhone?: string;
  talentPhone?: string;
  type?: TalentsCriteriaDTOType;
  updatedAt?: DateRangeDTO;
}

export interface ProcessCriteriaDTO {
  assessmentType?: string[];
  availability?: DateRangeDTO;
  createdAt?: DateRangeDTO;
  features?: unknown;
  processName?: string;
  search?: string;
  status?: string[];
  updatedAt?: DateRangeDTO;
}

/**
 * Status of the talent
 */
export type TalentTestSessionStatusRequestDTOTalentStatus =
  (typeof TalentTestSessionStatusRequestDTOTalentStatus)[keyof typeof TalentTestSessionStatusRequestDTOTalentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentTestSessionStatusRequestDTOTalentStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

/**
 * Status of the process
 */
export type TalentTestSessionStatusRequestDTOProcessStatus =
  (typeof TalentTestSessionStatusRequestDTOProcessStatus)[keyof typeof TalentTestSessionStatusRequestDTOProcessStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentTestSessionStatusRequestDTOProcessStatus = {
  UNPUBLISHED: 'UNPUBLISHED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED'
} as const;

/**
 * Request to update talent test session status
 */
export interface TalentTestSessionStatusRequestDTO {
  /**
   * Number of completed exams
   * @minimum 1
   */
  completionNum: number;
  /** ID of the process invitation */
  processInvitationId: string;
  /** Status of the process */
  processStatus: TalentTestSessionStatusRequestDTOProcessStatus;
  /** ID of the talent */
  talentId: string;
  /** Status of the talent */
  talentStatus: TalentTestSessionStatusRequestDTOTalentStatus;
}

/**
 * Reason why talent cannot be created (only present if canCreate is false)
 */
export type TalentValidationResponseReason =
  (typeof TalentValidationResponseReason)[keyof typeof TalentValidationResponseReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentValidationResponseReason = {
  HIDDEN_TALENT: 'HIDDEN_TALENT',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  REQUIRED_FIELD_MISSING: 'REQUIRED_FIELD_MISSING'
} as const;

/**
 * Response for talent validation
 */
export interface TalentValidationResponse {
  /** Whether the talent can be created */
  canCreate?: boolean;
  /** Reason why talent cannot be created (only present if canCreate is false) */
  reason?: TalentValidationResponseReason;
  /** ID of existing talent (only present if canCreate is false and reason is not HiddenTalent) */
  talentId?: string;
  /** Details about the validation failure (e.g., which field is missing or conflicting) */
  validationDetails?: string;
}

/**
 * Type of the talent
 */
export type TalentCreateDTOType = (typeof TalentCreateDTOType)[keyof typeof TalentCreateDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentCreateDTOType = {
  CANDIDATE: 'CANDIDATE',
  EMPLOYEE: 'EMPLOYEE'
} as const;

/**
 * DTO for creating a new Talent
 */
export interface TalentCreateDTO {
  /**
   * Email address of the talent
   * @minLength 1
   */
  email: string;
  /**
   * First name of the talent
   * @minLength 1
   */
  firstName: string;
  /** Identification number of the talent */
  idNumber?: string;
  /**
   * Last name of the talent
   * @minLength 1
   */
  lastName: string;
  /** Locations where the talent is available */
  locations?: TalentLocationRequestDTO[];
  /** Organization slug (only required for validation endpoint) */
  organizationSlug?: string;
  /** Passport number of the talent */
  passportNumber?: string;
  /** Phone number of the talent */
  phone?: string;
  /** Player invitation ID to link (for via-dataprocessor endpoint) */
  playerInvitationId?: string;
  /** Talent will start next processes */
  processes?: string[];
  /** Type of the talent */
  type: TalentCreateDTOType;
}

export interface TalentAddProcessesRequestDTO {
  processIds?: string[];
}

export type TestTemplateDTOAiWebcam = (typeof TestTemplateDTOAiWebcam)[keyof typeof TestTemplateDTOAiWebcam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestTemplateDTOAiWebcam = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  ALERT: 'ALERT'
} as const;

export interface TestTemplateDTO {
  additionalData?: string;
  aiWebcam?: TestTemplateDTOAiWebcam;
  highRisk?: number;
  id?: string;
  inquiryRequired?: number;
  marginal?: number;
  name?: string;
  noEvaluationAvailable?: number;
  recommended?: number;
}

export interface UserDTO {
  avatarUrl?: string;
  createdAt?: string;
  email?: string;
  firstName?: string;
  fullName?: string;
  /** @minLength 1 */
  id: string;
  isMidotEmployee?: boolean;
  jobTitle?: string;
  lastLoginAt?: string;
  lastName?: string;
  legacyId?: string;
  midotEmployee?: boolean;
  midotRoles?: string[];
  offices?: string[];
  /** @pattern ^\+?[1-9]\d{1,14}$ */
  phone?: string;
  /** @pattern ^(MM/DD/YYYY|DD/MM/YYYY|YYYY-MM-DD|YYYY/MM/DD)$ */
  preferredDateFormat?: string;
  /** @pattern ^[a-z]{2}-[A-Z]{2}$ */
  preferredLocale?: string;
  /** @pattern ^[A-Za-z_]+/[A-Za-z_]+$ */
  preferredTimezone?: string;
  /** @minLength 1 */
  status: string;
}

export type UpdateTalentStatusRequestStatus =
  (typeof UpdateTalentStatusRequestStatus)[keyof typeof UpdateTalentStatusRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTalentStatusRequestStatus = {
  REGISTERED: 'REGISTERED',
  GHOST: 'GHOST',
  IN_TEST: 'IN_TEST',
  REFUSED: 'REFUSED',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED'
} as const;

/**
 * The status update request with status field
 */
export interface UpdateTalentStatusRequest {
  status?: UpdateTalentStatusRequestStatus;
}

export type ProblemDetailProperties = { [key: string]: unknown };

export interface ProblemDetail {
  detail?: string;
  instance?: string;
  properties?: ProblemDetailProperties;
  status?: number;
  title?: string;
  type?: string;
}

export type MediaTypeParameters = { [key: string]: string };

export interface MediaType {
  charset?: string;
  concrete?: boolean;
  parameters?: MediaTypeParameters;
  qualityValue?: number;
  subtype?: string;
  subtypeSuffix?: string;
  type?: string;
  wildcardSubtype?: boolean;
  wildcardType?: boolean;
}

export interface HttpStatusCode {
  error?: boolean;
  is1xxInformational?: boolean;
  is2xxSuccessful?: boolean;
  is3xxRedirection?: boolean;
  is4xxClientError?: boolean;
  is5xxServerError?: boolean;
}

export type HttpStatus = (typeof HttpStatus)[keyof typeof HttpStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HttpStatus = {
  '100_CONTINUE': '100 CONTINUE',
  '101_SWITCHING_PROTOCOLS': '101 SWITCHING_PROTOCOLS',
  '102_PROCESSING': '102 PROCESSING',
  '103_EARLY_HINTS': '103 EARLY_HINTS',
  '200_OK': '200 OK',
  '201_CREATED': '201 CREATED',
  '202_ACCEPTED': '202 ACCEPTED',
  '203_NON_AUTHORITATIVE_INFORMATION': '203 NON_AUTHORITATIVE_INFORMATION',
  '204_NO_CONTENT': '204 NO_CONTENT',
  '205_RESET_CONTENT': '205 RESET_CONTENT',
  '206_PARTIAL_CONTENT': '206 PARTIAL_CONTENT',
  '207_MULTI_STATUS': '207 MULTI_STATUS',
  '208_ALREADY_REPORTED': '208 ALREADY_REPORTED',
  '226_IM_USED': '226 IM_USED',
  '300_MULTIPLE_CHOICES': '300 MULTIPLE_CHOICES',
  '301_MOVED_PERMANENTLY': '301 MOVED_PERMANENTLY',
  '302_FOUND': '302 FOUND',
  '303_SEE_OTHER': '303 SEE_OTHER',
  '304_NOT_MODIFIED': '304 NOT_MODIFIED',
  '307_TEMPORARY_REDIRECT': '307 TEMPORARY_REDIRECT',
  '308_PERMANENT_REDIRECT': '308 PERMANENT_REDIRECT',
  '400_BAD_REQUEST': '400 BAD_REQUEST',
  '401_UNAUTHORIZED': '401 UNAUTHORIZED',
  '402_PAYMENT_REQUIRED': '402 PAYMENT_REQUIRED',
  '403_FORBIDDEN': '403 FORBIDDEN',
  '404_NOT_FOUND': '404 NOT_FOUND',
  '405_METHOD_NOT_ALLOWED': '405 METHOD_NOT_ALLOWED',
  '406_NOT_ACCEPTABLE': '406 NOT_ACCEPTABLE',
  '407_PROXY_AUTHENTICATION_REQUIRED': '407 PROXY_AUTHENTICATION_REQUIRED',
  '408_REQUEST_TIMEOUT': '408 REQUEST_TIMEOUT',
  '409_CONFLICT': '409 CONFLICT',
  '410_GONE': '410 GONE',
  '411_LENGTH_REQUIRED': '411 LENGTH_REQUIRED',
  '412_PRECONDITION_FAILED': '412 PRECONDITION_FAILED',
  '413_CONTENT_TOO_LARGE': '413 CONTENT_TOO_LARGE',
  '413_PAYLOAD_TOO_LARGE': '413 PAYLOAD_TOO_LARGE',
  '414_URI_TOO_LONG': '414 URI_TOO_LONG',
  '415_UNSUPPORTED_MEDIA_TYPE': '415 UNSUPPORTED_MEDIA_TYPE',
  '416_REQUESTED_RANGE_NOT_SATISFIABLE': '416 REQUESTED_RANGE_NOT_SATISFIABLE',
  '417_EXPECTATION_FAILED': '417 EXPECTATION_FAILED',
  '418_I_AM_A_TEAPOT': '418 I_AM_A_TEAPOT',
  '421_MISDIRECTED_REQUEST': '421 MISDIRECTED_REQUEST',
  '422_UNPROCESSABLE_CONTENT': '422 UNPROCESSABLE_CONTENT',
  '422_UNPROCESSABLE_ENTITY': '422 UNPROCESSABLE_ENTITY',
  '423_LOCKED': '423 LOCKED',
  '424_FAILED_DEPENDENCY': '424 FAILED_DEPENDENCY',
  '425_TOO_EARLY': '425 TOO_EARLY',
  '426_UPGRADE_REQUIRED': '426 UPGRADE_REQUIRED',
  '428_PRECONDITION_REQUIRED': '428 PRECONDITION_REQUIRED',
  '429_TOO_MANY_REQUESTS': '429 TOO_MANY_REQUESTS',
  '431_REQUEST_HEADER_FIELDS_TOO_LARGE': '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
  '451_UNAVAILABLE_FOR_LEGAL_REASONS': '451 UNAVAILABLE_FOR_LEGAL_REASONS',
  '500_INTERNAL_SERVER_ERROR': '500 INTERNAL_SERVER_ERROR',
  '501_NOT_IMPLEMENTED': '501 NOT_IMPLEMENTED',
  '502_BAD_GATEWAY': '502 BAD_GATEWAY',
  '503_SERVICE_UNAVAILABLE': '503 SERVICE_UNAVAILABLE',
  '504_GATEWAY_TIMEOUT': '504 GATEWAY_TIMEOUT',
  '505_HTTP_VERSION_NOT_SUPPORTED': '505 HTTP_VERSION_NOT_SUPPORTED',
  '506_VARIANT_ALSO_NEGOTIATES': '506 VARIANT_ALSO_NEGOTIATES',
  '507_INSUFFICIENT_STORAGE': '507 INSUFFICIENT_STORAGE',
  '508_LOOP_DETECTED': '508 LOOP_DETECTED',
  '509_BANDWIDTH_LIMIT_EXCEEDED': '509 BANDWIDTH_LIMIT_EXCEEDED',
  '510_NOT_EXTENDED': '510 NOT_EXTENDED',
  '511_NETWORK_AUTHENTICATION_REQUIRED': '511 NETWORK_AUTHENTICATION_REQUIRED'
} as const;

export interface HttpRange {}

export interface HttpMethod {}

export type HttpHeadersHostAddress = {
  address?: string;
  anyLocalAddress?: boolean;
  canonicalHostName?: string;
  hostAddress?: string;
  hostName?: string;
  linkLocalAddress?: boolean;
  loopbackAddress?: boolean;
  mcglobal?: boolean;
  mclinkLocal?: boolean;
  mcnodeLocal?: boolean;
  mcorgLocal?: boolean;
  mcsiteLocal?: boolean;
  multicastAddress?: boolean;
  siteLocalAddress?: boolean;
};

export type HttpHeadersHost = {
  address?: HttpHeadersHostAddress;
  hostName?: string;
  hostString?: string;
  port?: number;
  unresolved?: boolean;
};

export type HttpHeadersAll = { [key: string]: string };

export type HttpHeadersAcceptLanguageItem = {
  range?: string;
  weight?: number;
};

export interface HttpHeaders {
  accept?: MediaType[];
  acceptCharset?: string[];
  acceptLanguage?: HttpHeadersAcceptLanguageItem[];
  acceptLanguageAsLocales?: string[];
  acceptPatch?: MediaType[];
  accessControlAllowCredentials?: boolean;
  accessControlAllowHeaders?: string[];
  accessControlAllowMethods?: HttpMethod[];
  accessControlAllowOrigin?: string;
  accessControlExposeHeaders?: string[];
  accessControlMaxAge?: number;
  accessControlRequestHeaders?: string[];
  accessControlRequestMethod?: HttpMethod;
  all?: HttpHeadersAll;
  allow?: HttpMethod[];
  basicAuth?: string;
  bearerAuth?: string;
  cacheControl?: string;
  connection?: string[];
  contentDisposition?: ContentDisposition;
  contentLanguage?: string;
  contentLength?: number;
  contentType?: MediaType;
  date?: number;
  empty?: boolean;
  etag?: string;
  expires?: number;
  host?: HttpHeadersHost;
  ifMatch?: string[];
  ifModifiedSince?: number;
  ifNoneMatch?: string[];
  ifUnmodifiedSince?: number;
  lastModified?: number;
  location?: string;
  origin?: string;
  pragma?: string;
  range?: HttpRange[];
  upgrade?: string;
  vary?: string[];
}

export interface ErrorResponse {
  body?: ProblemDetail;
  detailMessageArguments?: unknown[];
  detailMessageCode?: string;
  headers?: HttpHeaders;
  statusCode?: ErrorResponseStatusCode;
  titleMessageCode?: string;
  typeMessageCode?: string;
}

export type DefaultHttpStatusCode = HttpStatusCode;

export type ErrorResponseStatusCode = DefaultHttpStatusCode | HttpStatus;

export interface ContentDisposition {
  attachment?: boolean;
  charset?: string;
  filename?: string;
  formData?: boolean;
  inline?: boolean;
  name?: string;
  type?: string;
}

/**
 * Reference to a user by ID or email
 */
export interface UserReferenceDTO {
  email?: string;
  id?: string;
  /** Optional phone number in international format (any format accepted, validated by service) */
  phone?: string;
}

/**
 * @minLength 1
 */
export type LocationReferenceDTOType = (typeof LocationReferenceDTOType)[keyof typeof LocationReferenceDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationReferenceDTOType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

/**
 * Reference to a location where roles will be assigned
 */
export interface LocationReferenceDTO {
  /** @minLength 1 */
  organizationSlug: string;
  /** @minLength 1 */
  slug: string;
  /** @minLength 1 */
  type: LocationReferenceDTOType;
}

/**
 * Role assignment details for a set of users
 */
export interface RoleAssignmentDTO {
  /** @minItems 1 */
  locations: LocationReferenceDTO[];
  /** @minItems 1 */
  roleIds: string[];
  /** @minItems 1 */
  users: UserReferenceDTO[];
}

/**
 * Request to create role assignments for users
 */
export interface CreateRoleAssignmentsRequestDTO {
  /** @minItems 1 */
  roleAssignments: RoleAssignmentDTO[];
}

export interface VerifyPhoneRequest {
  /**
   * @minLength 1
   * @pattern ^\d{6}$
   */
  code: string;
  /**
   * @minLength 1
   * @pattern ^\+[1-9]\d{1,14}$
   */
  phone: string;
  /** @minLength 1 */
  token: string;
}

/**
 * Translated display labels for each message key in this locale (e.g. invitation -> "Invitación" for es-ES). Use for UI card titles.
 */
export type ProcessMessagesMessageLabels = { [key: string]: string };

/**
 * The locale of the messages
 */
export type ProcessMessagesLocale = (typeof ProcessMessagesLocale)[keyof typeof ProcessMessagesLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessMessagesLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

export interface Messages {
  /** Anonymous invitation link message sent to talent */
  anonymousInvitationLink?: string;
  /** Camera terms and conditions shown in the Player */
  cameraTerms?: string;
  /** Congratulations / completion message shown after the assessment is finished */
  complete?: string;
  /** Error message shown in the Player when something goes wrong */
  error?: string;
  /** Invitation message sent to talent via their invitation channel */
  invitation?: string;
  /** Data processing terms shown in the Player */
  processingTerms?: string;
  /** Research terms shown in the Player */
  researchTerms?: string;
  /** Notification with test report details */
  sendTestReport?: string;
  /** Notification sent when a talent report is shared from Podium */
  talentReportSent?: string;
  /** General terms and conditions shown in the Player */
  termsGeneral?: string;
  /** Player Welcome page */
  welcome?: string;
  /** Welcome email sent to new Podium users */
  welcomeInvitation?: string;
}

/**
 * Process messages for an organization in a specific locale
 */
export interface ProcessMessages {
  /** The locale of the messages */
  locale?: ProcessMessagesLocale;
  /** Translated display labels for each message key in this locale (e.g. invitation -> "Invitación" for es-ES). Use for UI card titles. */
  messageLabels?: ProcessMessagesMessageLabels;
  /** The messages content */
  messages?: Messages;
}

/**
 * Map of message keys to message texts. Only messages included will be updated/added. Use empty string to clear a message. Keys must match ProcessMessages.Messages field names.
 */
export type UpdateOrganizationMessagesRequestMessages = { [key: string]: string };

/**
 * The locale for these messages (e.g., en-US, fr-FR, es-ES)
 */
export type UpdateOrganizationMessagesRequestLocale =
  (typeof UpdateOrganizationMessagesRequestLocale)[keyof typeof UpdateOrganizationMessagesRequestLocale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrganizationMessagesRequestLocale = {
  'en-US': 'en-US',
  'he-IL': 'he-IL',
  'es-MX': 'es-MX',
  'ru-RU': 'ru-RU',
  'ar-SA': 'ar-SA',
  'es-ES': 'es-ES',
  'pt-PT': 'pt-PT',
  'es-419': 'es-419',
  'uk-UA': 'uk-UA',
  'nl-NL': 'nl-NL',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'pl-PL': 'pl-PL',
  'ka-GE': 'ka-GE',
  'el-GR': 'el-GR',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'ro-RO': 'ro-RO',
  'zu-ZA': 'zu-ZA',
  'zh-CN': 'zh-CN',
  'es-PE': 'es-PE',
  'hi-IN': 'hi-IN',
  'en-IN': 'en-IN',
  'sq-AL': 'sq-AL',
  'id-ID': 'id-ID',
  'kk-KZ': 'kk-KZ',
  'ar-AE': 'ar-AE',
  'de-DE': 'de-DE'
} as const;

/**
 * Request to update organization messages for a specific locale
 */
export interface UpdateOrganizationMessagesRequest {
  /** The locale for these messages (e.g., en-US, fr-FR, es-ES) */
  locale: UpdateOrganizationMessagesRequestLocale;
  /** Map of message keys to message texts. Only messages included will be updated/added. Use empty string to clear a message. Keys must match ProcessMessages.Messages field names. */
  messages: UpdateOrganizationMessagesRequestMessages;
}

export interface TestTypeDTO {
  iconUrl?: string;
  id?: string;
  name?: string;
}

export interface NormDTO {
  id?: string;
  title?: string;
}

export interface OrganizationNormDTO {
  defaultNorm?: NormDTO;
  isDefault?: boolean;
  testType?: TestTypeDTO;
}

export interface OrganizationNormsResponse {
  organizationNorms?: OrganizationNormDTO[];
}

export interface OrganizationNormRequestItem {
  default?: boolean;
  defaultNormId: string;
  testTypeId?: string;
}

export interface PutOrganizationNormsRequestDto {
  /** @minItems 1 */
  organizationNorms: OrganizationNormRequestItem[];
}

export interface UpdateTalentLocationsResponse {
  email?: string;
  firstName?: string;
  lastName?: string;
  locations?: LocationDTO[];
  message?: string;
  talentId?: string;
  updatedAt?: string;
}

export interface SubOrganizationDTO {
  name?: string;
  offices?: string[];
  slug?: string;
}

export interface LocationErrorDTO {
  code?: string;
  message?: string;
  slug?: string;
}

export type LocationDTOType = (typeof LocationDTOType)[keyof typeof LocationDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationDTOType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export type LocationDTOParentType = (typeof LocationDTOParentType)[keyof typeof LocationDTOParentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationDTOParentType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

export interface LocationDTO {
  errors?: LocationErrorDTO[];
  name?: string;
  offices?: string[];
  organizationName?: string;
  organizationSlug?: string;
  parent?: LocationDTO;
  parentType?: LocationDTOParentType;
  slug?: string;
  suborganization?: SubOrganizationDTO[];
  subOrganizationName?: string;
  subOrganizationSlug?: string;
  type?: LocationDTOType;
}

/**
 * Type of the location
 */
export type TalentLocationRequestDTOType =
  (typeof TalentLocationRequestDTOType)[keyof typeof TalentLocationRequestDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TalentLocationRequestDTOType = {
  ORGANIZATION: 'ORGANIZATION',
  SUB_ORGANIZATION: 'SUB_ORGANIZATION',
  FOLDER: 'FOLDER',
  SUB_FOLDER: 'SUB_FOLDER'
} as const;

/**
 * Location information for talent creation request
 */
export interface TalentLocationRequestDTO {
  /** Slug of the location */
  slug?: string;
  /** Type of the location */
  type?: TalentLocationRequestDTOType;
}

export interface UpdateTalentLocationsRequest {
  /** @minItems 1 */
  locations: TalentLocationRequestDTO[];
}

/**
 * Request to update user's Midot roles
 */
export interface UpdateUserRolesRequestDTO {
  /**
   * List of role IDs to assign to the user. Empty list will remove all roles.
   * @minItems 0
   * @maxItems 2147483647
   */
  roleIds: string[];
}

/**
 * Response for phone update OTP request
 */
export interface UpdatePhoneResponse {
  /** ISO date when a new OTP can be requested for a different number */
  changePhoneAllowedAt?: string;
  /** ISO date when the OTP expires */
  expiresAt?: string;
  /** ISO date when a new OTP can be requested for the same number */
  resendAllowedAt?: string;
}

/**
 * Request to update phone number with OTP verification
 */
export interface UpdatePhoneRequest {
  /**
   * Phone number in E.164 format
   * @minLength 1
   * @pattern ^\+[1-9]\d{1,14}$
   */
  phone: string;
  /**
   * Token received via email verification link
   * @minLength 1
   */
  token: string;
}

/**
 * Requests or re-requests that a code gets sent via text message to the provided phone number for verification.
- The code is valid for 5 minutes
- A new code for the same number can be requested after 60 seconds
- A new code for another number can be requested instantly for the first change, then every 120 seconds
- Requesting a new code invalidates the previous one
- Decoded base64 example

 * @deprecated
 * @summary Request an OTP for phone verification
 */
export const useRequestPhoneOtpHook = () => {
  const requestPhoneOtp = useCustomAxios<UpdatePhoneResponse>();

  return useCallback(
    (userId: string, updatePhoneRequest: UpdatePhoneRequest) => {
      return requestPhoneOtp({
        url: `/v1/users/${userId}/phone`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updatePhoneRequest
      });
    },
    [requestPhoneOtp]
  );
};

export const useRequestPhoneOtpMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRequestPhoneOtpHook>>>,
    TError,
    { userId: string; data: UpdatePhoneRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRequestPhoneOtpHook>>>,
  TError,
  { userId: string; data: UpdatePhoneRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const requestPhoneOtp = useRequestPhoneOtpHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRequestPhoneOtpHook>>>,
    { userId: string; data: UpdatePhoneRequest }
  > = props => {
    const { userId, data } = props ?? {};

    return requestPhoneOtp(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPhoneOtpMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRequestPhoneOtpHook>>>>;
export type RequestPhoneOtpMutationBody = UpdatePhoneRequest;
export type RequestPhoneOtpMutationError = unknown;

/**
 * @deprecated
 * @summary Request an OTP for phone verification
 */
export const useRequestPhoneOtp = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRequestPhoneOtpHook>>>,
    TError,
    { userId: string; data: UpdatePhoneRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRequestPhoneOtpHook>>>,
  TError,
  { userId: string; data: UpdatePhoneRequest },
  TContext
> => {
  const mutationOptions = useRequestPhoneOtpMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates a user's roles by replacing all current roles with the provided ones.
This endpoint is used for updating the complete role set for a user.
Empty role list will remove all roles from the user.
Only Global Admins can update user roles.

 * @summary Update user's roles
 */
export const useUpdateUserMidotRolesHook = () => {
  const updateUserMidotRoles = useCustomAxios<void>();

  return useCallback(
    (userId: string, updateUserRolesRequestDTO: UpdateUserRolesRequestDTO) => {
      return updateUserMidotRoles({
        url: `/v1/users/${userId}/midot-roles`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateUserRolesRequestDTO
      });
    },
    [updateUserMidotRoles]
  );
};

export const useUpdateUserMidotRolesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserMidotRolesHook>>>,
    TError,
    { userId: string; data: UpdateUserRolesRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserMidotRolesHook>>>,
  TError,
  { userId: string; data: UpdateUserRolesRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateUserMidotRoles = useUpdateUserMidotRolesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserMidotRolesHook>>>,
    { userId: string; data: UpdateUserRolesRequestDTO }
  > = props => {
    const { userId, data } = props ?? {};

    return updateUserMidotRoles(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMidotRolesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserMidotRolesHook>>>
>;
export type UpdateUserMidotRolesMutationBody = UpdateUserRolesRequestDTO;
export type UpdateUserMidotRolesMutationError = unknown;

/**
 * @summary Update user's roles
 */
export const useUpdateUserMidotRoles = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserMidotRolesHook>>>,
    TError,
    { userId: string; data: UpdateUserRolesRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserMidotRolesHook>>>,
  TError,
  { userId: string; data: UpdateUserRolesRequestDTO },
  TContext
> => {
  const mutationOptions = useUpdateUserMidotRolesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update the locations associated with a specific talent. This will replace all existing locations with the new ones provided.
 * @summary Update talent locations
 */
export const useUpdateTalentLocationsHook = () => {
  const updateTalentLocations = useCustomAxios<UpdateTalentLocationsResponse>();

  return useCallback(
    (organizationSlug: string, talentId: string, updateTalentLocationsRequest: UpdateTalentLocationsRequest) => {
      return updateTalentLocations({
        url: `/v1/organizations/${organizationSlug}/talents/${talentId}/locations`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateTalentLocationsRequest
      });
    },
    [updateTalentLocations]
  );
};

export const useUpdateTalentLocationsMutationOptions = <
  TError = UpdateTalentLocations500,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentLocationsHook>>>,
    TError,
    { organizationSlug: string; talentId: string; data: UpdateTalentLocationsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentLocationsHook>>>,
  TError,
  { organizationSlug: string; talentId: string; data: UpdateTalentLocationsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateTalentLocations = useUpdateTalentLocationsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentLocationsHook>>>,
    { organizationSlug: string; talentId: string; data: UpdateTalentLocationsRequest }
  > = props => {
    const { organizationSlug, talentId, data } = props ?? {};

    return updateTalentLocations(organizationSlug, talentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTalentLocationsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentLocationsHook>>>
>;
export type UpdateTalentLocationsMutationBody = UpdateTalentLocationsRequest;
export type UpdateTalentLocationsMutationError = UpdateTalentLocations500;

/**
 * @summary Update talent locations
 */
export const useUpdateTalentLocations = <TError = UpdateTalentLocations500, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentLocationsHook>>>,
    TError,
    { organizationSlug: string; talentId: string; data: UpdateTalentLocationsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentLocationsHook>>>,
  TError,
  { organizationSlug: string; talentId: string; data: UpdateTalentLocationsRequest },
  TContext
> => {
  const mutationOptions = useUpdateTalentLocationsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the mapping of catalog items (tests) to norms for a suborganization, including default norm for 'all other tests'.
 * @summary Get suborganization norms configuration
 */
export const useGetSuborganizationNormsHook = () => {
  const getSuborganizationNorms = useCustomAxios<OrganizationNormsResponse>();

  return useCallback(
    (organizationSlug: string, suborganizationSlug: string, signal?: AbortSignal) => {
      return getSuborganizationNorms({
        url: `/v1/organizations/${organizationSlug}/suborganizations/${suborganizationSlug}/norms`,
        method: 'GET',
        signal
      });
    },
    [getSuborganizationNorms]
  );
};

export const getGetSuborganizationNormsQueryKey = (organizationSlug: string, suborganizationSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/suborganizations/${suborganizationSlug}/norms`] as const;
};

export const useGetSuborganizationNormsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  suborganizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuborganizationNormsQueryKey(organizationSlug, suborganizationSlug);

  const getSuborganizationNorms = useGetSuborganizationNormsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>> = ({ signal }) =>
    getSuborganizationNorms(organizationSlug, suborganizationSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationSlug && suborganizationSlug),
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetSuborganizationNormsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>
>;
export type GetSuborganizationNormsQueryError = unknown;

/**
 * @summary Get suborganization norms configuration
 */

export function useGetSuborganizationNorms<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  suborganizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationNormsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSuborganizationNormsQueryOptions(organizationSlug, suborganizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Redefines all norms for the target suborganization. Existing norms are fully replaced by the provided set. Each norm entry can be either a default norm (for 'all other tests') or a catalog-specific norm.
 * @summary Update suborganization norms configuration
 */
export const useUpdateSuborganizationNormsHook = () => {
  const updateSuborganizationNorms = useCustomAxios<OrganizationNormsResponse>();

  return useCallback(
    (
      organizationSlug: string,
      suborganizationSlug: string,
      putOrganizationNormsRequestDto: PutOrganizationNormsRequestDto
    ) => {
      return updateSuborganizationNorms({
        url: `/v1/organizations/${organizationSlug}/suborganizations/${suborganizationSlug}/norms`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: putOrganizationNormsRequestDto
      });
    },
    [updateSuborganizationNorms]
  );
};

export const useUpdateSuborganizationNormsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationNormsHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string; data: PutOrganizationNormsRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationNormsHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string; data: PutOrganizationNormsRequestDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateSuborganizationNorms = useUpdateSuborganizationNormsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationNormsHook>>>,
    { organizationSlug: string; suborganizationSlug: string; data: PutOrganizationNormsRequestDto }
  > = props => {
    const { organizationSlug, suborganizationSlug, data } = props ?? {};

    return updateSuborganizationNorms(organizationSlug, suborganizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSuborganizationNormsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationNormsHook>>>
>;
export type UpdateSuborganizationNormsMutationBody = PutOrganizationNormsRequestDto;
export type UpdateSuborganizationNormsMutationError = unknown;

/**
 * @summary Update suborganization norms configuration
 */
export const useUpdateSuborganizationNorms = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationNormsHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string; data: PutOrganizationNormsRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationNormsHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string; data: PutOrganizationNormsRequestDto },
  TContext
> => {
  const mutationOptions = useUpdateSuborganizationNormsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the mapping of catalog items (tests) to norms for an organization, including default norm for 'all other tests'.
 * @summary Get organization norms configuration
 */
export const useGetOrganizationNormsHook = () => {
  const getOrganizationNorms = useCustomAxios<OrganizationNormsResponse>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return getOrganizationNorms({ url: `/v1/organizations/${organizationSlug}/norms`, method: 'GET', signal });
    },
    [getOrganizationNorms]
  );
};

export const getGetOrganizationNormsQueryKey = (organizationSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/norms`] as const;
};

export const useGetOrganizationNormsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationNormsQueryKey(organizationSlug);

  const getOrganizationNorms = useGetOrganizationNormsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>> = ({ signal }) =>
    getOrganizationNorms(organizationSlug, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationNormsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>
>;
export type GetOrganizationNormsQueryError = unknown;

/**
 * @summary Get organization norms configuration
 */

export function useGetOrganizationNorms<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationNormsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationNormsQueryOptions(organizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Redefines all norms for the target organization. Existing norms are fully replaced by the provided set. Each norm entry can be either a default norm (for 'all other tests') or a catalog-specific norm.
 * @summary Update organization norms configuration
 */
export const useUpdateOrganizationNormsHook = () => {
  const updateOrganizationNorms = useCustomAxios<OrganizationNormsResponse>();

  return useCallback(
    (organizationSlug: string, putOrganizationNormsRequestDto: PutOrganizationNormsRequestDto) => {
      return updateOrganizationNorms({
        url: `/v1/organizations/${organizationSlug}/norms`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: putOrganizationNormsRequestDto
      });
    },
    [updateOrganizationNorms]
  );
};

export const useUpdateOrganizationNormsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationNormsHook>>>,
    TError,
    { organizationSlug: string; data: PutOrganizationNormsRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationNormsHook>>>,
  TError,
  { organizationSlug: string; data: PutOrganizationNormsRequestDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateOrganizationNorms = useUpdateOrganizationNormsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationNormsHook>>>,
    { organizationSlug: string; data: PutOrganizationNormsRequestDto }
  > = props => {
    const { organizationSlug, data } = props ?? {};

    return updateOrganizationNorms(organizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationNormsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationNormsHook>>>
>;
export type UpdateOrganizationNormsMutationBody = PutOrganizationNormsRequestDto;
export type UpdateOrganizationNormsMutationError = unknown;

/**
 * @summary Update organization norms configuration
 */
export const useUpdateOrganizationNorms = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationNormsHook>>>,
    TError,
    { organizationSlug: string; data: PutOrganizationNormsRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationNormsHook>>>,
  TError,
  { organizationSlug: string; data: PutOrganizationNormsRequestDto },
  TContext
> => {
  const mutationOptions = useUpdateOrganizationNormsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get the default process messages set for this organization in the requested language. If the language is not available, returns the default language.
 * @summary Get organization process messages
 */
export const useGetOrganizationMessagesHook = () => {
  const getOrganizationMessages = useCustomAxios<ProcessMessages>();

  return useCallback(
    (organizationSlug: string, params?: GetOrganizationMessagesParams, signal?: AbortSignal) => {
      return getOrganizationMessages({
        url: `/v1/organizations/${organizationSlug}/messages`,
        method: 'GET',
        params,
        signal
      });
    },
    [getOrganizationMessages]
  );
};

export const getGetOrganizationMessagesQueryKey = (
  organizationSlug: string,
  params?: GetOrganizationMessagesParams
) => {
  return [`/v1/organizations/${organizationSlug}/messages`, ...(params ? [params] : [])] as const;
};

export const useGetOrganizationMessagesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params?: GetOrganizationMessagesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationMessagesQueryKey(organizationSlug, params);

  const getOrganizationMessages = useGetOrganizationMessagesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>> = ({ signal }) =>
    getOrganizationMessages(organizationSlug, params, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationMessagesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>
>;
export type GetOrganizationMessagesQueryError = unknown;

/**
 * @summary Get organization process messages
 */

export function useGetOrganizationMessages<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params?: GetOrganizationMessagesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationMessagesHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationMessagesQueryOptions(organizationSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update or add custom process messages for an organization in a specific locale. Only the message keys provided will be updated - other messages remain unchanged. Only MIDOT_ADMIN users can update organization messages.
 * @summary Update organization process messages
 */
export const useUpdateOrganizationMessagesHook = () => {
  const updateOrganizationMessages = useCustomAxios<ProcessMessages>();

  return useCallback(
    (organizationSlug: string, updateOrganizationMessagesRequest: UpdateOrganizationMessagesRequest) => {
      return updateOrganizationMessages({
        url: `/v1/organizations/${organizationSlug}/messages`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateOrganizationMessagesRequest
      });
    },
    [updateOrganizationMessages]
  );
};

export const useUpdateOrganizationMessagesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationMessagesHook>>>,
    TError,
    { organizationSlug: string; data: UpdateOrganizationMessagesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationMessagesHook>>>,
  TError,
  { organizationSlug: string; data: UpdateOrganizationMessagesRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateOrganizationMessages = useUpdateOrganizationMessagesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationMessagesHook>>>,
    { organizationSlug: string; data: UpdateOrganizationMessagesRequest }
  > = props => {
    const { organizationSlug, data } = props ?? {};

    return updateOrganizationMessages(organizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMessagesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationMessagesHook>>>
>;
export type UpdateOrganizationMessagesMutationBody = UpdateOrganizationMessagesRequest;
export type UpdateOrganizationMessagesMutationError = unknown;

/**
 * @summary Update organization process messages
 */
export const useUpdateOrganizationMessages = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationMessagesHook>>>,
    TError,
    { organizationSlug: string; data: UpdateOrganizationMessagesRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationMessagesHook>>>,
  TError,
  { organizationSlug: string; data: UpdateOrganizationMessagesRequest },
  TContext
> => {
  const mutationOptions = useUpdateOrganizationMessagesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update or add global process messages that serve as defaults for all organizations. Only the message keys provided will be updated - other messages remain unchanged. Only MIDOT_ADMIN users can update global messages.
 * @summary Update global process messages
 */
export const useUpdateGlobalMessagesHook = () => {
  const updateGlobalMessages = useCustomAxios<ProcessMessages>();

  return useCallback(
    (updateOrganizationMessagesRequest: UpdateOrganizationMessagesRequest) => {
      return updateGlobalMessages({
        url: `/v1/organizations/messages/global`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateOrganizationMessagesRequest
      });
    },
    [updateGlobalMessages]
  );
};

export const useUpdateGlobalMessagesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateGlobalMessagesHook>>>,
    TError,
    { data: UpdateOrganizationMessagesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateGlobalMessagesHook>>>,
  TError,
  { data: UpdateOrganizationMessagesRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateGlobalMessages = useUpdateGlobalMessagesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateGlobalMessagesHook>>>,
    { data: UpdateOrganizationMessagesRequest }
  > = props => {
    const { data } = props ?? {};

    return updateGlobalMessages(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGlobalMessagesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateGlobalMessagesHook>>>
>;
export type UpdateGlobalMessagesMutationBody = UpdateOrganizationMessagesRequest;
export type UpdateGlobalMessagesMutationError = unknown;

/**
 * @summary Update global process messages
 */
export const useUpdateGlobalMessages = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateGlobalMessagesHook>>>,
    TError,
    { data: UpdateOrganizationMessagesRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateGlobalMessagesHook>>>,
  TError,
  { data: UpdateOrganizationMessagesRequest },
  TContext
> => {
  const mutationOptions = useUpdateGlobalMessagesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useGetAccountHook = () => {
  const getAccount = useCustomAxios<GetAccount200>();

  return useCallback(
    (accountId: string, signal?: AbortSignal) => {
      return getAccount({ url: `/api/rbac-demo/accounts/${accountId}`, method: 'GET', signal });
    },
    [getAccount]
  );
};

export const getGetAccountQueryKey = (accountId: string) => {
  return [`/api/rbac-demo/accounts/${accountId}`] as const;
};

export const useGetAccountQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>,
  TError = unknown
>(
  accountId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountQueryKey(accountId);

  const getAccount = useGetAccountHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>> = ({ signal }) =>
    getAccount(accountId, signal);

  return { queryKey, queryFn, enabled: !!accountId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>>;
export type GetAccountQueryError = unknown;

export function useGetAccount<TData = Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>, TError = unknown>(
  accountId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetAccountQueryOptions(accountId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useEditAccountHook = () => {
  const editAccount = useCustomAxios<EditAccount200>();

  return useCallback(
    (accountId: string, editAccountBody: EditAccountBody) => {
      return editAccount({
        url: `/api/rbac-demo/accounts/${accountId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: editAccountBody
      });
    },
    [editAccount]
  );
};

export const useEditAccountMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useEditAccountHook>>>,
    TError,
    { accountId: string; data: EditAccountBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useEditAccountHook>>>,
  TError,
  { accountId: string; data: EditAccountBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const editAccount = useEditAccountHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useEditAccountHook>>>,
    { accountId: string; data: EditAccountBody }
  > = props => {
    const { accountId, data } = props ?? {};

    return editAccount(accountId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditAccountMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useEditAccountHook>>>>;
export type EditAccountMutationBody = EditAccountBody;
export type EditAccountMutationError = unknown;

export const useEditAccount = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useEditAccountHook>>>,
    TError,
    { accountId: string; data: EditAccountBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useEditAccountHook>>>,
  TError,
  { accountId: string; data: EditAccountBody },
  TContext
> => {
  const mutationOptions = useEditAccountMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useTranslateHook = () => {
  const translate = useCustomAxios<string>();

  return useCallback(
    (translateBody: string, signal?: AbortSignal) => {
      return translate({
        url: `/v1/util/translate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: translateBody,
        signal
      });
    },
    [translate]
  );
};

export const useTranslateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTranslateHook>>>,
    TError,
    { data: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTranslateHook>>>,
  TError,
  { data: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const translate = useTranslateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTranslateHook>>>,
    { data: string }
  > = props => {
    const { data } = props ?? {};

    return translate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranslateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTranslateHook>>>>;
export type TranslateMutationBody = string;
export type TranslateMutationError = unknown;

export const useTranslate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTranslateHook>>>,
    TError,
    { data: string },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useTranslateHook>>>, TError, { data: string }, TContext> => {
  const mutationOptions = useTranslateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Request that the user gets sent an email with a link to update and verify a new phone number.

 * @deprecated
 * @summary Request a phone number update
 */
export const useRequestPhoneNumberUpdateHook = () => {
  const requestPhoneNumberUpdate = useCustomAxios<void>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return requestPhoneNumberUpdate({ url: `/v1/users/${userId}/update-phone`, method: 'POST', signal });
    },
    [requestPhoneNumberUpdate]
  );
};

export const useRequestPhoneNumberUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRequestPhoneNumberUpdateHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRequestPhoneNumberUpdateHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const requestPhoneNumberUpdate = useRequestPhoneNumberUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRequestPhoneNumberUpdateHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return requestPhoneNumberUpdate(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPhoneNumberUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRequestPhoneNumberUpdateHook>>>
>;

export type RequestPhoneNumberUpdateMutationError = unknown;

/**
 * @deprecated
 * @summary Request a phone number update
 */
export const useRequestPhoneNumberUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRequestPhoneNumberUpdateHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRequestPhoneNumberUpdateHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useRequestPhoneNumberUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an ON_HOLD user to ACTIVE. Only Midot administrators can perform this action.
 * @summary Resume a user from hold
 */
export const useResumeUserHook = () => {
  const resumeUser = useCustomAxios<void>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return resumeUser({ url: `/v1/users/${userId}/resume`, method: 'POST', signal });
    },
    [resumeUser]
  );
};

export const useResumeUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useResumeUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const resumeUser = useResumeUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useResumeUserHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return resumeUser(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useResumeUserHook>>>>;

export type ResumeUserMutationError = void;

/**
 * @summary Resume a user from hold
 */
export const useResumeUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useResumeUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useResumeUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Verifies the OTP code sent to the phone number.
- The code must match the one sent
- The phone number must match the one the code was sent to
- The code must not be expired (5 minutes)
- The token must be valid

 * @deprecated
 * @summary Verify phone number OTP
 */
export const useVerifyPhoneOtpHook = () => {
  const verifyPhoneOtp = useCustomAxios<void>();

  return useCallback(
    (userId: string, verifyPhoneRequest: VerifyPhoneRequest, signal?: AbortSignal) => {
      return verifyPhoneOtp({
        url: `/v1/users/${userId}/phone/verify`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: verifyPhoneRequest,
        signal
      });
    },
    [verifyPhoneOtp]
  );
};

export const useVerifyPhoneOtpMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVerifyPhoneOtpHook>>>,
    TError,
    { userId: string; data: VerifyPhoneRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useVerifyPhoneOtpHook>>>,
  TError,
  { userId: string; data: VerifyPhoneRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const verifyPhoneOtp = useVerifyPhoneOtpHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useVerifyPhoneOtpHook>>>,
    { userId: string; data: VerifyPhoneRequest }
  > = props => {
    const { userId, data } = props ?? {};

    return verifyPhoneOtp(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPhoneOtpMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useVerifyPhoneOtpHook>>>>;
export type VerifyPhoneOtpMutationBody = VerifyPhoneRequest;
export type VerifyPhoneOtpMutationError = unknown;

/**
 * @deprecated
 * @summary Verify phone number OTP
 */
export const useVerifyPhoneOtp = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useVerifyPhoneOtpHook>>>,
    TError,
    { userId: string; data: VerifyPhoneRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useVerifyPhoneOtpHook>>>,
  TError,
  { userId: string; data: VerifyPhoneRequest },
  TContext
> => {
  const mutationOptions = useVerifyPhoneOtpMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active user to ON_HOLD. Only Midot administrators can perform this action.
 * @summary Put a user on hold
 */
export const useHoldUserHook = () => {
  const holdUser = useCustomAxios<void>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return holdUser({ url: `/v1/users/${userId}/hold`, method: 'POST', signal });
    },
    [holdUser]
  );
};

export const useHoldUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHoldUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const holdUser = useHoldUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHoldUserHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return holdUser(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHoldUserHook>>>>;

export type HoldUserMutationError = void;

/**
 * @summary Put a user on hold
 */
export const useHoldUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHoldUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useHoldUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active user to INACTIVE. Midot users can only be deactivated by Midot admins. Client users can be deactivated by Org admins (in their own organization).
 * @summary Deactivate a user
 */
export const useDeactivateUserHook = () => {
  const deactivateUser = useCustomAxios<void>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return deactivateUser({ url: `/v1/users/${userId}/deactivate`, method: 'POST', signal });
    },
    [deactivateUser]
  );
};

export const useDeactivateUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeactivateUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deactivateUser = useDeactivateUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeactivateUserHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return deactivateUser(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeactivateUserHook>>>>;

export type DeactivateUserMutationError = void;

/**
 * @summary Deactivate a user
 */
export const useDeactivateUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeactivateUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useDeactivateUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Switches the user's status to ACTIVE. If called on self, only works if status is Onboarding. If called on someone else, only works if called by Midot Admin and if user status is On Hold, Inactive, or Onboarding.
 * @summary Activate a user
 */
export const useActivateUserHook = () => {
  const activateUser = useCustomAxios<void>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return activateUser({ url: `/v1/users/${userId}/activate`, method: 'POST', signal });
    },
    [activateUser]
  );
};

export const useActivateUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useActivateUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const activateUser = useActivateUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useActivateUserHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return activateUser(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useActivateUserHook>>>>;

export type ActivateUserMutationError = void;

/**
 * @summary Activate a user
 */
export const useActivateUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useActivateUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useActivateUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Assigns roles to users in specified locations. Users can be referenced by ID (existing users) or email (existing users only). Returns 202 Accepted when the request is successfully queued.
 * @summary Create role assignments for users
 */
export const useCreateRoleAssignmentsHook = () => {
  const createRoleAssignments = useCustomAxios<void>();

  return useCallback(
    (createRoleAssignmentsRequestDTO: CreateRoleAssignmentsRequestDTO, signal?: AbortSignal) => {
      return createRoleAssignments({
        url: `/v1/users/role-assignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createRoleAssignmentsRequestDTO,
        signal
      });
    },
    [createRoleAssignments]
  );
};

export const useCreateRoleAssignmentsMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateRoleAssignmentsHook>>>,
    TError,
    { data: CreateRoleAssignmentsRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateRoleAssignmentsHook>>>,
  TError,
  { data: CreateRoleAssignmentsRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createRoleAssignments = useCreateRoleAssignmentsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateRoleAssignmentsHook>>>,
    { data: CreateRoleAssignmentsRequestDTO }
  > = props => {
    const { data } = props ?? {};

    return createRoleAssignments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoleAssignmentsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateRoleAssignmentsHook>>>
>;
export type CreateRoleAssignmentsMutationBody = CreateRoleAssignmentsRequestDTO;
export type CreateRoleAssignmentsMutationError = ErrorResponse;

/**
 * @summary Create role assignments for users
 */
export const useCreateRoleAssignments = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateRoleAssignmentsHook>>>,
    TError,
    { data: CreateRoleAssignmentsRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateRoleAssignmentsHook>>>,
  TError,
  { data: CreateRoleAssignmentsRequestDTO },
  TContext
> => {
  const mutationOptions = useCreateRoleAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Triggers recalculation for a test session in CALCULATING or COMPLETED status. Refreshes Redis data and re-invokes the calculator via player-backend.
 * @summary Reanalyze a test session
 */
export const useReanalyzeTestSessionHook = () => {
  const reanalyzeTestSession = useCustomAxios<void>();

  return useCallback(
    (testSessionId: string, signal?: AbortSignal) => {
      return reanalyzeTestSession({ url: `/v1/test-sessions/${testSessionId}/reanalyze`, method: 'POST', signal });
    },
    [reanalyzeTestSession]
  );
};

export const useReanalyzeTestSessionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReanalyzeTestSessionHook>>>,
    TError,
    { testSessionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useReanalyzeTestSessionHook>>>,
  TError,
  { testSessionId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const reanalyzeTestSession = useReanalyzeTestSessionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useReanalyzeTestSessionHook>>>,
    { testSessionId: string }
  > = props => {
    const { testSessionId } = props ?? {};

    return reanalyzeTestSession(testSessionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReanalyzeTestSessionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReanalyzeTestSessionHook>>>
>;

export type ReanalyzeTestSessionMutationError = void;

/**
 * @summary Reanalyze a test session
 */
export const useReanalyzeTestSession = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReanalyzeTestSessionHook>>>,
    TError,
    { testSessionId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useReanalyzeTestSessionHook>>>,
  TError,
  { testSessionId: string },
  TContext
> => {
  const mutationOptions = useReanalyzeTestSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the status of a talent. Used by player-backend to update talent status after exam completion.
 * @summary Update talent status
 */
export const useUpdateTalentStatusHook = () => {
  const updateTalentStatus = useCustomAxios<void>();

  return useCallback(
    (talentId: string, updateTalentStatusRequest: UpdateTalentStatusRequest, signal?: AbortSignal) => {
      return updateTalentStatus({
        url: `/v1/talents/${talentId}/status`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateTalentStatusRequest,
        signal
      });
    },
    [updateTalentStatus]
  );
};

export const useUpdateTalentStatusMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentStatusHook>>>,
    TError,
    { talentId: string; data: UpdateTalentStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentStatusHook>>>,
  TError,
  { talentId: string; data: UpdateTalentStatusRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateTalentStatus = useUpdateTalentStatusHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentStatusHook>>>,
    { talentId: string; data: UpdateTalentStatusRequest }
  > = props => {
    const { talentId, data } = props ?? {};

    return updateTalentStatus(talentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTalentStatusMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentStatusHook>>>
>;
export type UpdateTalentStatusMutationBody = UpdateTalentStatusRequest;
export type UpdateTalentStatusMutationError = void;

/**
 * @summary Update talent status
 */
export const useUpdateTalentStatus = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentStatusHook>>>,
    TError,
    { talentId: string; data: UpdateTalentStatusRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentStatusHook>>>,
  TError,
  { talentId: string; data: UpdateTalentStatusRequest },
  TContext
> => {
  const mutationOptions = useUpdateTalentStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Add a test template to a specific process
 */
export const useAddTestTemplateToProcessHook = () => {
  const addTestTemplateToProcess = useCustomAxios<ProcessDTO>();

  return useCallback(
    (processId: string, testTemplateId: string, testTemplateDTO: TestTemplateDTO, signal?: AbortSignal) => {
      return addTestTemplateToProcess({
        url: `/v1/talents/${processId}/test-templates/${testTemplateId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: testTemplateDTO,
        signal
      });
    },
    [addTestTemplateToProcess]
  );
};

export const useAddTestTemplateToProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddTestTemplateToProcessHook>>>,
    TError,
    { processId: string; testTemplateId: string; data: TestTemplateDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAddTestTemplateToProcessHook>>>,
  TError,
  { processId: string; testTemplateId: string; data: TestTemplateDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const addTestTemplateToProcess = useAddTestTemplateToProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAddTestTemplateToProcessHook>>>,
    { processId: string; testTemplateId: string; data: TestTemplateDTO }
  > = props => {
    const { processId, testTemplateId, data } = props ?? {};

    return addTestTemplateToProcess(processId, testTemplateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTestTemplateToProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAddTestTemplateToProcessHook>>>
>;
export type AddTestTemplateToProcessMutationBody = TestTemplateDTO;
export type AddTestTemplateToProcessMutationError = string;

/**
 * @summary Add a test template to a specific process
 */
export const useAddTestTemplateToProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddTestTemplateToProcessHook>>>,
    TError,
    { processId: string; testTemplateId: string; data: TestTemplateDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAddTestTemplateToProcessHook>>>,
  TError,
  { processId: string; testTemplateId: string; data: TestTemplateDTO },
  TContext
> => {
  const mutationOptions = useAddTestTemplateToProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve all processes associated with a specific talent, including test session summaries.
 * @summary Get processes for a specific talent
 */
export const useGetTalentProcessesHook = () => {
  const getTalentProcesses = useCustomAxios<TalentProcessesResponseDTO>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getTalentProcesses({ url: `/v1/talents/${id}/processes`, method: 'GET', signal });
    },
    [getTalentProcesses]
  );
};

export const getGetTalentProcessesQueryKey = (id: string) => {
  return [`/v1/talents/${id}/processes`] as const;
};

export const useGetTalentProcessesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>,
  TError = TalentProcessesResponseDTO
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTalentProcessesQueryKey(id);

  const getTalentProcesses = useGetTalentProcessesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>> = ({ signal }) =>
    getTalentProcesses(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTalentProcessesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>
>;
export type GetTalentProcessesQueryError = TalentProcessesResponseDTO;

/**
 * @summary Get processes for a specific talent
 */

export function useGetTalentProcesses<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>,
  TError = TalentProcessesResponseDTO
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentProcessesHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTalentProcessesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds the talent to the specified processes. If the talent is already in a process or the process is in a final state, no error is returned. Active processes will trigger an invite.
 * @summary Add talent to processes
 */
export const useAddTalentToProcessesHook = () => {
  const addTalentToProcesses = useCustomAxios<void>();

  return useCallback(
    (id: string, talentAddProcessesRequestDTO: TalentAddProcessesRequestDTO, signal?: AbortSignal) => {
      return addTalentToProcesses({
        url: `/v1/talents/${id}/processes`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentAddProcessesRequestDTO,
        signal
      });
    },
    [addTalentToProcesses]
  );
};

export const useAddTalentToProcessesMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddTalentToProcessesHook>>>,
    TError,
    { id: string; data: TalentAddProcessesRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAddTalentToProcessesHook>>>,
  TError,
  { id: string; data: TalentAddProcessesRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const addTalentToProcesses = useAddTalentToProcessesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAddTalentToProcessesHook>>>,
    { id: string; data: TalentAddProcessesRequestDTO }
  > = props => {
    const { id, data } = props ?? {};

    return addTalentToProcesses(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTalentToProcessesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAddTalentToProcessesHook>>>
>;
export type AddTalentToProcessesMutationBody = TalentAddProcessesRequestDTO;
export type AddTalentToProcessesMutationError = void;

/**
 * @summary Add talent to processes
 */
export const useAddTalentToProcesses = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddTalentToProcessesHook>>>,
    TError,
    { id: string; data: TalentAddProcessesRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAddTalentToProcessesHook>>>,
  TError,
  { id: string; data: TalentAddProcessesRequestDTO },
  TContext
> => {
  const mutationOptions = useAddTalentToProcessesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Validates talent data without creating or updating the talent. Returns whether the talent can be created and the reason if not.
 * @summary Validate talent data
 */
export const useValidateTalentHook = () => {
  const validateTalent = useCustomAxios<TalentValidationResponse>();

  return useCallback(
    (talentCreateDTO: TalentCreateDTO, signal?: AbortSignal) => {
      return validateTalent({
        url: `/v1/talents/validate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentCreateDTO,
        signal
      });
    },
    [validateTalent]
  );
};

export const useValidateTalentMutationOptions = <TError = TalentValidationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateTalentHook>>>,
    TError,
    { data: TalentCreateDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useValidateTalentHook>>>,
  TError,
  { data: TalentCreateDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const validateTalent = useValidateTalentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useValidateTalentHook>>>,
    { data: TalentCreateDTO }
  > = props => {
    const { data } = props ?? {};

    return validateTalent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateTalentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidateTalentHook>>>>;
export type ValidateTalentMutationBody = TalentCreateDTO;
export type ValidateTalentMutationError = TalentValidationResponse;

/**
 * @summary Validate talent data
 */
export const useValidateTalent = <TError = TalentValidationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateTalentHook>>>,
    TError,
    { data: TalentCreateDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useValidateTalentHook>>>,
  TError,
  { data: TalentCreateDTO },
  TContext
> => {
  const mutationOptions = useValidateTalentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the status of a talent and associated process based on test session completion. Updates the talent status, process status, and process invitation with completion information. **Authorization:** Only Midot administrators can access this endpoint.
 * @summary Update talent test session status
 */
export const useUpdateTestSessionStatusHook = () => {
  const updateTestSessionStatus = useCustomAxios<void>();

  return useCallback(
    (talentTestSessionStatusRequestDTO: TalentTestSessionStatusRequestDTO, signal?: AbortSignal) => {
      return updateTestSessionStatus({
        url: `/v1/talents/test-session/status`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentTestSessionStatusRequestDTO,
        signal
      });
    },
    [updateTestSessionStatus]
  );
};

export const useUpdateTestSessionStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTestSessionStatusHook>>>,
    TError,
    { data: TalentTestSessionStatusRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateTestSessionStatusHook>>>,
  TError,
  { data: TalentTestSessionStatusRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateTestSessionStatus = useUpdateTestSessionStatusHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateTestSessionStatusHook>>>,
    { data: TalentTestSessionStatusRequestDTO }
  > = props => {
    const { data } = props ?? {};

    return updateTestSessionStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTestSessionStatusMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateTestSessionStatusHook>>>
>;
export type UpdateTestSessionStatusMutationBody = TalentTestSessionStatusRequestDTO;
export type UpdateTestSessionStatusMutationError = unknown;

/**
 * @summary Update talent test session status
 */
export const useUpdateTestSessionStatus = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTestSessionStatusHook>>>,
    TError,
    { data: TalentTestSessionStatusRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateTestSessionStatusHook>>>,
  TError,
  { data: TalentTestSessionStatusRequestDTO },
  TContext
> => {
  const mutationOptions = useUpdateTestSessionStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fetch a list of talents based on provided search criteria in the request body.
 * @summary Get list of talents
 */
export const useFilterTalentsHook = () => {
  const filterTalents = useCustomAxios<TalentsResponseDTO>();

  return useCallback(
    (talentListRequestDTO: TalentListRequestDTO, params?: FilterTalentsParams, signal?: AbortSignal) => {
      return filterTalents({
        url: `/v1/talents/filter`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentListRequestDTO,
        params,
        signal
      });
    },
    [filterTalents]
  );
};

export const getFilterTalentsQueryKey = (talentListRequestDTO: TalentListRequestDTO, params?: FilterTalentsParams) => {
  return [`/v1/talents/filter`, ...(params ? [params] : []), talentListRequestDTO] as const;
};

export const useFilterTalentsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>,
  TError = unknown
>(
  talentListRequestDTO: TalentListRequestDTO,
  params?: FilterTalentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilterTalentsQueryKey(talentListRequestDTO, params);

  const filterTalents = useFilterTalentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>> = ({ signal }) =>
    filterTalents(talentListRequestDTO, params, signal);

  const customOptions = useCustomFilterTalentsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { talentListRequestDTO, params },
    { url: `/v1/talents/filter` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilterTalentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>
>;
export type FilterTalentsInfiniteQueryError = unknown;

/**
 * @summary Get list of talents
 */

export function useFilterTalentsInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>,
  TError = unknown
>(
  talentListRequestDTO: TalentListRequestDTO,
  params?: FilterTalentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>, TError, TData>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useFilterTalentsInfiniteQueryOptions(talentListRequestDTO, params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useFilterTalentsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>,
  TError = unknown
>(
  talentListRequestDTO: TalentListRequestDTO,
  params?: FilterTalentsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilterTalentsQueryKey(talentListRequestDTO, params);

  const filterTalents = useFilterTalentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>> = ({ signal }) =>
    filterTalents(talentListRequestDTO, params, signal);

  const customOptions = useCustomFilterTalentsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { talentListRequestDTO, params },
    { url: `/v1/talents/filter` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilterTalentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>>;
export type FilterTalentsQueryError = unknown;

/**
 * @summary Get list of talents
 */

export function useFilterTalents<
  TData = Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>,
  TError = unknown
>(
  talentListRequestDTO: TalentListRequestDTO,
  params?: FilterTalentsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterTalentsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useFilterTalentsQueryOptions(talentListRequestDTO, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a folder to a sub-organization
 */
export const useAddFolderToSubOrganizationHook = () => {
  const addFolderToSubOrganization = useCustomAxios<SubOrganization>();

  return useCallback(
    (subOrgId: string, folder: Folder, signal?: AbortSignal) => {
      return addFolderToSubOrganization({
        url: `/v1/suborganizations/${subOrgId}/folders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: folder,
        signal
      });
    },
    [addFolderToSubOrganization]
  );
};

export const useAddFolderToSubOrganizationMutationOptions = <TError = SubOrganization, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddFolderToSubOrganizationHook>>>,
    TError,
    { subOrgId: string; data: Folder },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAddFolderToSubOrganizationHook>>>,
  TError,
  { subOrgId: string; data: Folder },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const addFolderToSubOrganization = useAddFolderToSubOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAddFolderToSubOrganizationHook>>>,
    { subOrgId: string; data: Folder }
  > = props => {
    const { subOrgId, data } = props ?? {};

    return addFolderToSubOrganization(subOrgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddFolderToSubOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAddFolderToSubOrganizationHook>>>
>;
export type AddFolderToSubOrganizationMutationBody = Folder;
export type AddFolderToSubOrganizationMutationError = SubOrganization;

/**
 * @summary Add a folder to a sub-organization
 */
export const useAddFolderToSubOrganization = <TError = SubOrganization, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddFolderToSubOrganizationHook>>>,
    TError,
    { subOrgId: string; data: Folder },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAddFolderToSubOrganizationHook>>>,
  TError,
  { subOrgId: string; data: Folder },
  TContext
> => {
  const mutationOptions = useAddFolderToSubOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useLogoutHook = () => {
  const logout = useCustomAxios<Logout200>();

  return useCallback(
    (params: LogoutParams, signal?: AbortSignal) => {
      return logout({ url: `/v1/simple-auth/logout`, method: 'POST', params, signal });
    },
    [logout]
  );
};

export const useLogoutMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
    TError,
    { params: LogoutParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
  TError,
  { params: LogoutParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const logout = useLogoutHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
    { params: LogoutParams }
  > = props => {
    const { params } = props ?? {};

    return logout(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>>;

export type LogoutMutationError = unknown;

export const useLogout = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
    TError,
    { params: LogoutParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLogoutHook>>>,
  TError,
  { params: LogoutParams },
  TContext
> => {
  const mutationOptions = useLogoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useLoginHook = () => {
  const login = useCustomAxios<Login200>();

  return useCallback(
    (loginRequest: LoginRequest, signal?: AbortSignal) => {
      return login({
        url: `/v1/simple-auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginRequest,
        signal
      });
    },
    [login]
  );
};

export const useLoginMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    TError,
    { data: LoginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
  TError,
  { data: LoginRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const login = useLoginHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    { data: LoginRequest }
  > = props => {
    const { data } = props ?? {};

    return login(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLoginHook>>>>;
export type LoginMutationBody = LoginRequest;
export type LoginMutationError = unknown;

export const useLogin = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    TError,
    { data: LoginRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
  TError,
  { data: LoginRequest },
  TContext
> => {
  const mutationOptions = useLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useConvertJwtToSessionHook = () => {
  const convertJwtToSession = useCustomAxios<ConvertJwtToSession200>();

  return useCallback(
    (jwtRequest: JwtRequest, signal?: AbortSignal) => {
      return convertJwtToSession({
        url: `/v1/simple-auth/convert-jwt`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: jwtRequest,
        signal
      });
    },
    [convertJwtToSession]
  );
};

export const useConvertJwtToSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useConvertJwtToSessionHook>>>,
    TError,
    { data: JwtRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useConvertJwtToSessionHook>>>,
  TError,
  { data: JwtRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const convertJwtToSession = useConvertJwtToSessionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useConvertJwtToSessionHook>>>,
    { data: JwtRequest }
  > = props => {
    const { data } = props ?? {};

    return convertJwtToSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConvertJwtToSessionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useConvertJwtToSessionHook>>>
>;
export type ConvertJwtToSessionMutationBody = JwtRequest;
export type ConvertJwtToSessionMutationError = unknown;

export const useConvertJwtToSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useConvertJwtToSessionHook>>>,
    TError,
    { data: JwtRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useConvertJwtToSessionHook>>>,
  TError,
  { data: JwtRequest },
  TContext
> => {
  const mutationOptions = useConvertJwtToSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new process using the provided request data.
 * @summary Create a new process
 */
export const useCreateProcessHook = () => {
  const createProcess = useCustomAxios<ProcessResponseDTO>();

  return useCallback(
    (createProcessRequestDto: CreateProcessRequestDto, signal?: AbortSignal) => {
      return createProcess({
        url: `/v1/processes`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createProcessRequestDto,
        signal
      });
    },
    [createProcess]
  );
};

export const useCreateProcessMutationOptions = <
  TError = CreateProcess400 | CreateProcess500,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateProcessHook>>>,
    TError,
    { data: CreateProcessRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateProcessHook>>>,
  TError,
  { data: CreateProcessRequestDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createProcess = useCreateProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateProcessHook>>>,
    { data: CreateProcessRequestDto }
  > = props => {
    const { data } = props ?? {};

    return createProcess(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateProcessHook>>>>;
export type CreateProcessMutationBody = CreateProcessRequestDto;
export type CreateProcessMutationError = CreateProcess400 | CreateProcess500;

/**
 * @summary Create a new process
 */
export const useCreateProcess = <TError = CreateProcess400 | CreateProcess500, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateProcessHook>>>,
    TError,
    { data: CreateProcessRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateProcessHook>>>,
  TError,
  { data: CreateProcessRequestDto },
  TContext
> => {
  const mutationOptions = useCreateProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the talent registration form including questions, answers, and translations.
 * @summary Get talent registration form answers
 */
export const useGetTalentRegistrationFormHook = () => {
  const getTalentRegistrationForm = useCustomAxios<TalentRegistrationFormAnswersDto>();

  return useCallback(
    (processId: string, talentId: string, signal?: AbortSignal) => {
      return getTalentRegistrationForm({
        url: `/v1/processes/${processId}/talents/${talentId}/talent-registration-form`,
        method: 'GET',
        signal
      });
    },
    [getTalentRegistrationForm]
  );
};

export const getGetTalentRegistrationFormQueryKey = (processId: string, talentId: string) => {
  return [`/v1/processes/${processId}/talents/${talentId}/talent-registration-form`] as const;
};

export const useGetTalentRegistrationFormQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>,
  TError = unknown
>(
  processId: string,
  talentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTalentRegistrationFormQueryKey(processId, talentId);

  const getTalentRegistrationForm = useGetTalentRegistrationFormHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>> = ({
    signal
  }) => getTalentRegistrationForm(processId, talentId, signal);

  return { queryKey, queryFn, enabled: !!(processId && talentId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTalentRegistrationFormQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>
>;
export type GetTalentRegistrationFormQueryError = unknown;

/**
 * @summary Get talent registration form answers
 */

export function useGetTalentRegistrationForm<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>,
  TError = unknown
>(
  processId: string,
  talentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentRegistrationFormHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTalentRegistrationFormQueryOptions(processId, talentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows to answer both internal and external questions of the talent registration form.
 * @summary Update the registration form answers for a talent
 */
export const useUpdateTalentRegistrationFormHook = () => {
  const updateTalentRegistrationForm = useCustomAxios<void>();

  return useCallback(
    (
      processId: string,
      talentId: string,
      answerTalentRegistrationFormDto: AnswerTalentRegistrationFormDto,
      signal?: AbortSignal
    ) => {
      return updateTalentRegistrationForm({
        url: `/v1/processes/${processId}/talents/${talentId}/talent-registration-form`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: answerTalentRegistrationFormDto,
        signal
      });
    },
    [updateTalentRegistrationForm]
  );
};

export const useUpdateTalentRegistrationFormMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentRegistrationFormHook>>>,
    TError,
    { processId: string; talentId: string; data: AnswerTalentRegistrationFormDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentRegistrationFormHook>>>,
  TError,
  { processId: string; talentId: string; data: AnswerTalentRegistrationFormDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateTalentRegistrationForm = useUpdateTalentRegistrationFormHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentRegistrationFormHook>>>,
    { processId: string; talentId: string; data: AnswerTalentRegistrationFormDto }
  > = props => {
    const { processId, talentId, data } = props ?? {};

    return updateTalentRegistrationForm(processId, talentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTalentRegistrationFormMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentRegistrationFormHook>>>
>;
export type UpdateTalentRegistrationFormMutationBody = AnswerTalentRegistrationFormDto;
export type UpdateTalentRegistrationFormMutationError = unknown;

/**
 * @summary Update the registration form answers for a talent
 */
export const useUpdateTalentRegistrationForm = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentRegistrationFormHook>>>,
    TError,
    { processId: string; talentId: string; data: AnswerTalentRegistrationFormDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentRegistrationFormHook>>>,
  TError,
  { processId: string; talentId: string; data: AnswerTalentRegistrationFormDto },
  TContext
> => {
  const mutationOptions = useUpdateTalentRegistrationFormMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sends an invite to a specific talent and/or returns a link or password. If the talent hasn't been added to the process before, this endpoint will add them as well. The process must not be Unpublished or On Hold. Requires process admin access (MIDOT_ADMIN, ORGANIZATION_ADMIN, KAM for assigned orgs, CS for assigned offices, or Location Admin for assigned locations).
 * @summary Invite a single talent to a process
 */
export const useInviteTalentToProcessHook = () => {
  const inviteTalentToProcess = useCustomAxios<ProcessTalentInvitationResponse>();

  return useCallback(
    (
      processId: string,
      talentId: string,
      processTalentInvitationRequest: ProcessTalentInvitationRequest,
      signal?: AbortSignal
    ) => {
      return inviteTalentToProcess({
        url: `/v1/processes/${processId}/talents/${talentId}/invite`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: processTalentInvitationRequest,
        signal
      });
    },
    [inviteTalentToProcess]
  );
};

export const useInviteTalentToProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInviteTalentToProcessHook>>>,
    TError,
    { processId: string; talentId: string; data: ProcessTalentInvitationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInviteTalentToProcessHook>>>,
  TError,
  { processId: string; talentId: string; data: ProcessTalentInvitationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const inviteTalentToProcess = useInviteTalentToProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInviteTalentToProcessHook>>>,
    { processId: string; talentId: string; data: ProcessTalentInvitationRequest }
  > = props => {
    const { processId, talentId, data } = props ?? {};

    return inviteTalentToProcess(processId, talentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteTalentToProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInviteTalentToProcessHook>>>
>;
export type InviteTalentToProcessMutationBody = ProcessTalentInvitationRequest;
export type InviteTalentToProcessMutationError = string;

/**
 * @summary Invite a single talent to a process
 */
export const useInviteTalentToProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInviteTalentToProcessHook>>>,
    TError,
    { processId: string; talentId: string; data: ProcessTalentInvitationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInviteTalentToProcessHook>>>,
  TError,
  { processId: string; talentId: string; data: ProcessTalentInvitationRequest },
  TContext
> => {
  const mutationOptions = useInviteTalentToProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the list of files associated with a specific process and talent by fetching metadata from AWS.
 * @summary List files for a process and talent
 */
export const useListProcessTalentFilesHook = () => {
  const listProcessTalentFiles = useCustomAxios<ProcessTalentFilesResponseDTO>();

  return useCallback(
    (processId: string, talentId: string, signal?: AbortSignal) => {
      return listProcessTalentFiles({
        url: `/v1/processes/${processId}/talents/${talentId}/files`,
        method: 'GET',
        signal
      });
    },
    [listProcessTalentFiles]
  );
};

export const getListProcessTalentFilesQueryKey = (processId: string, talentId: string) => {
  return [`/v1/processes/${processId}/talents/${talentId}/files`] as const;
};

export const useListProcessTalentFilesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>,
  TError = unknown
>(
  processId: string,
  talentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProcessTalentFilesQueryKey(processId, talentId);

  const listProcessTalentFiles = useListProcessTalentFilesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>> = ({ signal }) =>
    listProcessTalentFiles(processId, talentId, signal);

  return { queryKey, queryFn, enabled: !!(processId && talentId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProcessTalentFilesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>
>;
export type ListProcessTalentFilesQueryError = unknown;

/**
 * @summary List files for a process and talent
 */

export function useListProcessTalentFiles<
  TData = Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>,
  TError = unknown
>(
  processId: string,
  talentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProcessTalentFilesHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useListProcessTalentFilesQueryOptions(processId, talentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a file and store it in the S3 bucket under a specific folder for the given process and talent.
 * @summary Upload a file for a specific process and talent
 */
export const useUploadFileHook = () => {
  const uploadFile = useCustomAxios<ProcessTalentFileUploadResponseDTO>();

  return useCallback(
    (processId: string, talentId: string, uploadFileBody: UploadFileBody, signal?: AbortSignal) => {
      const formData = new FormData();
      formData.append('file', uploadFileBody.file);

      return uploadFile({
        url: `/v1/processes/${processId}/talents/${talentId}/files`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        signal
      });
    },
    [uploadFile]
  );
};

export const useUploadFileMutationOptions = <
  TError = ProcessTalentFileUploadResponseDTO,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadFileHook>>>,
    TError,
    { processId: string; talentId: string; data: UploadFileBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUploadFileHook>>>,
  TError,
  { processId: string; talentId: string; data: UploadFileBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const uploadFile = useUploadFileHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUploadFileHook>>>,
    { processId: string; talentId: string; data: UploadFileBody }
  > = props => {
    const { processId, talentId, data } = props ?? {};

    return uploadFile(processId, talentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUploadFileHook>>>>;
export type UploadFileMutationBody = UploadFileBody;
export type UploadFileMutationError = ProcessTalentFileUploadResponseDTO;

/**
 * @summary Upload a file for a specific process and talent
 */
export const useUploadFile = <TError = ProcessTalentFileUploadResponseDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadFileHook>>>,
    TError,
    { processId: string; talentId: string; data: UploadFileBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUploadFileHook>>>,
  TError,
  { processId: string; talentId: string; data: UploadFileBody },
  TContext
> => {
  const mutationOptions = useUploadFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sends invites to talents and/or returns link or password. If talents haven't been added to the process before, this endpoint will add them as well. As opposed to Add talents to a process, this endpoint doesn't work when the Process is Unpublished or On Hold because invites can't be sent.
 * @summary Invite talents to a process
 */
export const useInviteTalentsToProcessHook = () => {
  const inviteTalentsToProcess = useCustomAxios<ProcessInvitationResponse>();

  return useCallback(
    (processId: string, processInvitationRequest: ProcessInvitationRequest, signal?: AbortSignal) => {
      return inviteTalentsToProcess({
        url: `/v1/processes/${processId}/invite`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: processInvitationRequest,
        signal
      });
    },
    [inviteTalentsToProcess]
  );
};

export const useInviteTalentsToProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInviteTalentsToProcessHook>>>,
    TError,
    { processId: string; data: ProcessInvitationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInviteTalentsToProcessHook>>>,
  TError,
  { processId: string; data: ProcessInvitationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const inviteTalentsToProcess = useInviteTalentsToProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInviteTalentsToProcessHook>>>,
    { processId: string; data: ProcessInvitationRequest }
  > = props => {
    const { processId, data } = props ?? {};

    return inviteTalentsToProcess(processId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteTalentsToProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInviteTalentsToProcessHook>>>
>;
export type InviteTalentsToProcessMutationBody = ProcessInvitationRequest;
export type InviteTalentsToProcessMutationError = string;

/**
 * @summary Invite talents to a process
 */
export const useInviteTalentsToProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInviteTalentsToProcessHook>>>,
    TError,
    { processId: string; data: ProcessInvitationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInviteTalentsToProcessHook>>>,
  TError,
  { processId: string; data: ProcessInvitationRequest },
  TContext
> => {
  const mutationOptions = useInviteTalentsToProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Adds one test definition to a process as the last array item. If refinements are needed, returns required refinement options.
 * @summary Add a test definition to a process
 */
export const useAddCatalogItemToProcessHook = () => {
  const addCatalogItemToProcess = useCustomAxios<AddProcessCatalogItemsResponse>();

  return useCallback(
    (processId: string, addProcessCatalogItemsRequest: AddProcessCatalogItemsRequest, signal?: AbortSignal) => {
      return addCatalogItemToProcess({
        url: `/v1/processes/${processId}/catalog-items`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addProcessCatalogItemsRequest,
        signal
      });
    },
    [addCatalogItemToProcess]
  );
};

export const useAddCatalogItemToProcessMutationOptions = <
  TError = AddProcessCatalogItemsResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddCatalogItemToProcessHook>>>,
    TError,
    { processId: string; data: AddProcessCatalogItemsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAddCatalogItemToProcessHook>>>,
  TError,
  { processId: string; data: AddProcessCatalogItemsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const addCatalogItemToProcess = useAddCatalogItemToProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAddCatalogItemToProcessHook>>>,
    { processId: string; data: AddProcessCatalogItemsRequest }
  > = props => {
    const { processId, data } = props ?? {};

    return addCatalogItemToProcess(processId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCatalogItemToProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAddCatalogItemToProcessHook>>>
>;
export type AddCatalogItemToProcessMutationBody = AddProcessCatalogItemsRequest;
export type AddCatalogItemToProcessMutationError = AddProcessCatalogItemsResponse;

/**
 * @summary Add a test definition to a process
 */
export const useAddCatalogItemToProcess = <TError = AddProcessCatalogItemsResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddCatalogItemToProcessHook>>>,
    TError,
    { processId: string; data: AddProcessCatalogItemsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAddCatalogItemToProcessHook>>>,
  TError,
  { processId: string; data: AddProcessCatalogItemsRequest },
  TContext
> => {
  const mutationOptions = useAddCatalogItemToProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the order of catalog items for a specific process. The request must contain all catalog items currently attached to the process in a new order. No new catalog items can be added, and none can be removed.
 * @summary Reorder catalog items in a process
 */
export const useUpdateProcessCatalogItemOrderHook = () => {
  const updateProcessCatalogItemOrder = useCustomAxios<UpdateProcessCatalogItemsResponse>();

  return useCallback(
    (processId: string, updateProcessCatalogItemsRequest: UpdateProcessCatalogItemsRequest) => {
      return updateProcessCatalogItemOrder({
        url: `/v1/processes/${processId}/catalog-items`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateProcessCatalogItemsRequest
      });
    },
    [updateProcessCatalogItemOrder]
  );
};

export const useUpdateProcessCatalogItemOrderMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessCatalogItemOrderHook>>>,
    TError,
    { processId: string; data: UpdateProcessCatalogItemsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessCatalogItemOrderHook>>>,
  TError,
  { processId: string; data: UpdateProcessCatalogItemsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateProcessCatalogItemOrder = useUpdateProcessCatalogItemOrderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessCatalogItemOrderHook>>>,
    { processId: string; data: UpdateProcessCatalogItemsRequest }
  > = props => {
    const { processId, data } = props ?? {};

    return updateProcessCatalogItemOrder(processId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProcessCatalogItemOrderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessCatalogItemOrderHook>>>
>;
export type UpdateProcessCatalogItemOrderMutationBody = UpdateProcessCatalogItemsRequest;
export type UpdateProcessCatalogItemOrderMutationError = string;

/**
 * @summary Reorder catalog items in a process
 */
export const useUpdateProcessCatalogItemOrder = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessCatalogItemOrderHook>>>,
    TError,
    { processId: string; data: UpdateProcessCatalogItemsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessCatalogItemOrderHook>>>,
  TError,
  { processId: string; data: UpdateProcessCatalogItemsRequest },
  TContext
> => {
  const mutationOptions = useUpdateProcessCatalogItemOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fetch a list of talents associated with a specific process. Supports optional search, sorting, and pagination. Optionally includes stats if requested.
 * @summary Get talents for a specific process
 */
export const useGetProcessTalentsHook = () => {
  const getProcessTalents = useCustomAxios<PagedProcessTalentsResponseDTO>();

  return useCallback(
    (id: string, params?: GetProcessTalentsParams, signal?: AbortSignal) => {
      return getProcessTalents({ url: `/v1/processes/${id}/talents`, method: 'GET', params, signal });
    },
    [getProcessTalents]
  );
};

export const getGetProcessTalentsQueryKey = (id: string, params?: GetProcessTalentsParams) => {
  return [`/v1/processes/${id}/talents`, ...(params ? [params] : [])] as const;
};

export const useGetProcessTalentsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>,
  TError = unknown
>(
  id: string,
  params?: GetProcessTalentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessTalentsQueryKey(id, params);

  const getProcessTalents = useGetProcessTalentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>> = ({ signal }) =>
    getProcessTalents(id, params, signal);

  const customOptions = useCustomGetProcessTalentsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    { url: `/v1/processes/${id}/talents` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessTalentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>
>;
export type GetProcessTalentsInfiniteQueryError = unknown;

/**
 * @summary Get talents for a specific process
 */

export function useGetProcessTalentsInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>,
  TError = unknown
>(
  id: string,
  params?: GetProcessTalentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>, TError, TData>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessTalentsInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetProcessTalentsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>,
  TError = unknown
>(
  id: string,
  params?: GetProcessTalentsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessTalentsQueryKey(id, params);

  const getProcessTalents = useGetProcessTalentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>> = ({ signal }) =>
    getProcessTalents(id, params, signal);

  const customOptions = useCustomGetProcessTalentsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    { url: `/v1/processes/${id}/talents` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessTalentsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>
>;
export type GetProcessTalentsQueryError = unknown;

/**
 * @summary Get talents for a specific process
 */

export function useGetProcessTalents<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>,
  TError = unknown
>(
  id: string,
  params?: GetProcessTalentsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessTalentsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add talents to a process. Only allowed if:
- User is Midot ADMIN, Client ADMIN, or Client OTHER
- Process is not in a final state

Once the talents are added, they will receive invites if the process is active and they haven't been invited before.
 * @summary Add talents to a process
 */
export const useAddTalentsToProcessHook = () => {
  const addTalentsToProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, processAddTalentsRequest: ProcessAddTalentsRequest, signal?: AbortSignal) => {
      return addTalentsToProcess({
        url: `/v1/processes/${id}/talents`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: processAddTalentsRequest,
        signal
      });
    },
    [addTalentsToProcess]
  );
};

export const useAddTalentsToProcessMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddTalentsToProcessHook>>>,
    TError,
    { id: string; data: ProcessAddTalentsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAddTalentsToProcessHook>>>,
  TError,
  { id: string; data: ProcessAddTalentsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const addTalentsToProcess = useAddTalentsToProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAddTalentsToProcessHook>>>,
    { id: string; data: ProcessAddTalentsRequest }
  > = props => {
    const { id, data } = props ?? {};

    return addTalentsToProcess(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTalentsToProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAddTalentsToProcessHook>>>
>;
export type AddTalentsToProcessMutationBody = ProcessAddTalentsRequest;
export type AddTalentsToProcessMutationError = void;

/**
 * @summary Add talents to a process
 */
export const useAddTalentsToProcess = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddTalentsToProcessHook>>>,
    TError,
    { id: string; data: ProcessAddTalentsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAddTalentsToProcessHook>>>,
  TError,
  { id: string; data: ProcessAddTalentsRequest },
  TContext
> => {
  const mutationOptions = useAddTalentsToProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Remove talents from a process. Only allowed if:
- User is Midot ADMIN, Client ADMIN, or Client OTHER
- Process is not completed
- Talents have not started their tests
 * @summary Remove talents from a process
 */
export const useRemoveTalentsFromProcessHook = () => {
  const removeTalentsFromProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, deleteProcessTalentsDTO: DeleteProcessTalentsDTO) => {
      return removeTalentsFromProcess({
        url: `/v1/processes/${id}/talents`,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        data: deleteProcessTalentsDTO
      });
    },
    [removeTalentsFromProcess]
  );
};

export const useRemoveTalentsFromProcessMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveTalentsFromProcessHook>>>,
    TError,
    { id: string; data: DeleteProcessTalentsDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRemoveTalentsFromProcessHook>>>,
  TError,
  { id: string; data: DeleteProcessTalentsDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const removeTalentsFromProcess = useRemoveTalentsFromProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRemoveTalentsFromProcessHook>>>,
    { id: string; data: DeleteProcessTalentsDTO }
  > = props => {
    const { id, data } = props ?? {};

    return removeTalentsFromProcess(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTalentsFromProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRemoveTalentsFromProcessHook>>>
>;
export type RemoveTalentsFromProcessMutationBody = DeleteProcessTalentsDTO;
export type RemoveTalentsFromProcessMutationError = void;

/**
 * @summary Remove talents from a process
 */
export const useRemoveTalentsFromProcess = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveTalentsFromProcessHook>>>,
    TError,
    { id: string; data: DeleteProcessTalentsDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRemoveTalentsFromProcessHook>>>,
  TError,
  { id: string; data: DeleteProcessTalentsDTO },
  TContext
> => {
  const mutationOptions = useRemoveTalentsFromProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the talent registration form structure for a given process ID, including all internal and external questions.
 * @summary Get the talent registration form for a process
 */
export const useGetProcessTalentRegistrationFormHook = () => {
  const getProcessTalentRegistrationForm = useCustomAxios<TalentRegistrationFormAnswersDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getProcessTalentRegistrationForm({
        url: `/v1/processes/${id}/talent-registration-form`,
        method: 'GET',
        signal
      });
    },
    [getProcessTalentRegistrationForm]
  );
};

export const getGetProcessTalentRegistrationFormQueryKey = (id: string) => {
  return [`/v1/processes/${id}/talent-registration-form`] as const;
};

export const useGetProcessTalentRegistrationFormQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessTalentRegistrationFormQueryKey(id);

  const getProcessTalentRegistrationForm = useGetProcessTalentRegistrationFormHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>> = ({
    signal
  }) => getProcessTalentRegistrationForm(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessTalentRegistrationFormQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>
>;
export type GetProcessTalentRegistrationFormQueryError = unknown;

/**
 * @summary Get the talent registration form for a process
 */

export function useGetProcessTalentRegistrationForm<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetProcessTalentRegistrationFormHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessTalentRegistrationFormQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Saves or updates the talent registration questions form structure for a given process ID. This includes all internal and external questions.
 * @summary Update the talent registration questions form for an organization
 */
export const useUpdateProcessTalentRegistrationQuestionsFormHook = () => {
  const updateProcessTalentRegistrationQuestionsForm = useCustomAxios<void>();

  return useCallback(
    (id: string, talentRegistrationFormAnswersDto: TalentRegistrationFormAnswersDto, signal?: AbortSignal) => {
      return updateProcessTalentRegistrationQuestionsForm({
        url: `/v1/processes/${id}/talent-registration-form`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentRegistrationFormAnswersDto,
        signal
      });
    },
    [updateProcessTalentRegistrationQuestionsForm]
  );
};

export const useUpdateProcessTalentRegistrationQuestionsFormMutationOptions = <
  TError = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessTalentRegistrationQuestionsFormHook>>>,
    TError,
    { id: string; data: TalentRegistrationFormAnswersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessTalentRegistrationQuestionsFormHook>>>,
  TError,
  { id: string; data: TalentRegistrationFormAnswersDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateProcessTalentRegistrationQuestionsForm = useUpdateProcessTalentRegistrationQuestionsFormHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessTalentRegistrationQuestionsFormHook>>>,
    { id: string; data: TalentRegistrationFormAnswersDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateProcessTalentRegistrationQuestionsForm(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProcessTalentRegistrationQuestionsFormMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessTalentRegistrationQuestionsFormHook>>>
>;
export type UpdateProcessTalentRegistrationQuestionsFormMutationBody = TalentRegistrationFormAnswersDto;
export type UpdateProcessTalentRegistrationQuestionsFormMutationError = void;

/**
 * @summary Update the talent registration questions form for an organization
 */
export const useUpdateProcessTalentRegistrationQuestionsForm = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessTalentRegistrationQuestionsFormHook>>>,
    TError,
    { id: string; data: TalentRegistrationFormAnswersDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessTalentRegistrationQuestionsFormHook>>>,
  TError,
  { id: string; data: TalentRegistrationFormAnswersDto },
  TContext
> => {
  const mutationOptions = useUpdateProcessTalentRegistrationQuestionsFormMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Changes the status of an 'On Hold' process to 'Active' and sends invitations to newly added talents.
 * @summary Resume a process
 */
export const useResumeProcessHook = () => {
  const resumeProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return resumeProcess({ url: `/v1/processes/${id}/resume`, method: 'POST', signal });
    },
    [resumeProcess]
  );
};

export const useResumeProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useResumeProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const resumeProcess = useResumeProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useResumeProcessHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return resumeProcess(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useResumeProcessHook>>>>;

export type ResumeProcessMutationError = string;

/**
 * @summary Resume a process
 */
export const useResumeProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useResumeProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useResumeProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Changes the process status to 'Active' and sends invitations via email to all associated talents. Only works on unpublished processes.
 * @summary Publish an unpublished process asynchronously
 */
export const usePublishProcessHook = () => {
  const publishProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return publishProcess({ url: `/v1/processes/${id}/publish`, method: 'POST', signal });
    },
    [publishProcess]
  );
};

export const usePublishProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePublishProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePublishProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const publishProcess = usePublishProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePublishProcessHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return publishProcess(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePublishProcessHook>>>>;

export type PublishProcessMutationError = string;

/**
 * @summary Publish an unpublished process asynchronously
 */
export const usePublishProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePublishProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePublishProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = usePublishProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Changes the status of an active process to 'On Hold'.
 * @summary Hold an active process
 */
export const useHoldProcessHook = () => {
  const holdProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return holdProcess({ url: `/v1/processes/${id}/hold`, method: 'POST', signal });
    },
    [holdProcess]
  );
};

export const useHoldProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHoldProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const holdProcess = useHoldProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHoldProcessHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return holdProcess(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHoldProcessHook>>>>;

export type HoldProcessMutationError = string;

/**
 * @summary Hold an active process
 */
export const useHoldProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useHoldProcessHook>>>, TError, { id: string }, TContext> => {
  const mutationOptions = useHoldProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Changes the status of an active or on-hold process to 'Completed'.
 * @summary Complete a process
 */
export const useCompleteProcessHook = () => {
  const completeProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return completeProcess({ url: `/v1/processes/${id}/complete`, method: 'POST', signal });
    },
    [completeProcess]
  );
};

export const useCompleteProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCompleteProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCompleteProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const completeProcess = useCompleteProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCompleteProcessHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return completeProcess(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCompleteProcessHook>>>>;

export type CompleteProcessMutationError = string;

/**
 * @summary Complete a process
 */
export const useCompleteProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCompleteProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCompleteProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useCompleteProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Changes the status of an unpublished process to 'Cancelled'.
 * @summary Cancel a process
 */
export const useCancelProcessHook = () => {
  const cancelProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return cancelProcess({ url: `/v1/processes/${id}/cancel`, method: 'POST', signal });
    },
    [cancelProcess]
  );
};

export const useCancelProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCancelProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const cancelProcess = useCancelProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCancelProcessHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return cancelProcess(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCancelProcessHook>>>>;

export type CancelProcessMutationError = string;

/**
 * @summary Cancel a process
 */
export const useCancelProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelProcessHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCancelProcessHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useCancelProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fetches a list of processes based on the provided query parameters. The process.locations filter must be an array of objects (each with slug and type). Returned processes are always restricted to locations that the current user has access to; user type determines which locations are allowed (e.g. ADMIN/BASIC by assigned locations, ORGANIZATION_ADMIN by org, KAM by assigned orgs, CS by offices).
 * @summary Retrieve processes with advanced query filtering
 */
export const useFilterProcessesHook = () => {
  const filterProcesses = useCustomAxios<ProcessResponseDTO[]>();

  return useCallback(
    (processQueryDTO: ProcessQueryDTO, signal?: AbortSignal) => {
      return filterProcesses({
        url: `/v1/processes/filter`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: processQueryDTO,
        signal
      });
    },
    [filterProcesses]
  );
};

export const getFilterProcessesQueryKey = (processQueryDTO: ProcessQueryDTO) => {
  return [`/v1/processes/filter`, processQueryDTO] as const;
};

export const useFilterProcessesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>,
  TError = string
>(
  processQueryDTO: ProcessQueryDTO,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilterProcessesQueryKey(processQueryDTO);

  const filterProcesses = useFilterProcessesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>> = ({ signal }) =>
    filterProcesses(processQueryDTO, signal);

  const customOptions = useCustomFilterProcessesQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { processQueryDTO },
    { url: `/v1/processes/filter` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilterProcessesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>
>;
export type FilterProcessesInfiniteQueryError = string;

/**
 * @summary Retrieve processes with advanced query filtering
 */

export function useFilterProcessesInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>,
  TError = string
>(
  processQueryDTO: ProcessQueryDTO,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>, TError, TData>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useFilterProcessesInfiniteQueryOptions(processQueryDTO, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useFilterProcessesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>,
  TError = string
>(
  processQueryDTO: ProcessQueryDTO,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilterProcessesQueryKey(processQueryDTO);

  const filterProcesses = useFilterProcessesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>> = ({ signal }) =>
    filterProcesses(processQueryDTO, signal);

  const customOptions = useCustomFilterProcessesQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { processQueryDTO },
    { url: `/v1/processes/filter` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilterProcessesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>>;
export type FilterProcessesQueryError = string;

/**
 * @summary Retrieve processes with advanced query filtering
 */

export function useFilterProcesses<
  TData = Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>,
  TError = string
>(
  processQueryDTO: ProcessQueryDTO,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterProcessesHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useFilterProcessesQueryOptions(processQueryDTO, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a draft organization. Only the name is mandatory. The other fields are optional and only validated if present. Organization admins are not invited at this time.
 * @summary Create a draft organization
 */
export const useCreateDraftOrganizationHook = () => {
  const createDraftOrganization = useCustomAxios<CreateOrganizationResponseDto>();

  return useCallback(
    (createOrganizationRequest: CreateOrganizationRequest, signal?: AbortSignal) => {
      return createDraftOrganization({
        url: `/v1/organizations`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createOrganizationRequest,
        signal
      });
    },
    [createDraftOrganization]
  );
};

export const useCreateDraftOrganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateDraftOrganizationHook>>>,
    TError,
    { data: CreateOrganizationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateDraftOrganizationHook>>>,
  TError,
  { data: CreateOrganizationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createDraftOrganization = useCreateDraftOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateDraftOrganizationHook>>>,
    { data: CreateOrganizationRequest }
  > = props => {
    const { data } = props ?? {};

    return createDraftOrganization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDraftOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateDraftOrganizationHook>>>
>;
export type CreateDraftOrganizationMutationBody = CreateOrganizationRequest;
export type CreateDraftOrganizationMutationError = void;

/**
 * @summary Create a draft organization
 */
export const useCreateDraftOrganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateDraftOrganizationHook>>>,
    TError,
    { data: CreateOrganizationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateDraftOrganizationHook>>>,
  TError,
  { data: CreateOrganizationRequest },
  TContext
> => {
  const mutationOptions = useCreateDraftOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new suborganization under the given enterprise organization. The parent organization must be an Enterprise; otherwise, returns a 403 Forbidden error.
 * @summary Create a suborganization
 */
export const useCreateSuborganizationHook = () => {
  const createSuborganization = useCustomAxios<CreateSuborganizationResponseDto>();

  return useCallback(
    (slug: string, createSuborganizationRequest: CreateSuborganizationRequest, signal?: AbortSignal) => {
      return createSuborganization({
        url: `/v1/organizations/${slug}/suborganizations`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createSuborganizationRequest,
        signal
      });
    },
    [createSuborganization]
  );
};

export const useCreateSuborganizationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateSuborganizationHook>>>,
    TError,
    { slug: string; data: CreateSuborganizationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateSuborganizationHook>>>,
  TError,
  { slug: string; data: CreateSuborganizationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createSuborganization = useCreateSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateSuborganizationHook>>>,
    { slug: string; data: CreateSuborganizationRequest }
  > = props => {
    const { slug, data } = props ?? {};

    return createSuborganization(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateSuborganizationHook>>>
>;
export type CreateSuborganizationMutationBody = CreateSuborganizationRequest;
export type CreateSuborganizationMutationError = unknown;

/**
 * @summary Create a suborganization
 */
export const useCreateSuborganization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateSuborganizationHook>>>,
    TError,
    { slug: string; data: CreateSuborganizationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateSuborganizationHook>>>,
  TError,
  { slug: string; data: CreateSuborganizationRequest },
  TContext
> => {
  const mutationOptions = useCreateSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Adds users (with roles) to the given suborganization. If the suborganization is not ACTIVE, users are recorded but not invited.
 * @summary Assign users to a suborganization
 */
export const useAssignRolesToSuborganizationHook = () => {
  const assignRolesToSuborganization = useCustomAxios<void>();

  return useCallback(
    (slug: string, subSlug: string, roleAssignmentRequestDto: RoleAssignmentRequestDto, signal?: AbortSignal) => {
      return assignRolesToSuborganization({
        url: `/v1/organizations/${slug}/suborganizations/${subSlug}/role-assignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: roleAssignmentRequestDto,
        signal
      });
    },
    [assignRolesToSuborganization]
  );
};

export const useAssignRolesToSuborganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignRolesToSuborganizationHook>>>,
    TError,
    { slug: string; subSlug: string; data: RoleAssignmentRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignRolesToSuborganizationHook>>>,
  TError,
  { slug: string; subSlug: string; data: RoleAssignmentRequestDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignRolesToSuborganization = useAssignRolesToSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignRolesToSuborganizationHook>>>,
    { slug: string; subSlug: string; data: RoleAssignmentRequestDto }
  > = props => {
    const { slug, subSlug, data } = props ?? {};

    return assignRolesToSuborganization(slug, subSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignRolesToSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignRolesToSuborganizationHook>>>
>;
export type AssignRolesToSuborganizationMutationBody = RoleAssignmentRequestDto;
export type AssignRolesToSuborganizationMutationError = void;

/**
 * @summary Assign users to a suborganization
 */
export const useAssignRolesToSuborganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignRolesToSuborganizationHook>>>,
    TError,
    { slug: string; subSlug: string; data: RoleAssignmentRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignRolesToSuborganizationHook>>>,
  TError,
  { slug: string; subSlug: string; data: RoleAssignmentRequestDto },
  TContext
> => {
  const mutationOptions = useAssignRolesToSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of a draft suborganization to ACTIVE.
 * @summary Activate a suborganization
 */
export const useActivateSuborganizationHook = () => {
  const activateSuborganization = useCustomAxios<void>();

  return useCallback(
    (slug: string, subSlug: string, signal?: AbortSignal) => {
      return activateSuborganization({
        url: `/v1/organizations/${slug}/suborganizations/${subSlug}/activate`,
        method: 'POST',
        signal
      });
    },
    [activateSuborganization]
  );
};

export const useActivateSuborganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateSuborganizationHook>>>,
    TError,
    { slug: string; subSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useActivateSuborganizationHook>>>,
  TError,
  { slug: string; subSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const activateSuborganization = useActivateSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useActivateSuborganizationHook>>>,
    { slug: string; subSlug: string }
  > = props => {
    const { slug, subSlug } = props ?? {};

    return activateSuborganization(slug, subSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useActivateSuborganizationHook>>>
>;

export type ActivateSuborganizationMutationError = void;

/**
 * @summary Activate a suborganization
 */
export const useActivateSuborganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateSuborganizationHook>>>,
    TError,
    { slug: string; subSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useActivateSuborganizationHook>>>,
  TError,
  { slug: string; subSlug: string },
  TContext
> => {
  const mutationOptions = useActivateSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new subfolder under the given organization. The request must specify a parent with a slug and type. If subfolder, cannot be more than five levels down.
 * @summary Create a subfolder for an organization
 */
export const useCreateSubFolderForOrganizationHook = () => {
  const createSubFolderForOrganization = useCustomAxios<SubFolderDto>();

  return useCallback(
    (slug: string, createSubfolderRequestBody: CreateSubfolderRequestBody, signal?: AbortSignal) => {
      return createSubFolderForOrganization({
        url: `/v1/organizations/${slug}/subfolders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createSubfolderRequestBody,
        signal
      });
    },
    [createSubFolderForOrganization]
  );
};

export const useCreateSubFolderForOrganizationMutationOptions = <TError = FolderDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateSubFolderForOrganizationHook>>>,
    TError,
    { slug: string; data: CreateSubfolderRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateSubFolderForOrganizationHook>>>,
  TError,
  { slug: string; data: CreateSubfolderRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createSubFolderForOrganization = useCreateSubFolderForOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateSubFolderForOrganizationHook>>>,
    { slug: string; data: CreateSubfolderRequestBody }
  > = props => {
    const { slug, data } = props ?? {};

    return createSubFolderForOrganization(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSubFolderForOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateSubFolderForOrganizationHook>>>
>;
export type CreateSubFolderForOrganizationMutationBody = CreateSubfolderRequestBody;
export type CreateSubFolderForOrganizationMutationError = FolderDTO;

/**
 * @summary Create a subfolder for an organization
 */
export const useCreateSubFolderForOrganization = <TError = FolderDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateSubFolderForOrganizationHook>>>,
    TError,
    { slug: string; data: CreateSubfolderRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateSubFolderForOrganizationHook>>>,
  TError,
  { slug: string; data: CreateSubfolderRequestBody },
  TContext
> => {
  const mutationOptions = useCreateSubFolderForOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Validates that the organization is still in draft, checks required draft fields, and invites all admins.
 * @summary Start onboarding an organization
 */
export const useOnboardOrganizationHook = () => {
  const onboardOrganization = useCustomAxios<void>();

  return useCallback(
    (slug: string, signal?: AbortSignal) => {
      return onboardOrganization({ url: `/v1/organizations/${slug}/onboard`, method: 'POST', signal });
    },
    [onboardOrganization]
  );
};

export const useOnboardOrganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useOnboardOrganizationHook>>>,
    TError,
    { slug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useOnboardOrganizationHook>>>,
  TError,
  { slug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const onboardOrganization = useOnboardOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useOnboardOrganizationHook>>>,
    { slug: string }
  > = props => {
    const { slug } = props ?? {};

    return onboardOrganization(slug);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useOnboardOrganizationHook>>>
>;

export type OnboardOrganizationMutationError = void;

/**
 * @summary Start onboarding an organization
 */
export const useOnboardOrganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useOnboardOrganizationHook>>>,
    TError,
    { slug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useOnboardOrganizationHook>>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationOptions = useOnboardOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new talent inside an organization. Business rules: If the talent already exists with exact same details, new locations are added. If talent exists but details differ, returns error.
 * @summary Create a new talent
 */
export const useCreateTalentHook = () => {
  const createTalent = useCustomAxios<PostTalentsResponse>();

  return useCallback(
    (organizationSlug: string, talentCreateDTO: TalentCreateDTO, params?: CreateTalentParams, signal?: AbortSignal) => {
      return createTalent({
        url: `/v1/organizations/${organizationSlug}/talents`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentCreateDTO,
        params,
        signal
      });
    },
    [createTalent]
  );
};

export const useCreateTalentMutationOptions = <
  TError = CreateTalent400 | CreateTalent404 | CreateTalent500,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateTalentHook>>>,
    TError,
    { organizationSlug: string; data: TalentCreateDTO; params?: CreateTalentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateTalentHook>>>,
  TError,
  { organizationSlug: string; data: TalentCreateDTO; params?: CreateTalentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createTalent = useCreateTalentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateTalentHook>>>,
    { organizationSlug: string; data: TalentCreateDTO; params?: CreateTalentParams }
  > = props => {
    const { organizationSlug, data, params } = props ?? {};

    return createTalent(organizationSlug, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTalentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateTalentHook>>>>;
export type CreateTalentMutationBody = TalentCreateDTO;
export type CreateTalentMutationError = CreateTalent400 | CreateTalent404 | CreateTalent500;

/**
 * @summary Create a new talent
 */
export const useCreateTalent = <
  TError = CreateTalent400 | CreateTalent404 | CreateTalent500,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateTalentHook>>>,
    TError,
    { organizationSlug: string; data: TalentCreateDTO; params?: CreateTalentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateTalentHook>>>,
  TError,
  { organizationSlug: string; data: TalentCreateDTO; params?: CreateTalentParams },
  TContext
> => {
  const mutationOptions = useCreateTalentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new talent directly in the DataProcessorService database (mongo-player)
instead of Podium's main database. This endpoint:

1. Creates the talent in DataProcessorService (mongo-player database)
2. Creates ProcessInvitation in Podium (mongo-podium)
3. Updates ProcessInvitation in DataProcessorService with podiumId reference
4. Sends invitation email with UNIQUE_LINK

Use this endpoint for external candidate registrations or temporary assessments
where full talent lifecycle management in Podium is not required.

**Note**: At least one process ID must be provided in the request.

 * @summary Create a new talent via DataProcessorService
 */
export const useCreateTalentViaDataProcessorHook = () => {
  const createTalentViaDataProcessor = useCustomAxios<PostTalentsResponse>();

  return useCallback(
    (organizationSlug: string, talentCreateDTO: TalentCreateDTO, signal?: AbortSignal) => {
      return createTalentViaDataProcessor({
        url: `/v1/organizations/${organizationSlug}/talents/via-dataprocessor`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentCreateDTO,
        signal
      });
    },
    [createTalentViaDataProcessor]
  );
};

export const useCreateTalentViaDataProcessorMutationOptions = <
  TError = CreateTalentViaDataProcessor400 | CreateTalentViaDataProcessor404 | CreateTalentViaDataProcessor500,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateTalentViaDataProcessorHook>>>,
    TError,
    { organizationSlug: string; data: TalentCreateDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateTalentViaDataProcessorHook>>>,
  TError,
  { organizationSlug: string; data: TalentCreateDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createTalentViaDataProcessor = useCreateTalentViaDataProcessorHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateTalentViaDataProcessorHook>>>,
    { organizationSlug: string; data: TalentCreateDTO }
  > = props => {
    const { organizationSlug, data } = props ?? {};

    return createTalentViaDataProcessor(organizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTalentViaDataProcessorMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateTalentViaDataProcessorHook>>>
>;
export type CreateTalentViaDataProcessorMutationBody = TalentCreateDTO;
export type CreateTalentViaDataProcessorMutationError =
  | CreateTalentViaDataProcessor400
  | CreateTalentViaDataProcessor404
  | CreateTalentViaDataProcessor500;

/**
 * @summary Create a new talent via DataProcessorService
 */
export const useCreateTalentViaDataProcessor = <
  TError = CreateTalentViaDataProcessor400 | CreateTalentViaDataProcessor404 | CreateTalentViaDataProcessor500,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateTalentViaDataProcessorHook>>>,
    TError,
    { organizationSlug: string; data: TalentCreateDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateTalentViaDataProcessorHook>>>,
  TError,
  { organizationSlug: string; data: TalentCreateDTO },
  TContext
> => {
  const mutationOptions = useCreateTalentViaDataProcessorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useDropTalentQuestionsAndTranslationsHook = () => {
  const dropTalentQuestionsAndTranslations = useCustomAxios<string>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return dropTalentQuestionsAndTranslations({
        url: `/v1/organizations/${organizationSlug}/talentQuestions/drop`,
        method: 'POST',
        signal
      });
    },
    [dropTalentQuestionsAndTranslations]
  );
};

export const useDropTalentQuestionsAndTranslationsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDropTalentQuestionsAndTranslationsHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDropTalentQuestionsAndTranslationsHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const dropTalentQuestionsAndTranslations = useDropTalentQuestionsAndTranslationsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDropTalentQuestionsAndTranslationsHook>>>,
    { organizationSlug: string }
  > = props => {
    const { organizationSlug } = props ?? {};

    return dropTalentQuestionsAndTranslations(organizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type DropTalentQuestionsAndTranslationsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDropTalentQuestionsAndTranslationsHook>>>
>;

export type DropTalentQuestionsAndTranslationsMutationError = unknown;

export const useDropTalentQuestionsAndTranslations = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDropTalentQuestionsAndTranslationsHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDropTalentQuestionsAndTranslationsHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const mutationOptions = useDropTalentQuestionsAndTranslationsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get additional talent questions for an organization
 */
export const useGetOrganizationTalentQuestionsHook = () => {
  const getOrganizationTalentQuestions = useCustomAxios<TalentQuestionsResponseDTO>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return getOrganizationTalentQuestions({
        url: `/v1/organizations/${organizationSlug}/talent-registration-form`,
        method: 'GET',
        signal
      });
    },
    [getOrganizationTalentQuestions]
  );
};

export const getGetOrganizationTalentQuestionsQueryKey = (organizationSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/talent-registration-form`] as const;
};

export const useGetOrganizationTalentQuestionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationTalentQuestionsQueryKey(organizationSlug);

  const getOrganizationTalentQuestions = useGetOrganizationTalentQuestionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>> = ({
    signal
  }) => getOrganizationTalentQuestions(organizationSlug, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationTalentQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>
>;
export type GetOrganizationTalentQuestionsQueryError = unknown;

/**
 * @summary Get additional talent questions for an organization
 */

export function useGetOrganizationTalentQuestions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrganizationTalentQuestionsHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationTalentQuestionsQueryOptions(organizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add or update talent questions and translations for an organization
 */
export const usePostOrganizationTalentQuestionsHook = () => {
  const postOrganizationTalentQuestions = useCustomAxios<unknown>();

  return useCallback(
    (organizationSlug: string, talentQuestionsResponseDTO: TalentQuestionsResponseDTO, signal?: AbortSignal) => {
      return postOrganizationTalentQuestions({
        url: `/v1/organizations/${organizationSlug}/talent-registration-form`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: talentQuestionsResponseDTO,
        signal
      });
    },
    [postOrganizationTalentQuestions]
  );
};

export const usePostOrganizationTalentQuestionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostOrganizationTalentQuestionsHook>>>,
    TError,
    { organizationSlug: string; data: TalentQuestionsResponseDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostOrganizationTalentQuestionsHook>>>,
  TError,
  { organizationSlug: string; data: TalentQuestionsResponseDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const postOrganizationTalentQuestions = usePostOrganizationTalentQuestionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostOrganizationTalentQuestionsHook>>>,
    { organizationSlug: string; data: TalentQuestionsResponseDTO }
  > = props => {
    const { organizationSlug, data } = props ?? {};

    return postOrganizationTalentQuestions(organizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationTalentQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePostOrganizationTalentQuestionsHook>>>
>;
export type PostOrganizationTalentQuestionsMutationBody = TalentQuestionsResponseDTO;
export type PostOrganizationTalentQuestionsMutationError = unknown;

/**
 * @summary Add or update talent questions and translations for an organization
 */
export const usePostOrganizationTalentQuestions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostOrganizationTalentQuestionsHook>>>,
    TError,
    { organizationSlug: string; data: TalentQuestionsResponseDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePostOrganizationTalentQuestionsHook>>>,
  TError,
  { organizationSlug: string; data: TalentQuestionsResponseDTO },
  TContext
> => {
  const mutationOptions = usePostOrganizationTalentQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an ON_HOLD suborganization back to ACTIVE.
 * @summary Resume a suborganization from hold
 */
export const useResumeSuborganizationHook = () => {
  const resumeSuborganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, suborganizationSlug: string, signal?: AbortSignal) => {
      return resumeSuborganization({
        url: `/v1/organizations/${organizationSlug}/suborganizations/${suborganizationSlug}/resume`,
        method: 'POST',
        signal
      });
    },
    [resumeSuborganization]
  );
};

export const useResumeSuborganizationMutationOptions = <TError = string | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeSuborganizationHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useResumeSuborganizationHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const resumeSuborganization = useResumeSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useResumeSuborganizationHook>>>,
    { organizationSlug: string; suborganizationSlug: string }
  > = props => {
    const { organizationSlug, suborganizationSlug } = props ?? {};

    return resumeSuborganization(organizationSlug, suborganizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useResumeSuborganizationHook>>>
>;

export type ResumeSuborganizationMutationError = string | void;

/**
 * @summary Resume a suborganization from hold
 */
export const useResumeSuborganization = <TError = string | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeSuborganizationHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useResumeSuborganizationHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string },
  TContext
> => {
  const mutationOptions = useResumeSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active suborganization to ON_HOLD.
 * @summary Put a suborganization on hold
 */
export const useHoldSuborganizationHook = () => {
  const holdSuborganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, suborganizationSlug: string, signal?: AbortSignal) => {
      return holdSuborganization({
        url: `/v1/organizations/${organizationSlug}/suborganizations/${suborganizationSlug}/hold`,
        method: 'POST',
        signal
      });
    },
    [holdSuborganization]
  );
};

export const useHoldSuborganizationMutationOptions = <TError = string | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldSuborganizationHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHoldSuborganizationHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const holdSuborganization = useHoldSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHoldSuborganizationHook>>>,
    { organizationSlug: string; suborganizationSlug: string }
  > = props => {
    const { organizationSlug, suborganizationSlug } = props ?? {};

    return holdSuborganization(organizationSlug, suborganizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHoldSuborganizationHook>>>
>;

export type HoldSuborganizationMutationError = string | void;

/**
 * @summary Put a suborganization on hold
 */
export const useHoldSuborganization = <TError = string | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldSuborganizationHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHoldSuborganizationHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string },
  TContext
> => {
  const mutationOptions = useHoldSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active suborganization to INACTIVE.
 * @summary Deactivate a suborganization
 */
export const useDeactivateSuborganizationHook = () => {
  const deactivateSuborganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, suborganizationSlug: string, signal?: AbortSignal) => {
      return deactivateSuborganization({
        url: `/v1/organizations/${organizationSlug}/suborganizations/${suborganizationSlug}/deactivate`,
        method: 'POST',
        signal
      });
    },
    [deactivateSuborganization]
  );
};

export const useDeactivateSuborganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateSuborganizationHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeactivateSuborganizationHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deactivateSuborganization = useDeactivateSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeactivateSuborganizationHook>>>,
    { organizationSlug: string; suborganizationSlug: string }
  > = props => {
    const { organizationSlug, suborganizationSlug } = props ?? {};

    return deactivateSuborganization(organizationSlug, suborganizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeactivateSuborganizationHook>>>
>;

export type DeactivateSuborganizationMutationError = void;

/**
 * @summary Deactivate a suborganization
 */
export const useDeactivateSuborganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateSuborganizationHook>>>,
    TError,
    { organizationSlug: string; suborganizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeactivateSuborganizationHook>>>,
  TError,
  { organizationSlug: string; suborganizationSlug: string },
  TContext
> => {
  const mutationOptions = useDeactivateSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active subfolder to INACTIVE.
 * @summary Deactivate a subfolder
 */
export const useDeactivateSubfolderHook = () => {
  const deactivateSubfolder = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, subfolderSlug: string, signal?: AbortSignal) => {
      return deactivateSubfolder({
        url: `/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}/deactivate`,
        method: 'POST',
        signal
      });
    },
    [deactivateSubfolder]
  );
};

export const useDeactivateSubfolderMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateSubfolderHook>>>,
    TError,
    { organizationSlug: string; subfolderSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeactivateSubfolderHook>>>,
  TError,
  { organizationSlug: string; subfolderSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deactivateSubfolder = useDeactivateSubfolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeactivateSubfolderHook>>>,
    { organizationSlug: string; subfolderSlug: string }
  > = props => {
    const { organizationSlug, subfolderSlug } = props ?? {};

    return deactivateSubfolder(organizationSlug, subfolderSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateSubfolderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeactivateSubfolderHook>>>
>;

export type DeactivateSubfolderMutationError = void;

/**
 * @summary Deactivate a subfolder
 */
export const useDeactivateSubfolder = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateSubfolderHook>>>,
    TError,
    { organizationSlug: string; subfolderSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeactivateSubfolderHook>>>,
  TError,
  { organizationSlug: string; subfolderSlug: string },
  TContext
> => {
  const mutationOptions = useDeactivateSubfolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of a draft or inactive subfolder to ACTIVE.
 * @summary Activate a subfolder
 */
export const useActivateSubfolderHook = () => {
  const activateSubfolder = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, subfolderSlug: string, signal?: AbortSignal) => {
      return activateSubfolder({
        url: `/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}/activate`,
        method: 'POST',
        signal
      });
    },
    [activateSubfolder]
  );
};

export const useActivateSubfolderMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateSubfolderHook>>>,
    TError,
    { organizationSlug: string; subfolderSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useActivateSubfolderHook>>>,
  TError,
  { organizationSlug: string; subfolderSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const activateSubfolder = useActivateSubfolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useActivateSubfolderHook>>>,
    { organizationSlug: string; subfolderSlug: string }
  > = props => {
    const { organizationSlug, subfolderSlug } = props ?? {};

    return activateSubfolder(organizationSlug, subfolderSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateSubfolderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useActivateSubfolderHook>>>
>;

export type ActivateSubfolderMutationError = void;

/**
 * @summary Activate a subfolder
 */
export const useActivateSubfolder = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateSubfolderHook>>>,
    TError,
    { organizationSlug: string; subfolderSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useActivateSubfolderHook>>>,
  TError,
  { organizationSlug: string; subfolderSlug: string },
  TContext
> => {
  const mutationOptions = useActivateSubfolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an ON_HOLD organization back to ACTIVE.
 * @summary Resume an organization from hold
 */
export const useResumeOrganizationHook = () => {
  const resumeOrganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return resumeOrganization({ url: `/v1/organizations/${organizationSlug}/resume`, method: 'POST', signal });
    },
    [resumeOrganization]
  );
};

export const useResumeOrganizationMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useResumeOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const resumeOrganization = useResumeOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useResumeOrganizationHook>>>,
    { organizationSlug: string }
  > = props => {
    const { organizationSlug } = props ?? {};

    return resumeOrganization(organizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useResumeOrganizationHook>>>
>;

export type ResumeOrganizationMutationError = string;

/**
 * @summary Resume an organization from hold
 */
export const useResumeOrganization = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useResumeOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useResumeOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const mutationOptions = useResumeOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active organization to ON_HOLD.
 * @summary Put an organization on hold
 */
export const useHoldOrganizationHook = () => {
  const holdOrganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return holdOrganization({ url: `/v1/organizations/${organizationSlug}/hold`, method: 'POST', signal });
    },
    [holdOrganization]
  );
};

export const useHoldOrganizationMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHoldOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const holdOrganization = useHoldOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHoldOrganizationHook>>>,
    { organizationSlug: string }
  > = props => {
    const { organizationSlug } = props ?? {};

    return holdOrganization(organizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHoldOrganizationHook>>>
>;

export type HoldOrganizationMutationError = string;

/**
 * @summary Put an organization on hold
 */
export const useHoldOrganization = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHoldOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const mutationOptions = useHoldOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new folder under the given organization. The request must specify a parent with a slug and type. If parent type is 'organization', the parent organization must not be Enterprise; if 'folder', nesting is not allowed.
 * @summary Create a folder for an organization
 */
export const useCreateFolderForOrganizationHook = () => {
  const createFolderForOrganization = useCustomAxios<FolderDTO>();

  return useCallback(
    (organizationSlug: string, createFolderRequestBody: CreateFolderRequestBody, signal?: AbortSignal) => {
      return createFolderForOrganization({
        url: `/v1/organizations/${organizationSlug}/folders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createFolderRequestBody,
        signal
      });
    },
    [createFolderForOrganization]
  );
};

export const useCreateFolderForOrganizationMutationOptions = <TError = FolderDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderForOrganizationHook>>>,
    TError,
    { organizationSlug: string; data: CreateFolderRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateFolderForOrganizationHook>>>,
  TError,
  { organizationSlug: string; data: CreateFolderRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createFolderForOrganization = useCreateFolderForOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderForOrganizationHook>>>,
    { organizationSlug: string; data: CreateFolderRequestBody }
  > = props => {
    const { organizationSlug, data } = props ?? {};

    return createFolderForOrganization(organizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFolderForOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateFolderForOrganizationHook>>>
>;
export type CreateFolderForOrganizationMutationBody = CreateFolderRequestBody;
export type CreateFolderForOrganizationMutationError = FolderDTO;

/**
 * @summary Create a folder for an organization
 */
export const useCreateFolderForOrganization = <TError = FolderDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderForOrganizationHook>>>,
    TError,
    { organizationSlug: string; data: CreateFolderRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateFolderForOrganizationHook>>>,
  TError,
  { organizationSlug: string; data: CreateFolderRequestBody },
  TContext
> => {
  const mutationOptions = useCreateFolderForOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Adds users (with roles) to the given folder. If the folder is not ACTIVE, users are recorded but not invited.
 * @summary Assign users to a folder
 */
export const useAssignRolesToFolderHook = () => {
  const assignRolesToFolder = useCustomAxios<void>();

  return useCallback(
    (
      organizationSlug: string,
      folderSlug: string,
      roleAssignmentRequestDto: RoleAssignmentRequestDto,
      signal?: AbortSignal
    ) => {
      return assignRolesToFolder({
        url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}/role-assignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: roleAssignmentRequestDto,
        signal
      });
    },
    [assignRolesToFolder]
  );
};

export const useAssignRolesToFolderMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignRolesToFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string; data: RoleAssignmentRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignRolesToFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string; data: RoleAssignmentRequestDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignRolesToFolder = useAssignRolesToFolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignRolesToFolderHook>>>,
    { organizationSlug: string; folderSlug: string; data: RoleAssignmentRequestDto }
  > = props => {
    const { organizationSlug, folderSlug, data } = props ?? {};

    return assignRolesToFolder(organizationSlug, folderSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignRolesToFolderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignRolesToFolderHook>>>
>;
export type AssignRolesToFolderMutationBody = RoleAssignmentRequestDto;
export type AssignRolesToFolderMutationError = void;

/**
 * @summary Assign users to a folder
 */
export const useAssignRolesToFolder = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignRolesToFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string; data: RoleAssignmentRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignRolesToFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string; data: RoleAssignmentRequestDto },
  TContext
> => {
  const mutationOptions = useAssignRolesToFolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active folder to ON_HOLD.
 * @summary Put a folder on hold
 */
export const useHoldFolderHook = () => {
  const holdFolder = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, folderSlug: string, signal?: AbortSignal) => {
      return holdFolder({
        url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}/hold`,
        method: 'POST',
        signal
      });
    },
    [holdFolder]
  );
};

export const useHoldFolderMutationOptions = <TError = string | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHoldFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const holdFolder = useHoldFolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHoldFolderHook>>>,
    { organizationSlug: string; folderSlug: string }
  > = props => {
    const { organizationSlug, folderSlug } = props ?? {};

    return holdFolder(organizationSlug, folderSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldFolderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHoldFolderHook>>>>;

export type HoldFolderMutationError = string | void;

/**
 * @summary Put a folder on hold
 */
export const useHoldFolder = <TError = string | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHoldFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHoldFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string },
  TContext
> => {
  const mutationOptions = useHoldFolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active folder to INACTIVE.
 * @summary Deactivate a folder
 */
export const useDeactivateFolderHook = () => {
  const deactivateFolder = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, folderSlug: string, signal?: AbortSignal) => {
      return deactivateFolder({
        url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}/deactivate`,
        method: 'POST',
        signal
      });
    },
    [deactivateFolder]
  );
};

export const useDeactivateFolderMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeactivateFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deactivateFolder = useDeactivateFolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeactivateFolderHook>>>,
    { organizationSlug: string; folderSlug: string }
  > = props => {
    const { organizationSlug, folderSlug } = props ?? {};

    return deactivateFolder(organizationSlug, folderSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateFolderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeactivateFolderHook>>>
>;

export type DeactivateFolderMutationError = void;

/**
 * @summary Deactivate a folder
 */
export const useDeactivateFolder = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeactivateFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string },
  TContext
> => {
  const mutationOptions = useDeactivateFolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of a draft folder to ACTIVE.
 * @summary Activate a folder
 */
export const useActivateFolderHook = () => {
  const activateFolder = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, folderSlug: string, signal?: AbortSignal) => {
      return activateFolder({
        url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}/activate`,
        method: 'POST',
        signal
      });
    },
    [activateFolder]
  );
};

export const useActivateFolderMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useActivateFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const activateFolder = useActivateFolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useActivateFolderHook>>>,
    { organizationSlug: string; folderSlug: string }
  > = props => {
    const { organizationSlug, folderSlug } = props ?? {};

    return activateFolder(organizationSlug, folderSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateFolderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useActivateFolderHook>>>>;

export type ActivateFolderMutationError = void;

/**
 * @summary Activate a folder
 */
export const useActivateFolder = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useActivateFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string },
  TContext
> => {
  const mutationOptions = useActivateFolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of an active organization to INACTIVE.
 * @summary Deactivate an organization
 */
export const useDeactivateOrganizationHook = () => {
  const deactivateOrganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return deactivateOrganization({
        url: `/v1/organizations/${organizationSlug}/deactivate`,
        method: 'POST',
        signal
      });
    },
    [deactivateOrganization]
  );
};

export const useDeactivateOrganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeactivateOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deactivateOrganization = useDeactivateOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeactivateOrganizationHook>>>,
    { organizationSlug: string }
  > = props => {
    const { organizationSlug } = props ?? {};

    return deactivateOrganization(organizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeactivateOrganizationHook>>>
>;

export type DeactivateOrganizationMutationError = void;

/**
 * @summary Deactivate an organization
 */
export const useDeactivateOrganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeactivateOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeactivateOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const mutationOptions = useDeactivateOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets the status of a draft, inactive, or on-hold organization to ACTIVE.
 * @summary Activate an organization
 */
export const useActivateOrganizationHook = () => {
  const activateOrganization = useCustomAxios<void>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return activateOrganization({ url: `/v1/organizations/${organizationSlug}/activate`, method: 'POST', signal });
    },
    [activateOrganization]
  );
};

export const useActivateOrganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useActivateOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const activateOrganization = useActivateOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useActivateOrganizationHook>>>,
    { organizationSlug: string }
  > = props => {
    const { organizationSlug } = props ?? {};

    return activateOrganization(organizationSlug);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useActivateOrganizationHook>>>
>;

export type ActivateOrganizationMutationError = void;

/**
 * @summary Activate an organization
 */
export const useActivateOrganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useActivateOrganizationHook>>>,
    TError,
    { organizationSlug: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useActivateOrganizationHook>>>,
  TError,
  { organizationSlug: string },
  TContext
> => {
  const mutationOptions = useActivateOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fetches organizations for the authenticated user. Results are first restricted to organizations that share at least one office with the current user's visible offices (same source as GET /v1/offices: session user → user.offices → DB). Additional criteria in the body are applied on top of that scope. MIDOT_ADMIN / global admin users with no offices on their user record skip the office gate and use role-based access only.

 * @summary Get organizations by criteria
 */
export const useFilterOrganizationsHook = () => {
  const filterOrganizations = useCustomAxios<OrganizationDTO[]>();

  return useCallback(
    (organizationRequestDTO: OrganizationRequestDTO, signal?: AbortSignal) => {
      return filterOrganizations({
        url: `/v1/organizations/filter`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: organizationRequestDTO,
        signal
      });
    },
    [filterOrganizations]
  );
};

export const getFilterOrganizationsQueryKey = (organizationRequestDTO: OrganizationRequestDTO) => {
  return [`/v1/organizations/filter`, organizationRequestDTO] as const;
};

export const useFilterOrganizationsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>,
  TError = unknown
>(
  organizationRequestDTO: OrganizationRequestDTO,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilterOrganizationsQueryKey(organizationRequestDTO);

  const filterOrganizations = useFilterOrganizationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>> = ({ signal }) =>
    filterOrganizations(organizationRequestDTO, signal);

  const customOptions = useCustomFilterOrganizationsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { organizationRequestDTO },
    { url: `/v1/organizations/filter` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilterOrganizationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>
>;
export type FilterOrganizationsInfiniteQueryError = unknown;

/**
 * @summary Get organizations by criteria
 */

export function useFilterOrganizationsInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>,
  TError = unknown
>(
  organizationRequestDTO: OrganizationRequestDTO,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>, TError, TData>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useFilterOrganizationsInfiniteQueryOptions(organizationRequestDTO, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useFilterOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>,
  TError = unknown
>(
  organizationRequestDTO: OrganizationRequestDTO,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilterOrganizationsQueryKey(organizationRequestDTO);

  const filterOrganizations = useFilterOrganizationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>> = ({ signal }) =>
    filterOrganizations(organizationRequestDTO, signal);

  const customOptions = useCustomFilterOrganizationsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { organizationRequestDTO },
    { url: `/v1/organizations/filter` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilterOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>
>;
export type FilterOrganizationsQueryError = unknown;

/**
 * @summary Get organizations by criteria
 */

export function useFilterOrganizations<
  TData = Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>,
  TError = unknown
>(
  organizationRequestDTO: OrganizationRequestDTO,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilterOrganizationsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useFilterOrganizationsQueryOptions(organizationRequestDTO, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Assigns specified roles and offices to a list of users (new or existing).

- Existing users can be identified by ID or email
- New users will be invited if only email is provided
- Email must belong to an authorized Midot domain
- Unauthorized emails will be ignored
- No errors if roles or offices are already assigned

 * @summary Invite Midot users. Assign roles and offices to Midot users
 */
export const useAssignUsersHook = () => {
  const assignUsers = useCustomAxios<MidotUserAssignmentResponse>();

  return useCallback(
    (midotUserAssignmentRequest: MidotUserAssignmentRequest, signal?: AbortSignal) => {
      return assignUsers({
        url: `/v1/midot/user-assignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: midotUserAssignmentRequest,
        signal
      });
    },
    [assignUsers]
  );
};

export const useAssignUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignUsersHook>>>,
    TError,
    { data: MidotUserAssignmentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignUsersHook>>>,
  TError,
  { data: MidotUserAssignmentRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignUsers = useAssignUsersHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignUsersHook>>>,
    { data: MidotUserAssignmentRequest }
  > = props => {
    const { data } = props ?? {};

    return assignUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignUsersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAssignUsersHook>>>>;
export type AssignUsersMutationBody = MidotUserAssignmentRequest;
export type AssignUsersMutationError = unknown;

/**
 * @summary Invite Midot users. Assign roles and offices to Midot users
 */
export const useAssignUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignUsersHook>>>,
    TError,
    { data: MidotUserAssignmentRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignUsersHook>>>,
  TError,
  { data: MidotUserAssignmentRequest },
  TContext
> => {
  const mutationOptions = useAssignUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new invitation for a talent with the specified access mode.
RBAC Rules:
- Midot ADMIN: Yes ✅
- Midot OTHER: No ❌
- Client ADMIN: Yes ✅
- Client OTHER: Yes ✅

Additional Rules:
- Process must be active/published or unpublished
 * @summary Create Invitation for Player UNIQUE_LINK
 */
export const useCreateInvitationHook = () => {
  const createInvitation = useCustomAxios<CreateInvitationResponse>();

  return useCallback(
    (createInvitationRequest: CreateInvitationRequest, signal?: AbortSignal) => {
      return createInvitation({
        url: `/v1/invitation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createInvitationRequest,
        signal
      });
    },
    [createInvitation]
  );
};

export const useCreateInvitationMutationOptions = <TError = CreateInvitationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
    TError,
    { data: CreateInvitationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
  TError,
  { data: CreateInvitationRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createInvitation = useCreateInvitationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
    { data: CreateInvitationRequest }
  > = props => {
    const { data } = props ?? {};

    return createInvitation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvitationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>
>;
export type CreateInvitationMutationBody = CreateInvitationRequest;
export type CreateInvitationMutationError = CreateInvitationResponse;

/**
 * @summary Create Invitation for Player UNIQUE_LINK
 */
export const useCreateInvitation = <TError = CreateInvitationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
    TError,
    { data: CreateInvitationRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
  TError,
  { data: CreateInvitationRequest },
  TContext
> => {
  const mutationOptions = useCreateInvitationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Check if a JWT token has the correct format (3 parts separated by dots)
 * @summary 🔍 Validate JWT format
 */
export const useValidateJwtHook = () => {
  const validateJwt = useCustomAxios<ValidateJwt200>();

  return useCallback(
    (jwtValidateRequest: JwtValidateRequest, signal?: AbortSignal) => {
      return validateJwt({
        url: `/v1/dev-jwt/validate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: jwtValidateRequest,
        signal
      });
    },
    [validateJwt]
  );
};

export const useValidateJwtMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateJwtHook>>>,
    TError,
    { data: JwtValidateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useValidateJwtHook>>>,
  TError,
  { data: JwtValidateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const validateJwt = useValidateJwtHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useValidateJwtHook>>>,
    { data: JwtValidateRequest }
  > = props => {
    const { data } = props ?? {};

    return validateJwt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateJwtMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidateJwtHook>>>>;
export type ValidateJwtMutationBody = JwtValidateRequest;
export type ValidateJwtMutationError = unknown;

/**
 * @summary 🔍 Validate JWT format
 */
export const useValidateJwt = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateJwtHook>>>,
    TError,
    { data: JwtValidateRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useValidateJwtHook>>>,
  TError,
  { data: JwtValidateRequest },
  TContext
> => {
  const mutationOptions = useValidateJwtMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Refine catalog items based on catalog ID, locale, and refinement criteria. Returns either a refined catalog ID if refinement is complete, or the next refinement step.
 * @summary Refine catalog items
 */
export const useRefineCatalogHook = () => {
  const refineCatalog = useCustomAxios<CatalogRefinementResponse>();

  return useCallback(
    (catalogRefinementRequest: CatalogRefinementRequest, signal?: AbortSignal) => {
      return refineCatalog({
        url: `/v1/catalog/test-catalog/refine`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: catalogRefinementRequest,
        signal
      });
    },
    [refineCatalog]
  );
};

export const useRefineCatalogMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRefineCatalogHook>>>,
    TError,
    { data: CatalogRefinementRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRefineCatalogHook>>>,
  TError,
  { data: CatalogRefinementRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const refineCatalog = useRefineCatalogHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRefineCatalogHook>>>,
    { data: CatalogRefinementRequest }
  > = props => {
    const { data } = props ?? {};

    return refineCatalog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefineCatalogMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRefineCatalogHook>>>>;
export type RefineCatalogMutationBody = CatalogRefinementRequest;
export type RefineCatalogMutationError = void;

/**
 * @summary Refine catalog items
 */
export const useRefineCatalog = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRefineCatalogHook>>>,
    TError,
    { data: CatalogRefinementRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRefineCatalogHook>>>,
  TError,
  { data: CatalogRefinementRequest },
  TContext
> => {
  const mutationOptions = useRefineCatalogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useValidateHook = () => {
  const validate = useCustomAxios<Validate200>();

  return useCallback(
    (tokenRequest: TokenRequest, signal?: AbortSignal) => {
      return validate({
        url: `/v1/auth/validate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: tokenRequest,
        signal
      });
    },
    [validate]
  );
};

export const useValidateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateHook>>>,
    TError,
    { data: TokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useValidateHook>>>,
  TError,
  { data: TokenRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const validate = useValidateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useValidateHook>>>,
    { data: TokenRequest }
  > = props => {
    const { data } = props ?? {};

    return validate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidateHook>>>>;
export type ValidateMutationBody = TokenRequest;
export type ValidateMutationError = unknown;

export const useValidate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateHook>>>,
    TError,
    { data: TokenRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useValidateHook>>>,
  TError,
  { data: TokenRequest },
  TContext
> => {
  const mutationOptions = useValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useLogout1Hook = () => {
  const logout1 = useCustomAxios<boolean>();

  return useCallback(
    (signal?: AbortSignal) => {
      return logout1({ url: `/v1/auth/logout`, method: 'POST', signal });
    },
    [logout1]
  );
};

export const useLogout1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLogout1Hook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLogout1Hook>>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const logout1 = useLogout1Hook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useLogout1Hook>>>, void> = () => {
    return logout1();
  };

  return { mutationFn, ...mutationOptions };
};

export type Logout1MutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLogout1Hook>>>>;

export type Logout1MutationError = unknown;

export const useLogout1 = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLogout1Hook>>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useLogout1Hook>>>, TError, void, TContext> => {
  const mutationOptions = useLogout1MutationOptions(options);

  return useMutation(mutationOptions);
};

export const useLogin1Hook = () => {
  const login1 = useCustomAxios<string>();

  return useCallback(
    (signal?: AbortSignal) => {
      return login1({ url: `/v1/auth/login`, method: 'POST', signal });
    },
    [login1]
  );
};

export const useLogin1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLogin1Hook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLogin1Hook>>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const login1 = useLogin1Hook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useLogin1Hook>>>, void> = () => {
    return login1();
  };

  return { mutationFn, ...mutationOptions };
};

export type Login1MutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLogin1Hook>>>>;

export type Login1MutationError = unknown;

export const useLogin1 = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLogin1Hook>>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useLogin1Hook>>>, TError, void, TContext> => {
  const mutationOptions = useLogin1MutationOptions(options);

  return useMutation(mutationOptions);
};

export const useCheckEmailHook = () => {
  const checkEmail = useCustomAxios<boolean>();

  return useCallback(
    (emailRequest: EmailRequest, signal?: AbortSignal) => {
      return checkEmail({
        url: `/v1/auth/check-email`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: emailRequest,
        signal
      });
    },
    [checkEmail]
  );
};

export const useCheckEmailMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCheckEmailHook>>>,
    TError,
    { data: EmailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCheckEmailHook>>>,
  TError,
  { data: EmailRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const checkEmail = useCheckEmailHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCheckEmailHook>>>,
    { data: EmailRequest }
  > = props => {
    const { data } = props ?? {};

    return checkEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckEmailMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckEmailHook>>>>;
export type CheckEmailMutationBody = EmailRequest;
export type CheckEmailMutationError = unknown;

export const useCheckEmail = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCheckEmailHook>>>,
    TError,
    { data: EmailRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCheckEmailHook>>>,
  TError,
  { data: EmailRequest },
  TContext
> => {
  const mutationOptions = useCheckEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Validate if an API key is valid and get its permissions
 * @summary ✅ Validate API key
 */
export const useValidateApiKeyHook = () => {
  const validateApiKey = useCustomAxios<ValidateApiKey200>();

  return useCallback(
    (apiKeyValidateRequest: ApiKeyValidateRequest, signal?: AbortSignal) => {
      return validateApiKey({
        url: `/v1/api-keys/validate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: apiKeyValidateRequest,
        signal
      });
    },
    [validateApiKey]
  );
};

export const useValidateApiKeyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateApiKeyHook>>>,
    TError,
    { data: ApiKeyValidateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useValidateApiKeyHook>>>,
  TError,
  { data: ApiKeyValidateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const validateApiKey = useValidateApiKeyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useValidateApiKeyHook>>>,
    { data: ApiKeyValidateRequest }
  > = props => {
    const { data } = props ?? {};

    return validateApiKey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateApiKeyMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidateApiKeyHook>>>>;
export type ValidateApiKeyMutationBody = ApiKeyValidateRequest;
export type ValidateApiKeyMutationError = unknown;

/**
 * @summary ✅ Validate API key
 */
export const useValidateApiKey = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateApiKeyHook>>>,
    TError,
    { data: ApiKeyValidateRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useValidateApiKeyHook>>>,
  TError,
  { data: ApiKeyValidateRequest },
  TContext
> => {
  const mutationOptions = useValidateApiKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Create a new API key with specified role (development only)
 * @summary 🔧 Create new API key
 */
export const useCreateApiKeyHook = () => {
  const createApiKey = useCustomAxios<CreateApiKey200>();

  return useCallback(
    (createApiKeyRequest: CreateApiKeyRequest, signal?: AbortSignal) => {
      return createApiKey({
        url: `/v1/api-keys/create`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createApiKeyRequest,
        signal
      });
    },
    [createApiKey]
  );
};

export const useCreateApiKeyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>,
    TError,
    { data: CreateApiKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>,
  TError,
  { data: CreateApiKeyRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createApiKey = useCreateApiKeyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>,
    { data: CreateApiKeyRequest }
  > = props => {
    const { data } = props ?? {};

    return createApiKey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>>;
export type CreateApiKeyMutationBody = CreateApiKeyRequest;
export type CreateApiKeyMutationError = unknown;

/**
 * @summary 🔧 Create new API key
 */
export const useCreateApiKey = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>,
    TError,
    { data: CreateApiKeyRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>,
  TError,
  { data: CreateApiKeyRequest },
  TContext
> => {
  const mutationOptions = useCreateApiKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useSaveHook = () => {
  const save = useCustomAxios<void>();

  return useCallback(
    (params: SaveParams, signal?: AbortSignal) => {
      return save({ url: `/redis/save`, method: 'POST', params, signal });
    },
    [save]
  );
};

export const useSaveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveHook>>>,
    TError,
    { params: SaveParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSaveHook>>>,
  TError,
  { params: SaveParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const save = useSaveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSaveHook>>>,
    { params: SaveParams }
  > = props => {
    const { params } = props ?? {};

    return save(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveHook>>>>;

export type SaveMutationError = unknown;

export const useSave = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveHook>>>,
    TError,
    { params: SaveParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSaveHook>>>,
  TError,
  { params: SaveParams },
  TContext
> => {
  const mutationOptions = useSaveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useSaveWithExpirationHook = () => {
  const saveWithExpiration = useCustomAxios<void>();

  return useCallback(
    (params: SaveWithExpirationParams, signal?: AbortSignal) => {
      return saveWithExpiration({ url: `/redis/saveWithExpiration`, method: 'POST', params, signal });
    },
    [saveWithExpiration]
  );
};

export const useSaveWithExpirationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveWithExpirationHook>>>,
    TError,
    { params: SaveWithExpirationParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSaveWithExpirationHook>>>,
  TError,
  { params: SaveWithExpirationParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const saveWithExpiration = useSaveWithExpirationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSaveWithExpirationHook>>>,
    { params: SaveWithExpirationParams }
  > = props => {
    const { params } = props ?? {};

    return saveWithExpiration(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveWithExpirationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSaveWithExpirationHook>>>
>;

export type SaveWithExpirationMutationError = unknown;

export const useSaveWithExpiration = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveWithExpirationHook>>>,
    TError,
    { params: SaveWithExpirationParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSaveWithExpirationHook>>>,
  TError,
  { params: SaveWithExpirationParams },
  TContext
> => {
  const mutationOptions = useSaveWithExpirationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Standard OAuth2 Client Credentials flow for machine-to-machine authentication.

**Predefined Clients:**
- `podium-admin` / `podium_admin_secret_2024` → Full admin access (30 min)
- `automation-client` / `automation_secret_never_expires` → Never expires
- `cursor-ai` / `cursor_ai_integration_secret` → For AI integrations

**Usage:**
1. POST to this endpoint with client credentials
2. Receive JWT access token
3. Use token in `Authorization: Bearer <token>` header

**Standards Compliant:** RFC 6749 (OAuth2) + RFC 7519 (JWT)

 * @summary 🔑 OAuth2 Token Endpoint (Client Credentials)
 */
export const useIssueTokenHook = () => {
  const issueToken = useCustomAxios<unknown>();

  return useCallback(
    (params: IssueTokenParams, signal?: AbortSignal) => {
      return issueToken({ url: `/oauth2/token`, method: 'POST', params, signal });
    },
    [issueToken]
  );
};

export const useIssueTokenMutationOptions = <TError = IssueToken400 | IssueToken401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useIssueTokenHook>>>,
    TError,
    { params: IssueTokenParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useIssueTokenHook>>>,
  TError,
  { params: IssueTokenParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const issueToken = useIssueTokenHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useIssueTokenHook>>>,
    { params: IssueTokenParams }
  > = props => {
    const { params } = props ?? {};

    return issueToken(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueTokenMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useIssueTokenHook>>>>;

export type IssueTokenMutationError = IssueToken400 | IssueToken401;

/**
 * @summary 🔑 OAuth2 Token Endpoint (Client Credentials)
 */
export const useIssueToken = <TError = IssueToken400 | IssueToken401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useIssueTokenHook>>>,
    TError,
    { params: IssueTokenParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useIssueTokenHook>>>,
  TError,
  { params: IssueTokenParams },
  TContext
> => {
  const mutationOptions = useIssueTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Validate and introspect a JWT token (RFC 7662 compliant)
 * @summary 🔍 Validate JWT Token
 */
export const useIntrospectTokenHook = () => {
  const introspectToken = useCustomAxios<IntrospectToken200>();

  return useCallback(
    (params: IntrospectTokenParams, signal?: AbortSignal) => {
      return introspectToken({ url: `/oauth2/introspect`, method: 'POST', params, signal });
    },
    [introspectToken]
  );
};

export const useIntrospectTokenMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useIntrospectTokenHook>>>,
    TError,
    { params: IntrospectTokenParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useIntrospectTokenHook>>>,
  TError,
  { params: IntrospectTokenParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const introspectToken = useIntrospectTokenHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useIntrospectTokenHook>>>,
    { params: IntrospectTokenParams }
  > = props => {
    const { params } = props ?? {};

    return introspectToken(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type IntrospectTokenMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useIntrospectTokenHook>>>>;

export type IntrospectTokenMutationError = unknown;

/**
 * @summary 🔍 Validate JWT Token
 */
export const useIntrospectToken = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useIntrospectTokenHook>>>,
    TError,
    { params: IntrospectTokenParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useIntrospectTokenHook>>>,
  TError,
  { params: IntrospectTokenParams },
  TContext
> => {
  const mutationOptions = useIntrospectTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Manually trigger cleanup of expired sessions
 */
export const useCleanupExpiredSessionsHook = () => {
  const cleanupExpiredSessions = useCustomAxios<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return cleanupExpiredSessions({ url: `/api/v1/sessions/cleanup`, method: 'POST', signal });
    },
    [cleanupExpiredSessions]
  );
};

export const useCleanupExpiredSessionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCleanupExpiredSessionsHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCleanupExpiredSessionsHook>>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const cleanupExpiredSessions = useCleanupExpiredSessionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCleanupExpiredSessionsHook>>>,
    void
  > = () => {
    return cleanupExpiredSessions();
  };

  return { mutationFn, ...mutationOptions };
};

export type CleanupExpiredSessionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCleanupExpiredSessionsHook>>>
>;

export type CleanupExpiredSessionsMutationError = unknown;

/**
 * @summary Manually trigger cleanup of expired sessions
 */
export const useCleanupExpiredSessions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCleanupExpiredSessionsHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCleanupExpiredSessionsHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = useCleanupExpiredSessionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useCreateUserOrganizationRelationshipHook = () => {
  const createUserOrganizationRelationship = useCustomAxios<CreateUserOrganizationRelationship200>();

  return useCallback(
    (params: CreateUserOrganizationRelationshipParams, signal?: AbortSignal) => {
      return createUserOrganizationRelationship({
        url: `/api/spicedb-demo/relationships/user-organization`,
        method: 'POST',
        params,
        signal
      });
    },
    [createUserOrganizationRelationship]
  );
};

export const useCreateUserOrganizationRelationshipMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateUserOrganizationRelationshipHook>>>,
    TError,
    { params: CreateUserOrganizationRelationshipParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateUserOrganizationRelationshipHook>>>,
  TError,
  { params: CreateUserOrganizationRelationshipParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createUserOrganizationRelationship = useCreateUserOrganizationRelationshipHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateUserOrganizationRelationshipHook>>>,
    { params: CreateUserOrganizationRelationshipParams }
  > = props => {
    const { params } = props ?? {};

    return createUserOrganizationRelationship(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserOrganizationRelationshipMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateUserOrganizationRelationshipHook>>>
>;

export type CreateUserOrganizationRelationshipMutationError = unknown;

export const useCreateUserOrganizationRelationship = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateUserOrganizationRelationshipHook>>>,
    TError,
    { params: CreateUserOrganizationRelationshipParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateUserOrganizationRelationshipHook>>>,
  TError,
  { params: CreateUserOrganizationRelationshipParams },
  TContext
> => {
  const mutationOptions = useCreateUserOrganizationRelationshipMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useManageOrganizationHook = () => {
  const manageOrganization = useCustomAxios<ManageOrganization200>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return manageOrganization({
        url: `/api/spicedb-demo/protected/organizations/${id}/manage`,
        method: 'POST',
        signal
      });
    },
    [manageOrganization]
  );
};

export const useManageOrganizationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useManageOrganizationHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useManageOrganizationHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const manageOrganization = useManageOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useManageOrganizationHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return manageOrganization(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManageOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useManageOrganizationHook>>>
>;

export type ManageOrganizationMutationError = unknown;

export const useManageOrganization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useManageOrganizationHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useManageOrganizationHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useManageOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useTestAuthorizationHook = () => {
  const testAuthorization = useCustomAxios<TestAuthorization200>();

  return useCallback(
    (testAuthorizationBody: TestAuthorizationBody, signal?: AbortSignal) => {
      return testAuthorization({
        url: `/api/rbac-demo/test-authorization`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: testAuthorizationBody,
        signal
      });
    },
    [testAuthorization]
  );
};

export const useTestAuthorizationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTestAuthorizationHook>>>,
    TError,
    { data: TestAuthorizationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTestAuthorizationHook>>>,
  TError,
  { data: TestAuthorizationBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const testAuthorization = useTestAuthorizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTestAuthorizationHook>>>,
    { data: TestAuthorizationBody }
  > = props => {
    const { data } = props ?? {};

    return testAuthorization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAuthorizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTestAuthorizationHook>>>
>;
export type TestAuthorizationMutationBody = TestAuthorizationBody;
export type TestAuthorizationMutationError = unknown;

export const useTestAuthorization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTestAuthorizationHook>>>,
    TError,
    { data: TestAuthorizationBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTestAuthorizationHook>>>,
  TError,
  { data: TestAuthorizationBody },
  TContext
> => {
  const mutationOptions = useTestAuthorizationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useCreateOrganizationUserHook = () => {
  const createOrganizationUser = useCustomAxios<CreateOrganizationUser200>();

  return useCallback(
    (orgId: string, createOrganizationUserBody: CreateOrganizationUserBody, signal?: AbortSignal) => {
      return createOrganizationUser({
        url: `/api/rbac-demo/orgs/${orgId}/users`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createOrganizationUserBody,
        signal
      });
    },
    [createOrganizationUser]
  );
};

export const useCreateOrganizationUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateOrganizationUserHook>>>,
    TError,
    { orgId: string; data: CreateOrganizationUserBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateOrganizationUserHook>>>,
  TError,
  { orgId: string; data: CreateOrganizationUserBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createOrganizationUser = useCreateOrganizationUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateOrganizationUserHook>>>,
    { orgId: string; data: CreateOrganizationUserBody }
  > = props => {
    const { orgId, data } = props ?? {};

    return createOrganizationUser(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationUserMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateOrganizationUserHook>>>
>;
export type CreateOrganizationUserMutationBody = CreateOrganizationUserBody;
export type CreateOrganizationUserMutationError = unknown;

export const useCreateOrganizationUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateOrganizationUserHook>>>,
    TError,
    { orgId: string; data: CreateOrganizationUserBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateOrganizationUserHook>>>,
  TError,
  { orgId: string; data: CreateOrganizationUserBody },
  TContext
> => {
  const mutationOptions = useCreateOrganizationUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useCreateFolderItemHook = () => {
  const createFolderItem = useCustomAxios<CreateFolderItem200>();

  return useCallback(
    (folderId: string, createFolderItemBody: CreateFolderItemBody, signal?: AbortSignal) => {
      return createFolderItem({
        url: `/api/rbac-demo/folders/${folderId}/items`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createFolderItemBody,
        signal
      });
    },
    [createFolderItem]
  );
};

export const useCreateFolderItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderItemHook>>>,
    TError,
    { folderId: string; data: CreateFolderItemBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateFolderItemHook>>>,
  TError,
  { folderId: string; data: CreateFolderItemBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const createFolderItem = useCreateFolderItemHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderItemHook>>>,
    { folderId: string; data: CreateFolderItemBody }
  > = props => {
    const { folderId, data } = props ?? {};

    return createFolderItem(folderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFolderItemMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateFolderItemHook>>>
>;
export type CreateFolderItemMutationBody = CreateFolderItemBody;
export type CreateFolderItemMutationError = unknown;

export const useCreateFolderItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderItemHook>>>,
    TError,
    { folderId: string; data: CreateFolderItemBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateFolderItemHook>>>,
  TError,
  { folderId: string; data: CreateFolderItemBody },
  TContext
> => {
  const mutationOptions = useCreateFolderItemMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a user by their ID in the UserDTO format. Supports both Midot employees and client users.
 * @summary Get user by ID
 */
export const useGetUserByIdHook = () => {
  const getUserById = useCustomAxios<UserDTO>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return getUserById({ url: `/v1/users/${userId}`, method: 'GET', signal });
    },
    [getUserById]
  );
};

export const getGetUserByIdQueryKey = (userId: string) => {
  return [`/v1/users/${userId}`] as const;
};

export const useGetUserByIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>,
  TError = unknown
>(
  userId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserByIdQueryKey(userId);

  const getUserById = useGetUserByIdHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>> = ({ signal }) =>
    getUserById(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>>;
export type GetUserByIdQueryError = unknown;

/**
 * @summary Get user by ID
 */

export function useGetUserById<TData = Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError = unknown>(
  userId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserByIdHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserByIdQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a user whose status is ONBOARDING, effectively cancelling the invitation. The caller must have user-creation permissions (same roles that can invite users). Returns 400 if the user exists but is not in ONBOARDING status.
 * @summary Delete user
 */
export const useDeleteUserHook = () => {
  const deleteUser = useCustomAxios<void>();

  return useCallback(
    (userId: string) => {
      return deleteUser({ url: `/v1/users/${userId}`, method: 'DELETE' });
    },
    [deleteUser]
  );
};

export const useDeleteUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteUser = useDeleteUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return deleteUser(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>>;

export type DeleteUserMutationError = void;

/**
 * @summary Delete user
 */
export const useDeleteUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useDeleteUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates a user. Only possible for the current user or for Midot admins.
 * @summary Update a user
 */
export const useUpdateUserHook = () => {
  const updateUser = useCustomAxios<void>();

  return useCallback(
    (userId: string, updateUserDTO: UpdateUserDTO) => {
      return updateUser({
        url: `/v1/users/${userId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateUserDTO
      });
    },
    [updateUser]
  );
};

export const useUpdateUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>,
    TError,
    { userId: string; data: UpdateUserDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>,
  TError,
  { userId: string; data: UpdateUserDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateUser = useUpdateUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>,
    { userId: string; data: UpdateUserDTO }
  > = props => {
    const { userId, data } = props ?? {};

    return updateUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>>;
export type UpdateUserMutationBody = UpdateUserDTO;
export type UpdateUserMutationError = unknown;

/**
 * @summary Update a user
 */
export const useUpdateUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>,
    TError,
    { userId: string; data: UpdateUserDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>,
  TError,
  { userId: string; data: UpdateUserDTO },
  TContext
> => {
  const mutationOptions = useUpdateUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the office assignments for a Midot user. Only available to Global Admins.
KAM users can only be assigned to offices where they are KAM.
Regular Midot users can be assigned to any office.

 * @summary Update a user's office assignments
 */
export const useUpdateUserOfficesHook = () => {
  const updateUserOffices = useCustomAxios<void>();

  return useCallback(
    (userId: string, updateUserOfficesRequest: UpdateUserOfficesRequest) => {
      return updateUserOffices({
        url: `/v1/users/${userId}/offices`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateUserOfficesRequest
      });
    },
    [updateUserOffices]
  );
};

export const useUpdateUserOfficesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserOfficesHook>>>,
    TError,
    { userId: string; data: UpdateUserOfficesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserOfficesHook>>>,
  TError,
  { userId: string; data: UpdateUserOfficesRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateUserOffices = useUpdateUserOfficesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserOfficesHook>>>,
    { userId: string; data: UpdateUserOfficesRequest }
  > = props => {
    const { userId, data } = props ?? {};

    return updateUserOffices(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserOfficesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserOfficesHook>>>
>;
export type UpdateUserOfficesMutationBody = UpdateUserOfficesRequest;
export type UpdateUserOfficesMutationError = unknown;

/**
 * @summary Update a user's office assignments
 */
export const useUpdateUserOffices = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateUserOfficesHook>>>,
    TError,
    { userId: string; data: UpdateUserOfficesRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateUserOfficesHook>>>,
  TError,
  { userId: string; data: UpdateUserOfficesRequest },
  TContext
> => {
  const mutationOptions = useUpdateUserOfficesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get talent metadata by ID
 */
export const useGetTalentByIdHook = () => {
  const getTalentById = useCustomAxios<unknown>();

  return useCallback(
    (talentId: string, signal?: AbortSignal) => {
      return getTalentById({ url: `/v1/talents/${talentId}`, method: 'GET', signal });
    },
    [getTalentById]
  );
};

export const getGetTalentByIdQueryKey = (talentId: string) => {
  return [`/v1/talents/${talentId}`] as const;
};

export const useGetTalentByIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>,
  TError = TalentDTO
>(
  talentId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTalentByIdQueryKey(talentId);

  const getTalentById = useGetTalentByIdHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>> = ({ signal }) =>
    getTalentById(talentId, signal);

  return { queryKey, queryFn, enabled: !!talentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTalentByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>>;
export type GetTalentByIdQueryError = TalentDTO;

/**
 * @summary Get talent metadata by ID
 */

export function useGetTalentById<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>,
  TError = TalentDTO
>(
  talentId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentByIdHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTalentByIdQueryOptions(talentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update talent information. Only allowed if:
- User is Midot ADMIN, Midot OTHER, Client ADMIN, or Client OTHER
- Talent has not started any tests in ANY process
 * @summary Update talent information
 */
export const useUpdateTalentHook = () => {
  const updateTalent = useCustomAxios<string>();

  return useCallback(
    (talentId: string, updateTalentRequest: UpdateTalentRequest) => {
      return updateTalent({
        url: `/v1/talents/${talentId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateTalentRequest
      });
    },
    [updateTalent]
  );
};

export const useUpdateTalentMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentHook>>>,
    TError,
    { talentId: string; data: UpdateTalentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentHook>>>,
  TError,
  { talentId: string; data: UpdateTalentRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateTalent = useUpdateTalentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentHook>>>,
    { talentId: string; data: UpdateTalentRequest }
  > = props => {
    const { talentId, data } = props ?? {};

    return updateTalent(talentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTalentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateTalentHook>>>>;
export type UpdateTalentMutationBody = UpdateTalentRequest;
export type UpdateTalentMutationError = string;

/**
 * @summary Update talent information
 */
export const useUpdateTalent = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTalentHook>>>,
    TError,
    { talentId: string; data: UpdateTalentRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateTalentHook>>>,
  TError,
  { talentId: string; data: UpdateTalentRequest },
  TContext
> => {
  const mutationOptions = useUpdateTalentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Fetch details of a specific process using its unique ID.
 * @summary Get a process by ID
 */
export const useGetProcessByIdHook = () => {
  const getProcessById = useCustomAxios<ProcessResponseDTO>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getProcessById({ url: `/v1/processes/${id}`, method: 'GET', signal });
    },
    [getProcessById]
  );
};

export const getGetProcessByIdQueryKey = (id: string) => {
  return [`/v1/processes/${id}`] as const;
};

export const useGetProcessByIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>,
  TError = unknown
>(
  id: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessByIdQueryKey(id);

  const getProcessById = useGetProcessByIdHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>> = ({ signal }) =>
    getProcessById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>>;
export type GetProcessByIdQueryError = unknown;

/**
 * @summary Get a process by ID
 */

export function useGetProcessById<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>,
  TError = unknown
>(
  id: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessByIdHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates allowed properties of a process. Allowed properties: name, description, offices, location, assessmentType, accessModes, sendModes, and testSettings (only webcamSettings and messages).
 * @summary Update a process
 */
export const useUpdateProcessHook = () => {
  const updateProcess = useCustomAxios<void>();

  return useCallback(
    (id: string, processUpdateDto: ProcessUpdateDto) => {
      return updateProcess({
        url: `/v1/processes/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: processUpdateDto
      });
    },
    [updateProcess]
  );
};

export const useUpdateProcessMutationOptions = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessHook>>>,
    TError,
    { id: string; data: ProcessUpdateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessHook>>>,
  TError,
  { id: string; data: ProcessUpdateDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateProcess = useUpdateProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessHook>>>,
    { id: string; data: ProcessUpdateDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateProcess(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProcessMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateProcessHook>>>>;
export type UpdateProcessMutationBody = ProcessUpdateDto;
export type UpdateProcessMutationError = string;

/**
 * @summary Update a process
 */
export const useUpdateProcess = <TError = string, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProcessHook>>>,
    TError,
    { id: string; data: ProcessUpdateDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateProcessHook>>>,
  TError,
  { id: string; data: ProcessUpdateDto },
  TContext
> => {
  const mutationOptions = useUpdateProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the details of a specific suborganization under the given parent organization.
 * @summary Get a suborganization by slug
 */
export const useGetSuborganizationHook = () => {
  const getSuborganization = useCustomAxios<SuborganizationDTO>();

  return useCallback(
    (slug: string, subSlug: string, signal?: AbortSignal) => {
      return getSuborganization({
        url: `/v1/organizations/${slug}/suborganizations/${subSlug}`,
        method: 'GET',
        signal
      });
    },
    [getSuborganization]
  );
};

export const getGetSuborganizationQueryKey = (slug: string, subSlug: string) => {
  return [`/v1/organizations/${slug}/suborganizations/${subSlug}`] as const;
};

export const useGetSuborganizationQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>,
  TError = SuborganizationDTO
>(
  slug: string,
  subSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuborganizationQueryKey(slug, subSlug);

  const getSuborganization = useGetSuborganizationHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>> = ({ signal }) =>
    getSuborganization(slug, subSlug, signal);

  return { queryKey, queryFn, enabled: !!(slug && subSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuborganizationQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>
>;
export type GetSuborganizationQueryError = SuborganizationDTO;

/**
 * @summary Get a suborganization by slug
 */

export function useGetSuborganization<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>,
  TError = SuborganizationDTO
>(
  slug: string,
  subSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSuborganizationQueryOptions(slug, subSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates an existing suborganization under a given organization. Only fields provided in the request body will be updated.
 * @summary Update a suborganization
 */
export const useUpdateSuborganizationHook = () => {
  const updateSuborganization = useCustomAxios<SuborganizationDTO>();

  return useCallback(
    (slug: string, subSlug: string, updateSuborganizationRequestBody: UpdateSuborganizationRequestBody) => {
      return updateSuborganization({
        url: `/v1/organizations/${slug}/suborganizations/${subSlug}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateSuborganizationRequestBody
      });
    },
    [updateSuborganization]
  );
};

export const useUpdateSuborganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationHook>>>,
    TError,
    { slug: string; subSlug: string; data: UpdateSuborganizationRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationHook>>>,
  TError,
  { slug: string; subSlug: string; data: UpdateSuborganizationRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateSuborganization = useUpdateSuborganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationHook>>>,
    { slug: string; subSlug: string; data: UpdateSuborganizationRequestBody }
  > = props => {
    const { slug, subSlug, data } = props ?? {};

    return updateSuborganization(slug, subSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSuborganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationHook>>>
>;
export type UpdateSuborganizationMutationBody = UpdateSuborganizationRequestBody;
export type UpdateSuborganizationMutationError = void;

/**
 * @summary Update a suborganization
 */
export const useUpdateSuborganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationHook>>>,
    TError,
    { slug: string; subSlug: string; data: UpdateSuborganizationRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateSuborganizationHook>>>,
  TError,
  { slug: string; subSlug: string; data: UpdateSuborganizationRequestBody },
  TContext
> => {
  const mutationOptions = useUpdateSuborganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Organization Metadata
 */
export const useGetOrganizationBySlugHook = () => {
  const getOrganizationBySlug = useCustomAxios<OrganizationDTO>();

  return useCallback(
    (organizationSlug: string, params?: GetOrganizationBySlugParams, signal?: AbortSignal) => {
      return getOrganizationBySlug({ url: `/v1/organizations/${organizationSlug}`, method: 'GET', params, signal });
    },
    [getOrganizationBySlug]
  );
};

export const getGetOrganizationBySlugQueryKey = (organizationSlug: string, params?: GetOrganizationBySlugParams) => {
  return [`/v1/organizations/${organizationSlug}`, ...(params ? [params] : [])] as const;
};

export const useGetOrganizationBySlugQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params?: GetOrganizationBySlugParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBySlugQueryKey(organizationSlug, params);

  const getOrganizationBySlug = useGetOrganizationBySlugHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>> = ({ signal }) =>
    getOrganizationBySlug(organizationSlug, params, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationBySlugQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>
>;
export type GetOrganizationBySlugQueryError = unknown;

/**
 * @summary Organization Metadata
 */

export function useGetOrganizationBySlug<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params?: GetOrganizationBySlugParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationBySlugHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationBySlugQueryOptions(organizationSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update an organization
 */
export const useUpdateOrganizationHook = () => {
  const updateOrganization = useCustomAxios<unknown>();

  return useCallback(
    (organizationSlug: string, organizationUpdateRequestDTO: OrganizationUpdateRequestDTO) => {
      return updateOrganization({
        url: `/v1/organizations/${organizationSlug}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: organizationUpdateRequestDTO
      });
    },
    [updateOrganization]
  );
};

export const useUpdateOrganizationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationHook>>>,
    TError,
    { organizationSlug: string; data: OrganizationUpdateRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationHook>>>,
  TError,
  { organizationSlug: string; data: OrganizationUpdateRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateOrganization = useUpdateOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationHook>>>,
    { organizationSlug: string; data: OrganizationUpdateRequestDTO }
  > = props => {
    const { organizationSlug, data } = props ?? {};

    return updateOrganization(organizationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationHook>>>
>;
export type UpdateOrganizationMutationBody = OrganizationUpdateRequestDTO;
export type UpdateOrganizationMutationError = unknown;

/**
 * @summary Update an organization
 */
export const useUpdateOrganization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationHook>>>,
    TError,
    { organizationSlug: string; data: OrganizationUpdateRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateOrganizationHook>>>,
  TError,
  { organizationSlug: string; data: OrganizationUpdateRequestDTO },
  TContext
> => {
  const mutationOptions = useUpdateOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve details of a specific subfolder under a given organization.
 * @summary Get a subfolder by slug
 */
export const useGetSubfolderHook = () => {
  const getSubfolder = useCustomAxios<SubFolderDto>();

  return useCallback(
    (organizationSlug: string, subfolderSlug: string, signal?: AbortSignal) => {
      return getSubfolder({
        url: `/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}`,
        method: 'GET',
        signal
      });
    },
    [getSubfolder]
  );
};

export const getGetSubfolderQueryKey = (organizationSlug: string, subfolderSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}`] as const;
};

export const useGetSubfolderQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>,
  TError = SubFolderDto
>(
  organizationSlug: string,
  subfolderSlug: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubfolderQueryKey(organizationSlug, subfolderSlug);

  const getSubfolder = useGetSubfolderHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>> = ({ signal }) =>
    getSubfolder(organizationSlug, subfolderSlug, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && subfolderSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSubfolderQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>>;
export type GetSubfolderQueryError = SubFolderDto;

/**
 * @summary Get a subfolder by slug
 */

export function useGetSubfolder<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>,
  TError = SubFolderDto
>(
  organizationSlug: string,
  subfolderSlug: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubfolderHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSubfolderQueryOptions(organizationSlug, subfolderSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the subfolder's name, legacyId, or parent (only allowed if status is DRAFT).
 * @summary Update a subfolder
 */
export const useUpdateSubfolderHook = () => {
  const updateSubfolder = useCustomAxios<SubFolderDto>();

  return useCallback(
    (organizationSlug: string, subfolderSlug: string, updateFolderRequestBody: UpdateFolderRequestBody) => {
      return updateSubfolder({
        url: `/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateFolderRequestBody
      });
    },
    [updateSubfolder]
  );
};

export const useUpdateSubfolderMutationOptions = <TError = SubFolderDto, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateSubfolderHook>>>,
    TError,
    { organizationSlug: string; subfolderSlug: string; data: UpdateFolderRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateSubfolderHook>>>,
  TError,
  { organizationSlug: string; subfolderSlug: string; data: UpdateFolderRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateSubfolder = useUpdateSubfolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateSubfolderHook>>>,
    { organizationSlug: string; subfolderSlug: string; data: UpdateFolderRequestBody }
  > = props => {
    const { organizationSlug, subfolderSlug, data } = props ?? {};

    return updateSubfolder(organizationSlug, subfolderSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubfolderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateSubfolderHook>>>>;
export type UpdateSubfolderMutationBody = UpdateFolderRequestBody;
export type UpdateSubfolderMutationError = SubFolderDto;

/**
 * @summary Update a subfolder
 */
export const useUpdateSubfolder = <TError = SubFolderDto, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateSubfolderHook>>>,
    TError,
    { organizationSlug: string; subfolderSlug: string; data: UpdateFolderRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateSubfolderHook>>>,
  TError,
  { organizationSlug: string; subfolderSlug: string; data: UpdateFolderRequestBody },
  TContext
> => {
  const mutationOptions = useUpdateSubfolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve details of a folder under a given organization.
 * @summary Get a folder by slug
 */
export const useGetFolderHook = () => {
  const getFolder = useCustomAxios<FolderDTO>();

  return useCallback(
    (organizationSlug: string, folderSlug: string, signal?: AbortSignal) => {
      return getFolder({ url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}`, method: 'GET', signal });
    },
    [getFolder]
  );
};

export const getGetFolderQueryKey = (organizationSlug: string, folderSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/folders/${folderSlug}`] as const;
};

export const useGetFolderQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>,
  TError = FolderDTO
>(
  organizationSlug: string,
  folderSlug: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFolderQueryKey(organizationSlug, folderSlug);

  const getFolder = useGetFolderHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>> = ({ signal }) =>
    getFolder(organizationSlug, folderSlug, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && folderSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFolderQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>>;
export type GetFolderQueryError = FolderDTO;

/**
 * @summary Get a folder by slug
 */

export function useGetFolder<TData = Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>, TError = FolderDTO>(
  organizationSlug: string,
  folderSlug: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolderHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetFolderQueryOptions(organizationSlug, folderSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the folder's name, legacyId, or parent (if status is Draft). Parent type rules: If organization, cannot be Enterprise. If folder, cannot be nested.
 * @summary Update a folder
 */
export const useUpdateFolderHook = () => {
  const updateFolder = useCustomAxios<FolderDTO>();

  return useCallback(
    (organizationSlug: string, folderSlug: string, updateFolderRequestBody: UpdateFolderRequestBody) => {
      return updateFolder({
        url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateFolderRequestBody
      });
    },
    [updateFolder]
  );
};

export const useUpdateFolderMutationOptions = <TError = FolderDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string; data: UpdateFolderRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string; data: UpdateFolderRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const updateFolder = useUpdateFolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateFolderHook>>>,
    { organizationSlug: string; folderSlug: string; data: UpdateFolderRequestBody }
  > = props => {
    const { organizationSlug, folderSlug, data } = props ?? {};

    return updateFolder(organizationSlug, folderSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFolderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateFolderHook>>>>;
export type UpdateFolderMutationBody = UpdateFolderRequestBody;
export type UpdateFolderMutationError = FolderDTO;

/**
 * @summary Update a folder
 */
export const useUpdateFolder = <TError = FolderDTO, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateFolderHook>>>,
    TError,
    { organizationSlug: string; folderSlug: string; data: UpdateFolderRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateFolderHook>>>,
  TError,
  { organizationSlug: string; folderSlug: string; data: UpdateFolderRequestBody },
  TContext
> => {
  const mutationOptions = useUpdateFolderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a TestDTO example to ensure TestDTO schema appears in Swagger documentation.
 * @summary Get TestDTO example
 */
export const useGetTestDTOExampleHook = () => {
  const getTestDTOExample = useCustomAxios<TestDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getTestDTOExample({ url: `/v1/util/test-dto-example`, method: 'GET', signal });
    },
    [getTestDTOExample]
  );
};

export const getGetTestDTOExampleQueryKey = () => {
  return [`/v1/util/test-dto-example`] as const;
};

export const useGetTestDTOExampleQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTestDTOExampleQueryKey();

  const getTestDTOExample = useGetTestDTOExampleHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>> = ({ signal }) =>
    getTestDTOExample(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestDTOExampleQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>
>;
export type GetTestDTOExampleQueryError = unknown;

/**
 * @summary Get TestDTO example
 */

export function useGetTestDTOExample<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestDTOExampleHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTestDTOExampleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useTestLogoHook = () => {
  const testLogo = useCustomAxios<string>();

  return useCallback(
    (signal?: AbortSignal) => {
      return testLogo({ url: `/v1/util/sns/test-logo`, method: 'GET', signal });
    },
    [testLogo]
  );
};

export const getTestLogoQueryKey = () => {
  return [`/v1/util/sns/test-logo`] as const;
};

export const useTestLogoQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTestLogoQueryKey();

  const testLogo = useTestLogoHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>> = ({ signal }) =>
    testLogo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TestLogoQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>>;
export type TestLogoQueryError = unknown;

export function useTestLogo<
  TData = Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTestLogoHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useTestLogoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useTestHtmlEmailHook = () => {
  const testHtmlEmail = useCustomAxios<string>();

  return useCallback(
    (params: TestHtmlEmailParams, signal?: AbortSignal) => {
      return testHtmlEmail({ url: `/v1/util/sns/test-html-email`, method: 'GET', params, signal });
    },
    [testHtmlEmail]
  );
};

export const getTestHtmlEmailQueryKey = (params: TestHtmlEmailParams) => {
  return [`/v1/util/sns/test-html-email`, ...(params ? [params] : [])] as const;
};

export const useTestHtmlEmailQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>,
  TError = unknown
>(
  params: TestHtmlEmailParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTestHtmlEmailQueryKey(params);

  const testHtmlEmail = useTestHtmlEmailHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>> = ({ signal }) =>
    testHtmlEmail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TestHtmlEmailQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>>;
export type TestHtmlEmailQueryError = unknown;

export function useTestHtmlEmail<
  TData = Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>,
  TError = unknown
>(
  params: TestHtmlEmailParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTestHtmlEmailHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useTestHtmlEmailQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useSendEmailHook = () => {
  const sendEmail = useCustomAxios<string>();

  return useCallback(
    (params: SendEmailParams, signal?: AbortSignal) => {
      return sendEmail({ url: `/v1/util/sns/send-email`, method: 'GET', params, signal });
    },
    [sendEmail]
  );
};

export const getSendEmailQueryKey = (params: SendEmailParams) => {
  return [`/v1/util/sns/send-email`, ...(params ? [params] : [])] as const;
};

export const useSendEmailQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>,
  TError = unknown
>(
  params: SendEmailParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSendEmailQueryKey(params);

  const sendEmail = useSendEmailHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>> = ({ signal }) =>
    sendEmail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SendEmailQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>>;
export type SendEmailQueryError = unknown;

export function useSendEmail<TData = Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>, TError = unknown>(
  params: SendEmailParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSendEmailHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useSendEmailQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const usePreviewEmailHook = () => {
  const previewEmail = useCustomAxios<string>();

  return useCallback(
    (params?: PreviewEmailParams, signal?: AbortSignal) => {
      return previewEmail({ url: `/v1/util/sns/preview-email`, method: 'GET', params, signal });
    },
    [previewEmail]
  );
};

export const getPreviewEmailQueryKey = (params?: PreviewEmailParams) => {
  return [`/v1/util/sns/preview-email`, ...(params ? [params] : [])] as const;
};

export const usePreviewEmailQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>,
  TError = unknown
>(
  params?: PreviewEmailParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPreviewEmailQueryKey(params);

  const previewEmail = usePreviewEmailHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>> = ({ signal }) =>
    previewEmail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewEmailQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>>;
export type PreviewEmailQueryError = unknown;

export function usePreviewEmail<TData = Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>, TError = unknown>(
  params?: PreviewEmailParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePreviewEmailHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = usePreviewEmailQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all available permission keys organized by type. Use this endpoint to see all available permission key enums in the Swagger UI.
 * @summary Get permission keys reference
 */
export const useGetPermissionKeysHook = () => {
  const getPermissionKeys = useCustomAxios<PermissionKeysDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getPermissionKeys({ url: `/v1/util/permission-keys`, method: 'GET', signal });
    },
    [getPermissionKeys]
  );
};

export const getGetPermissionKeysQueryKey = () => {
  return [`/v1/util/permission-keys`] as const;
};

export const useGetPermissionKeysQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPermissionKeysQueryKey();

  const getPermissionKeys = useGetPermissionKeysHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>> = ({ signal }) =>
    getPermissionKeys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPermissionKeysQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>
>;
export type GetPermissionKeysQueryError = unknown;

/**
 * @summary Get permission keys reference
 */

export function useGetPermissionKeys<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionKeysHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetPermissionKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns permission key enums to ensure they appear as separate components in OpenAPI spec. This endpoint is specifically for exposing enum schemas in Swagger UI.
 * @summary Get permission enums reference
 */
export const useGetPermissionEnumsHook = () => {
  const getPermissionEnums = useCustomAxios<PermissionEnumsDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getPermissionEnums({ url: `/v1/util/permission-enums`, method: 'GET', signal });
    },
    [getPermissionEnums]
  );
};

export const getGetPermissionEnumsQueryKey = () => {
  return [`/v1/util/permission-enums`] as const;
};

export const useGetPermissionEnumsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPermissionEnumsQueryKey();

  const getPermissionEnums = useGetPermissionEnumsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>> = ({ signal }) =>
    getPermissionEnums(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPermissionEnumsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>
>;
export type GetPermissionEnumsQueryError = unknown;

/**
 * @summary Get permission enums reference
 */

export function useGetPermissionEnums<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionEnumsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetPermissionEnumsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search client users by first name, last name, or full name. Returns only client users (ORGANIZATION_ADMIN, ADMIN, BASIC); excludes Midot employees (MIDOT_ADMIN, CS, KAM). Returns an empty array if no users are found.
 */
export const useGetUsersBySearchHook = () => {
  const getUsersBySearch = useCustomAxios<User[]>();

  return useCallback(
    (params?: GetUsersBySearchParams, signal?: AbortSignal) => {
      return getUsersBySearch({ url: `/v1/users`, method: 'GET', params, signal });
    },
    [getUsersBySearch]
  );
};

export const getGetUsersBySearchQueryKey = (params?: GetUsersBySearchParams) => {
  return [`/v1/users`, ...(params ? [params] : [])] as const;
};

export const useGetUsersBySearchQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>,
  TError = User[]
>(
  params?: GetUsersBySearchParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersBySearchQueryKey(params);

  const getUsersBySearch = useGetUsersBySearchHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>> = ({ signal }) =>
    getUsersBySearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersBySearchQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>>;
export type GetUsersBySearchQueryError = User[];

/**
 * @summary Search client users by first name, last name, or full name. Returns only client users (ORGANIZATION_ADMIN, ADMIN, BASIC); excludes Midot employees (MIDOT_ADMIN, CS, KAM). Returns an empty array if no users are found.
 */

export function useGetUsersBySearch<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>,
  TError = User[]
>(
  params?: GetUsersBySearchParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersBySearchHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUsersBySearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a paginated list of user's role assignments grouped by location (folder)
 * @summary Get user role assignments by location
 */
export const useGetUserRoleAssignmentsByLocationHook = () => {
  const getUserRoleAssignmentsByLocation = useCustomAxios<UserLocationRoleAssignmentsResponse>();

  return useCallback(
    (userId: string, params?: GetUserRoleAssignmentsByLocationParams, signal?: AbortSignal) => {
      return getUserRoleAssignmentsByLocation({
        url: `/v1/users/${userId}/role-assignments/by-location`,
        method: 'GET',
        params,
        signal
      });
    },
    [getUserRoleAssignmentsByLocation]
  );
};

export const getGetUserRoleAssignmentsByLocationQueryKey = (
  userId: string,
  params?: GetUserRoleAssignmentsByLocationParams
) => {
  return [`/v1/users/${userId}/role-assignments/by-location`, ...(params ? [params] : [])] as const;
};

export const useGetUserRoleAssignmentsByLocationInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
  TError = unknown
>(
  userId: string,
  params?: GetUserRoleAssignmentsByLocationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserRoleAssignmentsByLocationQueryKey(userId, params);

  const getUserRoleAssignmentsByLocation = useGetUserRoleAssignmentsByLocationHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>> = ({
    signal
  }) => getUserRoleAssignmentsByLocation(userId, params, signal);

  const customOptions = useCustomGetUserRoleAssignmentsByLocationQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { userId, params },
    { url: `/v1/users/${userId}/role-assignments/by-location` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserRoleAssignmentsByLocationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>
>;
export type GetUserRoleAssignmentsByLocationInfiniteQueryError = unknown;

/**
 * @summary Get user role assignments by location
 */

export function useGetUserRoleAssignmentsByLocationInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
  TError = unknown
>(
  userId: string,
  params?: GetUserRoleAssignmentsByLocationParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserRoleAssignmentsByLocationInfiniteQueryOptions(userId, params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetUserRoleAssignmentsByLocationQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
  TError = unknown
>(
  userId: string,
  params?: GetUserRoleAssignmentsByLocationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserRoleAssignmentsByLocationQueryKey(userId, params);

  const getUserRoleAssignmentsByLocation = useGetUserRoleAssignmentsByLocationHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>> = ({
    signal
  }) => getUserRoleAssignmentsByLocation(userId, params, signal);

  const customOptions = useCustomGetUserRoleAssignmentsByLocationQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { userId, params },
    { url: `/v1/users/${userId}/role-assignments/by-location` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserRoleAssignmentsByLocationQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>
>;
export type GetUserRoleAssignmentsByLocationQueryError = unknown;

/**
 * @summary Get user role assignments by location
 */

export function useGetUserRoleAssignmentsByLocation<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
  TError = unknown
>(
  userId: string,
  params?: GetUserRoleAssignmentsByLocationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserRoleAssignmentsByLocationHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserRoleAssignmentsByLocationQueryOptions(userId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the permissions for the specified user.
 * @summary Get user permissions
 */
export const useGetUserPermissionsHook = () => {
  const getUserPermissions = useCustomAxios<UserPermissionsDTO>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return getUserPermissions({ url: `/v1/users/${userId}/permissions`, method: 'GET', signal });
    },
    [getUserPermissions]
  );
};

export const getGetUserPermissionsQueryKey = (userId: string) => {
  return [`/v1/users/${userId}/permissions`] as const;
};

export const useGetUserPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>,
  TError = unknown
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserPermissionsQueryKey(userId);

  const getUserPermissions = useGetUserPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>> = ({ signal }) =>
    getUserPermissions(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>
>;
export type GetUserPermissionsQueryError = unknown;

/**
 * @summary Get user permissions
 */

export function useGetUserPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>,
  TError = unknown
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserPermissionsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserPermissionsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of organizations the user is a member of, with admin status for each. Only accessible by the user themselves or Global Admins.
 * @summary Get user's organizations
 */
export const useGetUserOrganizationsHook = () => {
  const getUserOrganizations = useCustomAxios<GetUserOrganizationsResponseDto>();

  return useCallback(
    (userId: string, params?: GetUserOrganizationsParams, signal?: AbortSignal) => {
      return getUserOrganizations({ url: `/v1/users/${userId}/organizations`, method: 'GET', params, signal });
    },
    [getUserOrganizations]
  );
};

export const getGetUserOrganizationsQueryKey = (userId: string, params?: GetUserOrganizationsParams) => {
  return [`/v1/users/${userId}/organizations`, ...(params ? [params] : [])] as const;
};

export const useGetUserOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>,
  TError = unknown
>(
  userId: string,
  params?: GetUserOrganizationsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserOrganizationsQueryKey(userId, params);

  const getUserOrganizations = useGetUserOrganizationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>> = ({ signal }) =>
    getUserOrganizations(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>
>;
export type GetUserOrganizationsQueryError = unknown;

/**
 * @summary Get user's organizations
 */

export function useGetUserOrganizations<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>,
  TError = unknown
>(
  userId: string,
  params?: GetUserOrganizationsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserOrganizationsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns information about the currently authenticated user.
For API key authentication, returns a system user with predefined values.
For regular users, returns their actual user information from the database.
 * @summary Get current user information
 */
export const useGetCurrentUserHook = () => {
  const getCurrentUser = useCustomAxios<UserDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getCurrentUser({ url: `/v1/users/me`, method: 'GET', signal });
    },
    [getCurrentUser]
  );
};

export const getGetCurrentUserQueryKey = () => {
  return [`/v1/users/me`] as const;
};

export const useGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const getCurrentUser = useGetCurrentUserHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>> = ({ signal }) =>
    getCurrentUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>>;
export type GetCurrentUserQueryError = unknown;

/**
 * @summary Get current user information
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get users by UUIDs. Returns an empty array if no users are found.
 */
export const useGetUsersByIdsHook = () => {
  const getUsersByIds = useCustomAxios<User[]>();

  return useCallback(
    (params: GetUsersByIdsParams, signal?: AbortSignal) => {
      return getUsersByIds({ url: `/v1/users/by-ids`, method: 'GET', params, signal });
    },
    [getUsersByIds]
  );
};

export const getGetUsersByIdsQueryKey = (params: GetUsersByIdsParams) => {
  return [`/v1/users/by-ids`, ...(params ? [params] : [])] as const;
};

export const useGetUsersByIdsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>,
  TError = User[]
>(
  params: GetUsersByIdsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersByIdsQueryKey(params);

  const getUsersByIds = useGetUsersByIdsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>> = ({ signal }) =>
    getUsersByIds(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersByIdsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>>;
export type GetUsersByIdsQueryError = User[];

/**
 * @summary Get users by UUIDs. Returns an empty array if no users are found.
 */

export function useGetUsersByIds<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>, TError = User[]>(
  params: GetUsersByIdsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersByIdsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUsersByIdsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Autocomplete search for client users by full name or email. Returns only client users (ORGANIZATION_ADMIN, ADMIN, BASIC); excludes Midot employees (MIDOT_ADMIN, CS, KAM).
 */
export const useAutocompleteUsersHook = () => {
  const autocompleteUsers = useCustomAxios<AutocompleteUsersResponseDto>();

  return useCallback(
    (params?: AutocompleteUsersParams, signal?: AbortSignal) => {
      return autocompleteUsers({ url: `/v1/users/autocomplete`, method: 'GET', params, signal });
    },
    [autocompleteUsers]
  );
};

export const getAutocompleteUsersQueryKey = (params?: AutocompleteUsersParams) => {
  return [`/v1/users/autocomplete`, ...(params ? [params] : [])] as const;
};

export const useAutocompleteUsersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>,
  TError = unknown
>(
  params?: AutocompleteUsersParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAutocompleteUsersQueryKey(params);

  const autocompleteUsers = useAutocompleteUsersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>> = ({ signal }) =>
    autocompleteUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AutocompleteUsersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>
>;
export type AutocompleteUsersQueryError = unknown;

/**
 * @summary Autocomplete search for client users by full name or email. Returns only client users (ORGANIZATION_ADMIN, ADMIN, BASIC); excludes Midot employees (MIDOT_ADMIN, CS, KAM).
 */

export function useAutocompleteUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>,
  TError = unknown
>(
  params?: AutocompleteUsersParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAutocompleteUsersHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useAutocompleteUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns user organization assignments. Each row is one (user, organization) pair.
Results are first restricted to organizations that share an office with the session user's visible offices (same source as GET /v1/offices: user.offices → DB). Role-based visibility (CS, KAM, ORG_ADMIN, etc.) applies on top. MIDOT_ADMIN / global admin with no offices on the user document skips the office gate.

Supports search across first name, last name, full name, organization name, and email.
Results are paginated and can be filtered by organization ID.

 * @summary Get user organization assignments
 */
export const useGetUserOrganizationAssignmentsHook = () => {
  const getUserOrganizationAssignments = useCustomAxios<UserOrganizationAssignmentsResponseDTO>();

  return useCallback(
    (params?: GetUserOrganizationAssignmentsParams, signal?: AbortSignal) => {
      return getUserOrganizationAssignments({
        url: `/v1/user-organization-assignments`,
        method: 'GET',
        params,
        signal
      });
    },
    [getUserOrganizationAssignments]
  );
};

export const getGetUserOrganizationAssignmentsQueryKey = (params?: GetUserOrganizationAssignmentsParams) => {
  return [`/v1/user-organization-assignments`, ...(params ? [params] : [])] as const;
};

export const useGetUserOrganizationAssignmentsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
  TError = unknown
>(
  params?: GetUserOrganizationAssignmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserOrganizationAssignmentsQueryKey(params);

  const getUserOrganizationAssignments = useGetUserOrganizationAssignmentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>> = ({
    signal
  }) => getUserOrganizationAssignments(params, signal);

  const customOptions = useCustomFilterUserOrganizationAssignmentsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { params },
    { url: `/v1/user-organization-assignments` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserOrganizationAssignmentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>
>;
export type GetUserOrganizationAssignmentsInfiniteQueryError = unknown;

/**
 * @summary Get user organization assignments
 */

export function useGetUserOrganizationAssignmentsInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
  TError = unknown
>(
  params?: GetUserOrganizationAssignmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserOrganizationAssignmentsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetUserOrganizationAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
  TError = unknown
>(
  params?: GetUserOrganizationAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserOrganizationAssignmentsQueryKey(params);

  const getUserOrganizationAssignments = useGetUserOrganizationAssignmentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>> = ({
    signal
  }) => getUserOrganizationAssignments(params, signal);

  const customOptions = useCustomFilterUserOrganizationAssignmentsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { params },
    { url: `/v1/user-organization-assignments` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserOrganizationAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>
>;
export type GetUserOrganizationAssignmentsQueryError = unknown;

/**
 * @summary Get user organization assignments
 */

export function useGetUserOrganizationAssignments<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
  TError = unknown
>(
  params?: GetUserOrganizationAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetUserOrganizationAssignmentsHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserOrganizationAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves norms for a specific test type. When testTypeId is 'default', returns all default norms. Supports pagination and free-text search over norm titles.
 * @summary Get norms by test type
 */
export const useGetTestTypeNormsHook = () => {
  const getTestTypeNorms = useCustomAxios<GetTestTypeNormsResponseDto>();

  return useCallback(
    (testTypeId: string, params?: GetTestTypeNormsParams, signal?: AbortSignal) => {
      return getTestTypeNorms({ url: `/v1/test-type/${testTypeId}/norms`, method: 'GET', params, signal });
    },
    [getTestTypeNorms]
  );
};

export const getGetTestTypeNormsQueryKey = (testTypeId: string, params?: GetTestTypeNormsParams) => {
  return [`/v1/test-type/${testTypeId}/norms`, ...(params ? [params] : [])] as const;
};

export const useGetTestTypeNormsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>,
  TError = unknown
>(
  testTypeId: string,
  params?: GetTestTypeNormsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTestTypeNormsQueryKey(testTypeId, params);

  const getTestTypeNorms = useGetTestTypeNormsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>> = ({ signal }) =>
    getTestTypeNorms(testTypeId, params, signal);

  return { queryKey, queryFn, enabled: !!testTypeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestTypeNormsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>>;
export type GetTestTypeNormsQueryError = unknown;

/**
 * @summary Get norms by test type
 */

export function useGetTestTypeNorms<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>,
  TError = unknown
>(
  testTypeId: string,
  params?: GetTestTypeNormsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestTypeNormsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTestTypeNormsQueryOptions(testTypeId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve detailed information about a single test session, including talent, process, scores, and settings.
 * @summary Get Test Session
 */
export const useGetTestSessionHook = () => {
  const getTestSession = useCustomAxios<TestSessionDetailDTO>();

  return useCallback(
    (testSessionId: string, signal?: AbortSignal) => {
      return getTestSession({ url: `/v1/test-sessions/${testSessionId}`, method: 'GET', signal });
    },
    [getTestSession]
  );
};

export const getGetTestSessionQueryKey = (testSessionId: string) => {
  return [`/v1/test-sessions/${testSessionId}`] as const;
};

export const useGetTestSessionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>,
  TError = TestSessionDetailDTO
>(
  testSessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTestSessionQueryKey(testSessionId);

  const getTestSession = useGetTestSessionHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>> = ({ signal }) =>
    getTestSession(testSessionId, signal);

  return { queryKey, queryFn, enabled: !!testSessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestSessionQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>>;
export type GetTestSessionQueryError = TestSessionDetailDTO;

/**
 * @summary Get Test Session
 */

export function useGetTestSession<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>,
  TError = TestSessionDetailDTO
>(
  testSessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestSessionHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTestSessionQueryOptions(testSessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve webcam captures for a test session (same data as in the report). Each capture has timestamp, imageUrl, and optional aiViolation.
 * @summary Get featured webcam captures
 */
export const useGetFeaturedWebcamCapturesHook = () => {
  const getFeaturedWebcamCaptures = useCustomAxios<TestSessionFeaturedWebcamCapturesDto>();

  return useCallback(
    (testSessionId: string, signal?: AbortSignal) => {
      return getFeaturedWebcamCaptures({
        url: `/v1/test-sessions/${testSessionId}/webcam-data/featured-captures`,
        method: 'GET',
        signal
      });
    },
    [getFeaturedWebcamCaptures]
  );
};

export const getGetFeaturedWebcamCapturesQueryKey = (testSessionId: string) => {
  return [`/v1/test-sessions/${testSessionId}/webcam-data/featured-captures`] as const;
};

export const useGetFeaturedWebcamCapturesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>,
  TError = TestSessionFeaturedWebcamCapturesDto
>(
  testSessionId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeaturedWebcamCapturesQueryKey(testSessionId);

  const getFeaturedWebcamCaptures = useGetFeaturedWebcamCapturesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>> = ({
    signal
  }) => getFeaturedWebcamCaptures(testSessionId, signal);

  return { queryKey, queryFn, enabled: !!testSessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeaturedWebcamCapturesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>
>;
export type GetFeaturedWebcamCapturesQueryError = TestSessionFeaturedWebcamCapturesDto;

/**
 * @summary Get featured webcam captures
 */

export function useGetFeaturedWebcamCaptures<
  TData = Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>,
  TError = TestSessionFeaturedWebcamCapturesDto
>(
  testSessionId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFeaturedWebcamCapturesHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetFeaturedWebcamCapturesQueryOptions(testSessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve test session and exam data for reporting using TestSession ID.
 * @summary Get Report Data
 */
export const useGetReportHook = () => {
  const getReport = useCustomAxios<ReportDataDTO>();

  return useCallback(
    (testSessionId: string, params?: GetReportParams, signal?: AbortSignal) => {
      return getReport({ url: `/v1/test-sessions/${testSessionId}/report`, method: 'GET', params, signal });
    },
    [getReport]
  );
};

export const getGetReportQueryKey = (testSessionId: string, params?: GetReportParams) => {
  return [`/v1/test-sessions/${testSessionId}/report`, ...(params ? [params] : [])] as const;
};

export const useGetReportQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>,
  TError = Report
>(
  testSessionId: string,
  params?: GetReportParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportQueryKey(testSessionId, params);

  const getReport = useGetReportHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>> = ({ signal }) =>
    getReport(testSessionId, params, signal);

  return { queryKey, queryFn, enabled: !!testSessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>>;
export type GetReportQueryError = Report;

/**
 * @summary Get Report Data
 */

export function useGetReport<TData = Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>, TError = Report>(
  testSessionId: string,
  params?: GetReportParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetReportQueryOptions(testSessionId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get what the connected user is allowed to do for the specified talent.
 * @summary Get talent permissions
 */
export const useGetTalentPermissionsHook = () => {
  const getTalentPermissions = useCustomAxios<TalentPermissionsDTO>();

  return useCallback(
    (talentId: string, signal?: AbortSignal) => {
      return getTalentPermissions({ url: `/v1/talents/${talentId}/permissions`, method: 'GET', signal });
    },
    [getTalentPermissions]
  );
};

export const getGetTalentPermissionsQueryKey = (talentId: string) => {
  return [`/v1/talents/${talentId}/permissions`] as const;
};

export const useGetTalentPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>,
  TError = unknown
>(
  talentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTalentPermissionsQueryKey(talentId);

  const getTalentPermissions = useGetTalentPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>> = ({ signal }) =>
    getTalentPermissions(talentId, signal);

  return { queryKey, queryFn, enabled: !!talentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTalentPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>
>;
export type GetTalentPermissionsQueryError = unknown;

/**
 * @summary Get talent permissions
 */

export function useGetTalentPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>,
  TError = unknown
>(
  talentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTalentPermissionsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTalentPermissionsQueryOptions(talentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Redirect to talent's CV
 */
export const useGetSignedCvUrlHook = () => {
  const getSignedCvUrl = useCustomAxios<unknown>();

  return useCallback(
    (talentId: string, signal?: AbortSignal) => {
      return getSignedCvUrl({ url: `/v1/talents/${talentId}/cv`, method: 'GET', signal });
    },
    [getSignedCvUrl]
  );
};

export const getGetSignedCvUrlQueryKey = (talentId: string) => {
  return [`/v1/talents/${talentId}/cv`] as const;
};

export const useGetSignedCvUrlQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>,
  TError = void
>(
  talentId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSignedCvUrlQueryKey(talentId);

  const getSignedCvUrl = useGetSignedCvUrlHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>> = ({ signal }) =>
    getSignedCvUrl(talentId, signal);

  return { queryKey, queryFn, enabled: !!talentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSignedCvUrlQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>>;
export type GetSignedCvUrlQueryError = void;

/**
 * @summary Redirect to talent's CV
 */

export function useGetSignedCvUrl<TData = Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>, TError = void>(
  talentId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSignedCvUrlHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSignedCvUrlQueryOptions(talentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of talents matching the search string
 * @summary Talents Autosuggest
 */
export const useAutosuggestTalentsHook = () => {
  const autosuggestTalents = useCustomAxios<MiniTalent[]>();

  return useCallback(
    (params: AutosuggestTalentsParams, signal?: AbortSignal) => {
      return autosuggestTalents({ url: `/v1/talents/autosuggest`, method: 'GET', params, signal });
    },
    [autosuggestTalents]
  );
};

export const getAutosuggestTalentsQueryKey = (params: AutosuggestTalentsParams) => {
  return [`/v1/talents/autosuggest`, ...(params ? [params] : [])] as const;
};

export const useAutosuggestTalentsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>,
  TError = unknown
>(
  params: AutosuggestTalentsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAutosuggestTalentsQueryKey(params);

  const autosuggestTalents = useAutosuggestTalentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>> = ({ signal }) =>
    autosuggestTalents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AutosuggestTalentsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>
>;
export type AutosuggestTalentsQueryError = unknown;

/**
 * @summary Talents Autosuggest
 */

export function useAutosuggestTalents<
  TData = Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>,
  TError = unknown
>(
  params: AutosuggestTalentsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAutosuggestTalentsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useAutosuggestTalentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get what the connected user is allowed to do in the specified suborganization.
 * @summary Get suborganization permissions
 */
export const useGetSuborganizationPermissionsHook = () => {
  const getSuborganizationPermissions = useCustomAxios<SuborganizationPermissionsDTO>();

  return useCallback(
    (suborganizationSlug: string, signal?: AbortSignal) => {
      return getSuborganizationPermissions({
        url: `/v1/suborganizations/${suborganizationSlug}/permissions`,
        method: 'GET',
        signal
      });
    },
    [getSuborganizationPermissions]
  );
};

export const getGetSuborganizationPermissionsQueryKey = (suborganizationSlug: string) => {
  return [`/v1/suborganizations/${suborganizationSlug}/permissions`] as const;
};

export const useGetSuborganizationPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>,
  TError = unknown
>(
  suborganizationSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuborganizationPermissionsQueryKey(suborganizationSlug);

  const getSuborganizationPermissions = useGetSuborganizationPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>> = ({
    signal
  }) => getSuborganizationPermissions(suborganizationSlug, signal);

  return { queryKey, queryFn, enabled: !!suborganizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuborganizationPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>
>;
export type GetSuborganizationPermissionsQueryError = unknown;

/**
 * @summary Get suborganization permissions
 */

export function useGetSuborganizationPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>,
  TError = unknown
>(
  suborganizationSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetSuborganizationPermissionsHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSuborganizationPermissionsQueryOptions(suborganizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useListUsersHook = () => {
  const listUsers = useCustomAxios<ListUsers200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return listUsers({ url: `/v1/simple-auth/users`, method: 'GET', signal });
    },
    [listUsers]
  );
};

export const getListUsersQueryKey = () => {
  return [`/v1/simple-auth/users`] as const;
};

export const useListUsersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey();

  const listUsers = useListUsersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>> = ({ signal }) =>
    listUsers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>>;
export type ListUsersQueryError = unknown;

export function useListUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUsersHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useListUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetSessionHook = () => {
  const getSession = useCustomAxios<GetSession200>();

  return useCallback(
    (params: GetSessionParams, signal?: AbortSignal) => {
      return getSession({ url: `/v1/simple-auth/session`, method: 'GET', params, signal });
    },
    [getSession]
  );
};

export const getGetSessionQueryKey = (params: GetSessionParams) => {
  return [`/v1/simple-auth/session`, ...(params ? [params] : [])] as const;
};

export const useGetSessionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>,
  TError = unknown
>(
  params: GetSessionParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey(params);

  const getSession = useGetSessionHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>> = ({ signal }) =>
    getSession(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>>;
export type GetSessionQueryError = unknown;

export function useGetSession<TData = Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>, TError = unknown>(
  params: GetSessionParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSessionHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSessionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generates a temporary pre-signed URL that allows downloading a file directly from AWS S3.
 * @summary Generate a pre-signed URL for downloading a file
 */
export const useGetPresignedDownloadUrlHook = () => {
  const getPresignedDownloadUrl = useCustomAxios<PreSignedUrlResponseDTO>();

  return useCallback(
    (processId: string, talentId: string, fileId: string, signal?: AbortSignal) => {
      return getPresignedDownloadUrl({
        url: `/v1/processes/${processId}/talents/${talentId}/files/${fileId}/download`,
        method: 'GET',
        signal
      });
    },
    [getPresignedDownloadUrl]
  );
};

export const getGetPresignedDownloadUrlQueryKey = (processId: string, talentId: string, fileId: string) => {
  return [`/v1/processes/${processId}/talents/${talentId}/files/${fileId}/download`] as const;
};

export const useGetPresignedDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>,
  TError = unknown
>(
  processId: string,
  talentId: string,
  fileId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPresignedDownloadUrlQueryKey(processId, talentId, fileId);

  const getPresignedDownloadUrl = useGetPresignedDownloadUrlHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>> = ({ signal }) =>
    getPresignedDownloadUrl(processId, talentId, fileId, signal);

  return { queryKey, queryFn, enabled: !!(processId && talentId && fileId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPresignedDownloadUrlQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>
>;
export type GetPresignedDownloadUrlQueryError = unknown;

/**
 * @summary Generate a pre-signed URL for downloading a file
 */

export function useGetPresignedDownloadUrl<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>,
  TError = unknown
>(
  processId: string,
  talentId: string,
  fileId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPresignedDownloadUrlHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetPresignedDownloadUrlQueryOptions(processId, talentId, fileId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns aggregated statistics for talents and tests in a process, used for the right-side panel visualization.
 * @summary Get aggregated stats for a process (right-side panel)
 */
export const useGetProcessStatsHook = () => {
  const getProcessStats = useCustomAxios<GetProcessStatsResponseDTO>();

  return useCallback(
    (processId: string, signal?: AbortSignal) => {
      return getProcessStats({ url: `/v1/processes/${processId}/stats`, method: 'GET', signal });
    },
    [getProcessStats]
  );
};

export const getGetProcessStatsQueryKey = (processId: string) => {
  return [`/v1/processes/${processId}/stats`] as const;
};

export const useGetProcessStatsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>,
  TError = unknown
>(
  processId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessStatsQueryKey(processId);

  const getProcessStats = useGetProcessStatsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>> = ({ signal }) =>
    getProcessStats(processId, signal);

  return { queryKey, queryFn, enabled: !!processId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>>;
export type GetProcessStatsQueryError = unknown;

/**
 * @summary Get aggregated stats for a process (right-side panel)
 */

export function useGetProcessStats<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>,
  TError = unknown
>(
  processId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessStatsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessStatsQueryOptions(processId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get what the connected user is allowed to do on the specified process. When the process status is ACTIVE, `canManageTests` is always false (test setup is locked while the process is live).
 * @summary Get process permissions
 */
export const useGetProcessPermissionsHook = () => {
  const getProcessPermissions = useCustomAxios<ProcessPermissionsDTO>();

  return useCallback(
    (processId: string, signal?: AbortSignal) => {
      return getProcessPermissions({ url: `/v1/processes/${processId}/permissions`, method: 'GET', signal });
    },
    [getProcessPermissions]
  );
};

export const getGetProcessPermissionsQueryKey = (processId: string) => {
  return [`/v1/processes/${processId}/permissions`] as const;
};

export const useGetProcessPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>,
  TError = unknown
>(
  processId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessPermissionsQueryKey(processId);

  const getProcessPermissions = useGetProcessPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>> = ({ signal }) =>
    getProcessPermissions(processId, signal);

  return { queryKey, queryFn, enabled: !!processId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>
>;
export type GetProcessPermissionsQueryError = unknown;

/**
 * @summary Get process permissions
 */

export function useGetProcessPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>,
  TError = unknown
>(
  processId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessPermissionsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessPermissionsQueryOptions(processId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the messages set for this process in the requested language. If the language is not available, returns the default language.
 * @summary Get process messages
 */
export const useGetProcessMessagesHook = () => {
  const getProcessMessages = useCustomAxios<ProcessMessages>();

  return useCallback(
    (processId: string, params?: GetProcessMessagesParams, signal?: AbortSignal) => {
      return getProcessMessages({ url: `/v1/processes/${processId}/messages`, method: 'GET', params, signal });
    },
    [getProcessMessages]
  );
};

export const getGetProcessMessagesQueryKey = (processId: string, params?: GetProcessMessagesParams) => {
  return [`/v1/processes/${processId}/messages`, ...(params ? [params] : [])] as const;
};

export const useGetProcessMessagesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>,
  TError = unknown
>(
  processId: string,
  params?: GetProcessMessagesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessMessagesQueryKey(processId, params);

  const getProcessMessages = useGetProcessMessagesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>> = ({ signal }) =>
    getProcessMessages(processId, params, signal);

  return { queryKey, queryFn, enabled: !!processId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessMessagesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>
>;
export type GetProcessMessagesQueryError = unknown;

/**
 * @summary Get process messages
 */

export function useGetProcessMessages<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>,
  TError = unknown
>(
  processId: string,
  params?: GetProcessMessagesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessMessagesHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessMessagesQueryOptions(processId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves only the external talent questions for a given process ID. External questions are those where isExternal=true.
 * @summary Get external talent questions for a process
 */
export const useGetProcessExternalTalentQuestionsHook = () => {
  const getProcessExternalTalentQuestions = useCustomAxios<TalentQuestionsResponseDTO>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getProcessExternalTalentQuestions({
        url: `/v1/processes/${id}/external-talent-questions`,
        method: 'GET',
        signal
      });
    },
    [getProcessExternalTalentQuestions]
  );
};

export const getGetProcessExternalTalentQuestionsQueryKey = (id: string) => {
  return [`/v1/processes/${id}/external-talent-questions`] as const;
};

export const useGetProcessExternalTalentQuestionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessExternalTalentQuestionsQueryKey(id);

  const getProcessExternalTalentQuestions = useGetProcessExternalTalentQuestionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>> = ({
    signal
  }) => getProcessExternalTalentQuestions(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessExternalTalentQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>
>;
export type GetProcessExternalTalentQuestionsQueryError = unknown;

/**
 * @summary Get external talent questions for a process
 */

export function useGetProcessExternalTalentQuestions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetProcessExternalTalentQuestionsHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessExternalTalentQuestionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get basic process information including processSettings (testSettings)
 * @summary Get process base info
 */
export const useGetProcessBaseInfoHook = () => {
  const getProcessBaseInfo = useCustomAxios<ProcessShortDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getProcessBaseInfo({ url: `/v1/processes/${id}/base-info`, method: 'GET', signal });
    },
    [getProcessBaseInfo]
  );
};

export const getGetProcessBaseInfoQueryKey = (id: string) => {
  return [`/v1/processes/${id}/base-info`] as const;
};

export const useGetProcessBaseInfoQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>,
  TError = ProcessShortDto
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessBaseInfoQueryKey(id);

  const getProcessBaseInfo = useGetProcessBaseInfoHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>> = ({ signal }) =>
    getProcessBaseInfo(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessBaseInfoQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>
>;
export type GetProcessBaseInfoQueryError = ProcessShortDto;

/**
 * @summary Get process base info
 */

export function useGetProcessBaseInfo<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>,
  TError = ProcessShortDto
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessBaseInfoHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessBaseInfoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetches processes matching the optional search string.
 * @summary Get processes with optional autosuggest
 */
export const useGetProcessesHook = () => {
  const getProcesses = useCustomAxios<ProcessDTO[]>();

  return useCallback(
    (params?: GetProcessesParams, signal?: AbortSignal) => {
      return getProcesses({ url: `/v1/processes/autosuggest`, method: 'GET', params, signal });
    },
    [getProcesses]
  );
};

export const getGetProcessesQueryKey = (params?: GetProcessesParams) => {
  return [`/v1/processes/autosuggest`, ...(params ? [params] : [])] as const;
};

export const useGetProcessesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>,
  TError = unknown
>(
  params?: GetProcessesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProcessesQueryKey(params);

  const getProcesses = useGetProcessesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>> = ({ signal }) =>
    getProcesses(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProcessesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>>;
export type GetProcessesQueryError = unknown;

/**
 * @summary Get processes with optional autosuggest
 */

export function useGetProcesses<TData = Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>, TError = unknown>(
  params?: GetProcessesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProcessesHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProcessesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the current user's platform-level permissions. These permissions determine what actions the user can perform at the platform level, such as creating organizations, creating users, and assigning roles. All authenticated users can access this endpoint - BASIC users will receive all permissions as false.
 * @summary Get platform permissions
 */
export const useGetPlatformPermissionsHook = () => {
  const getPlatformPermissions = useCustomAxios<PodiumPermissionsDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getPlatformPermissions({ url: `/v1/permissions`, method: 'GET', signal });
    },
    [getPlatformPermissions]
  );
};

export const getGetPlatformPermissionsQueryKey = () => {
  return [`/v1/permissions`] as const;
};

export const useGetPlatformPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>,
  TError = void
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformPermissionsQueryKey();

  const getPlatformPermissions = useGetPlatformPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>> = ({ signal }) =>
    getPlatformPermissions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>
>;
export type GetPlatformPermissionsQueryError = void;

/**
 * @summary Get platform permissions
 */

export function useGetPlatformPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>,
  TError = void
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPlatformPermissionsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetPlatformPermissionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all available permission keys organized by type (platform, user, talent, organization, etc.). Use this endpoint to see all available permission key enums and their values.
 * @summary Get all permission keys
 */
export const useGetPermissionKeys1Hook = () => {
  const getPermissionKeys1 = useCustomAxios<PermissionKeysDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getPermissionKeys1({ url: `/v1/permissions/keys`, method: 'GET', signal });
    },
    [getPermissionKeys1]
  );
};

export const getGetPermissionKeys1QueryKey = () => {
  return [`/v1/permissions/keys`] as const;
};

export const useGetPermissionKeys1QueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPermissionKeys1QueryKey();

  const getPermissionKeys1 = useGetPermissionKeys1Hook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>> = ({ signal }) =>
    getPermissionKeys1(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPermissionKeys1QueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>
>;
export type GetPermissionKeys1QueryError = unknown;

/**
 * @summary Get all permission keys
 */

export function useGetPermissionKeys1<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionKeys1Hook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetPermissionKeys1QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns permission key enums to ensure they appear as separate components in OpenAPI spec. This endpoint is specifically for exposing enum schemas in Swagger UI and for TypeScript type generation.
 * @summary Get permission enums reference
 */
export const useGetPermissionEnums1Hook = () => {
  const getPermissionEnums1 = useCustomAxios<PermissionEnumsDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getPermissionEnums1({ url: `/v1/permissions/enums`, method: 'GET', signal });
    },
    [getPermissionEnums1]
  );
};

export const getGetPermissionEnums1QueryKey = () => {
  return [`/v1/permissions/enums`] as const;
};

export const useGetPermissionEnums1QueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPermissionEnums1QueryKey();

  const getPermissionEnums1 = useGetPermissionEnums1Hook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>> = ({ signal }) =>
    getPermissionEnums1(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPermissionEnums1QueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>
>;
export type GetPermissionEnums1QueryError = unknown;

/**
 * @summary Get permission enums reference
 */

export function useGetPermissionEnums1<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPermissionEnums1Hook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetPermissionEnums1QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get what the connected user is allowed to do across subfolders in the specified organization and subfolder.
 * @summary Get subfolder permissions
 */
export const useGetSubfolderPermissionsHook = () => {
  const getSubfolderPermissions = useCustomAxios<SubfolderPermissionsDTO>();

  return useCallback(
    (organizationSlug: string, subfolderSlug: string, signal?: AbortSignal) => {
      return getSubfolderPermissions({
        url: `/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}/permissions`,
        method: 'GET',
        signal
      });
    },
    [getSubfolderPermissions]
  );
};

export const getGetSubfolderPermissionsQueryKey = (organizationSlug: string, subfolderSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/subfolders/${subfolderSlug}/permissions`] as const;
};

export const useGetSubfolderPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  subfolderSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubfolderPermissionsQueryKey(organizationSlug, subfolderSlug);

  const getSubfolderPermissions = useGetSubfolderPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>> = ({ signal }) =>
    getSubfolderPermissions(organizationSlug, subfolderSlug, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && subfolderSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSubfolderPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>
>;
export type GetSubfolderPermissionsQueryError = unknown;

/**
 * @summary Get subfolder permissions
 */

export function useGetSubfolderPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  subfolderSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubfolderPermissionsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetSubfolderPermissionsQueryOptions(organizationSlug, subfolderSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve the hierarchical structure of an organization, including sub-organizations and folders. Sub-organizations in DRAFT status and their folder subtree are omitted (not selectable for assignments or invites). Access follows role rules plus session-visible offices (same org boundary as filtered org listing / GET /v1/offices). CS/KAM see folders and sub-organizations intersected with those offices (slug, id, key). Examples (vasya-inc-2_60f91c,brit-finance_60f919)
 * @summary Get organization structure
 */
export const useGetOrganizationStructureHook = () => {
  const getOrganizationStructure = useCustomAxios<OrganizationStructureDTO>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return getOrganizationStructure({
        url: `/v1/organizations/${organizationSlug}/structure`,
        method: 'GET',
        signal
      });
    },
    [getOrganizationStructure]
  );
};

export const getGetOrganizationStructureQueryKey = (organizationSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/structure`] as const;
};

export const useGetOrganizationStructureQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationStructureQueryKey(organizationSlug);

  const getOrganizationStructure = useGetOrganizationStructureHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>> = ({
    signal
  }) => getOrganizationStructure(organizationSlug, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationStructureQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>
>;
export type GetOrganizationStructureQueryError = unknown;

/**
 * @summary Get organization structure
 */

export function useGetOrganizationStructure<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationStructureHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationStructureQueryOptions(organizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get what the connected user is allowed to do in the specified organization.
 * @summary Get organization permissions
 */
export const useGetOrganizationPermissionsHook = () => {
  const getOrganizationPermissions = useCustomAxios<OrganizationPermissionsDTO>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return getOrganizationPermissions({
        url: `/v1/organizations/${organizationSlug}/permissions`,
        method: 'GET',
        signal
      });
    },
    [getOrganizationPermissions]
  );
};

export const getGetOrganizationPermissionsQueryKey = (organizationSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/permissions`] as const;
};

export const useGetOrganizationPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationPermissionsQueryKey(organizationSlug);

  const getOrganizationPermissions = useGetOrganizationPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>> = ({
    signal
  }) => getOrganizationPermissions(organizationSlug, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>
>;
export type GetOrganizationPermissionsQueryError = unknown;

/**
 * @summary Get organization permissions
 */

export function useGetOrganizationPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationPermissionsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationPermissionsQueryOptions(organizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the legacyId of the organization identified by the provided slug.
 * @summary Get legacyId by organization slug
 */
export const useGetOrganizationLegacyIdHook = () => {
  const getOrganizationLegacyId = useCustomAxios<number>();

  return useCallback(
    (organizationSlug: string, signal?: AbortSignal) => {
      return getOrganizationLegacyId({ url: `/v1/organizations/${organizationSlug}/legacyId`, method: 'GET', signal });
    },
    [getOrganizationLegacyId]
  );
};

export const getGetOrganizationLegacyIdQueryKey = (organizationSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/legacyId`] as const;
};

export const useGetOrganizationLegacyIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>,
  TError = number
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationLegacyIdQueryKey(organizationSlug);

  const getOrganizationLegacyId = useGetOrganizationLegacyIdHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>> = ({ signal }) =>
    getOrganizationLegacyId(organizationSlug, signal);

  return { queryKey, queryFn, enabled: !!organizationSlug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationLegacyIdQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>
>;
export type GetOrganizationLegacyIdQueryError = number;

/**
 * @summary Get legacyId by organization slug
 */

export function useGetOrganizationLegacyId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>,
  TError = number
>(
  organizationSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationLegacyIdHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationLegacyIdQueryOptions(organizationSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve items (suborganizations, folders, or subfolders) at a specified location within an organization based on pagination and location type.
 * @summary Get organization items
 */
export const useGetOrganizationItemsHook = () => {
  const getOrganizationItems = useCustomAxios<OrganizationItemsResponseDto>();

  return useCallback(
    (organizationSlug: string, params: GetOrganizationItemsParams, signal?: AbortSignal) => {
      return getOrganizationItems({
        url: `/v1/organizations/${organizationSlug}/items`,
        method: 'GET',
        params,
        signal
      });
    },
    [getOrganizationItems]
  );
};

export const getGetOrganizationItemsQueryKey = (organizationSlug: string, params: GetOrganizationItemsParams) => {
  return [`/v1/organizations/${organizationSlug}/items`, ...(params ? [params] : [])] as const;
};

export const useGetOrganizationItemsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params: GetOrganizationItemsParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationItemsQueryKey(organizationSlug, params);

  const getOrganizationItems = useGetOrganizationItemsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>> = ({ signal }) =>
    getOrganizationItems(organizationSlug, params, signal);

  const customOptions = useCustomFilterOrganizationItemsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { organizationSlug, params },
    { url: `/v1/organizations/${organizationSlug}/items` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationItemsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>
>;
export type GetOrganizationItemsInfiniteQueryError = unknown;

/**
 * @summary Get organization items
 */

export function useGetOrganizationItemsInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params: GetOrganizationItemsParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>, TError, TData>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationItemsInfiniteQueryOptions(organizationSlug, params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetOrganizationItemsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params: GetOrganizationItemsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationItemsQueryKey(organizationSlug, params);

  const getOrganizationItems = useGetOrganizationItemsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>> = ({ signal }) =>
    getOrganizationItems(organizationSlug, params, signal);

  const customOptions = useCustomFilterOrganizationItemsQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { organizationSlug, params },
    { url: `/v1/organizations/${organizationSlug}/items` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationItemsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>
>;
export type GetOrganizationItemsQueryError = unknown;

/**
 * @summary Get organization items
 */

export function useGetOrganizationItems<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  params: GetOrganizationItemsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationItemsQueryOptions(organizationSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a specific organizationItemDto (organization, suborganization, folder, or subfolder) within an organization by its slug and location type.
 * @summary Get an organization organization item
 */
export const useGetOrganizationItemHook = () => {
  const getOrganizationItem = useCustomAxios<OrganizationItemDto>();

  return useCallback(
    (organizationSlug: string, itemSlug: string, params: GetOrganizationItemParams, signal?: AbortSignal) => {
      return getOrganizationItem({
        url: `/v1/organizations/${organizationSlug}/items/${itemSlug}`,
        method: 'GET',
        params,
        signal
      });
    },
    [getOrganizationItem]
  );
};

export const getGetOrganizationItemQueryKey = (
  organizationSlug: string,
  itemSlug: string,
  params: GetOrganizationItemParams
) => {
  return [`/v1/organizations/${organizationSlug}/items/${itemSlug}`, ...(params ? [params] : [])] as const;
};

export const useGetOrganizationItemQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  itemSlug: string,
  params: GetOrganizationItemParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationItemQueryKey(organizationSlug, itemSlug, params);

  const getOrganizationItem = useGetOrganizationItemHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>> = ({ signal }) =>
    getOrganizationItem(organizationSlug, itemSlug, params, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && itemSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationItemQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>
>;
export type GetOrganizationItemQueryError = unknown;

/**
 * @summary Get an organization organization item
 */

export function useGetOrganizationItem<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  itemSlug: string,
  params: GetOrganizationItemParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationItemHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationItemQueryOptions(organizationSlug, itemSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves paginated list of users with their role assignments for a specific folder
 * @summary Get users for an item
 */
export const useGetFolderRoleAssignmentsHook = () => {
  const getFolderRoleAssignments = useCustomAxios<PagedRoleAssignmentsDto>();

  return useCallback(
    (organizationSlug: string, itemSlug: string, params?: GetFolderRoleAssignmentsParams, signal?: AbortSignal) => {
      return getFolderRoleAssignments({
        url: `/v1/organizations/${organizationSlug}/folders/${itemSlug}/role-assignments`,
        method: 'GET',
        params,
        signal
      });
    },
    [getFolderRoleAssignments]
  );
};

export const getGetFolderRoleAssignmentsQueryKey = (
  organizationSlug: string,
  itemSlug: string,
  params?: GetFolderRoleAssignmentsParams
) => {
  return [
    `/v1/organizations/${organizationSlug}/folders/${itemSlug}/role-assignments`,
    ...(params ? [params] : [])
  ] as const;
};

export const useGetFolderRoleAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  itemSlug: string,
  params?: GetFolderRoleAssignmentsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFolderRoleAssignmentsQueryKey(organizationSlug, itemSlug, params);

  const getFolderRoleAssignments = useGetFolderRoleAssignmentsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>> = ({
    signal
  }) => getFolderRoleAssignments(organizationSlug, itemSlug, params, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && itemSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFolderRoleAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>
>;
export type GetFolderRoleAssignmentsQueryError = unknown;

/**
 * @summary Get users for an item
 */

export function useGetFolderRoleAssignments<
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  itemSlug: string,
  params?: GetFolderRoleAssignmentsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetFolderRoleAssignmentsQueryOptions(organizationSlug, itemSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves paginated list of role assignments for users in a specific folder. Returns user information along with their assigned roles.
 * @summary Get folder role assignments by user
 */
export const useGetFolderRoleAssignmentsByUserHook = () => {
  const getFolderRoleAssignmentsByUser = useCustomAxios<LocationUserRoleAssignmentsResponse>();

  return useCallback(
    (
      organizationSlug: string,
      itemSlug: string,
      params?: GetFolderRoleAssignmentsByUserParams,
      signal?: AbortSignal
    ) => {
      return getFolderRoleAssignmentsByUser({
        url: `/v1/organizations/${organizationSlug}/folders/${itemSlug}/role-assignments/by-user`,
        method: 'GET',
        params,
        signal
      });
    },
    [getFolderRoleAssignmentsByUser]
  );
};

export const getGetFolderRoleAssignmentsByUserQueryKey = (
  organizationSlug: string,
  itemSlug: string,
  params?: GetFolderRoleAssignmentsByUserParams
) => {
  return [
    `/v1/organizations/${organizationSlug}/folders/${itemSlug}/role-assignments/by-user`,
    ...(params ? [params] : [])
  ] as const;
};

export const useGetFolderRoleAssignmentsByUserQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  itemSlug: string,
  params?: GetFolderRoleAssignmentsByUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFolderRoleAssignmentsByUserQueryKey(organizationSlug, itemSlug, params);

  const getFolderRoleAssignmentsByUser = useGetFolderRoleAssignmentsByUserHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>> = ({
    signal
  }) => getFolderRoleAssignmentsByUser(organizationSlug, itemSlug, params, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && itemSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFolderRoleAssignmentsByUserQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>
>;
export type GetFolderRoleAssignmentsByUserQueryError = unknown;

/**
 * @summary Get folder role assignments by user
 */

export function useGetFolderRoleAssignmentsByUser<
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  itemSlug: string,
  params?: GetFolderRoleAssignmentsByUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetFolderRoleAssignmentsByUserHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetFolderRoleAssignmentsByUserQueryOptions(organizationSlug, itemSlug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get what the connected user is allowed to do in the specified folder.
 * @summary Get folder permissions
 */
export const useGetFolderPermissionsHook = () => {
  const getFolderPermissions = useCustomAxios<FolderPermissionsDTO>();

  return useCallback(
    (organizationSlug: string, folderSlug: string, signal?: AbortSignal) => {
      return getFolderPermissions({
        url: `/v1/organizations/${organizationSlug}/folders/${folderSlug}/permissions`,
        method: 'GET',
        signal
      });
    },
    [getFolderPermissions]
  );
};

export const getGetFolderPermissionsQueryKey = (organizationSlug: string, folderSlug: string) => {
  return [`/v1/organizations/${organizationSlug}/folders/${folderSlug}/permissions`] as const;
};

export const useGetFolderPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  folderSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFolderPermissionsQueryKey(organizationSlug, folderSlug);

  const getFolderPermissions = useGetFolderPermissionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>> = ({ signal }) =>
    getFolderPermissions(organizationSlug, folderSlug, signal);

  return { queryKey, queryFn, enabled: !!(organizationSlug && folderSlug), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFolderPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>
>;
export type GetFolderPermissionsQueryError = unknown;

/**
 * @summary Get folder permissions
 */

export function useGetFolderPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>,
  TError = unknown
>(
  organizationSlug: string,
  folderSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolderPermissionsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetFolderPermissionsQueryOptions(organizationSlug, folderSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useDebugAuthHook = () => {
  const debugAuth = useCustomAxios<DebugAuth200>();

  return useCallback(
    (params?: DebugAuthParams, signal?: AbortSignal) => {
      return debugAuth({ url: `/v1/organizations/debug-auth`, method: 'GET', params, signal });
    },
    [debugAuth]
  );
};

export const getDebugAuthQueryKey = (params?: DebugAuthParams) => {
  return [`/v1/organizations/debug-auth`, ...(params ? [params] : [])] as const;
};

export const useDebugAuthQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>,
  TError = unknown
>(
  params?: DebugAuthParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDebugAuthQueryKey(params);

  const debugAuth = useDebugAuthHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>> = ({ signal }) =>
    debugAuth(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DebugAuthQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>>;
export type DebugAuthQueryError = unknown;

export function useDebugAuth<TData = Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>, TError = unknown>(
  params?: DebugAuthParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDebugAuthHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useDebugAuthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Results are limited by the caller's role and by session-visible offices (same contract as GET /v1/offices). MIDOT_ADMIN / global admin with no office visibility on the user document bypass the office filter.
 * @summary AutoSuggest organizations by name or legal name
 */
export const useAutosuggestionOrganizationsHook = () => {
  const autosuggestionOrganizations = useCustomAxios<OrganizationAutosuggestDTO[]>();

  return useCallback(
    (params: AutosuggestionOrganizationsParams, signal?: AbortSignal) => {
      return autosuggestionOrganizations({ url: `/v1/organizations/autosuggest`, method: 'GET', params, signal });
    },
    [autosuggestionOrganizations]
  );
};

export const getAutosuggestionOrganizationsQueryKey = (params: AutosuggestionOrganizationsParams) => {
  return [`/v1/organizations/autosuggest`, ...(params ? [params] : [])] as const;
};

export const useAutosuggestionOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>,
  TError = unknown
>(
  params: AutosuggestionOrganizationsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAutosuggestionOrganizationsQueryKey(params);

  const autosuggestionOrganizations = useAutosuggestionOrganizationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>> = ({
    signal
  }) => autosuggestionOrganizations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AutosuggestionOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>
>;
export type AutosuggestionOrganizationsQueryError = unknown;

/**
 * @summary AutoSuggest organizations by name or legal name
 */

export function useAutosuggestionOrganizations<
  TData = Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>,
  TError = unknown
>(
  params: AutosuggestionOrganizationsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAutosuggestionOrganizationsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useAutosuggestionOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns offices the authenticated principal may see (RBAC by user type: Midot admin = full catalog; CS/KAM/org admin = scoped lists; location admin and basic users = assigned offices and/or locations). Empty array when none are in scope or when no user can be resolved (e.g. missing session/JWT).
 * @summary List offices visible to the current user
 */
export const useGetOfficesHook = () => {
  const getOffices = useCustomAxios<OfficeDTO[]>();

  return useCallback(
    (params?: GetOfficesParams, signal?: AbortSignal) => {
      return getOffices({ url: `/v1/offices`, method: 'GET', params, signal });
    },
    [getOffices]
  );
};

export const getGetOfficesQueryKey = (params?: GetOfficesParams) => {
  return [`/v1/offices`, ...(params ? [params] : [])] as const;
};

export const useGetOfficesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>,
  TError = unknown
>(
  params?: GetOfficesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOfficesQueryKey(params);

  const getOffices = useGetOfficesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>> = ({ signal }) =>
    getOffices(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOfficesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>>;
export type GetOfficesQueryError = unknown;

/**
 * @summary List offices visible to the current user
 */

export function useGetOffices<TData = Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>, TError = unknown>(
  params?: GetOfficesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOfficesHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOfficesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search Midot Employee users by first name, last name, or full name. Returns an empty array if no users are found.
 */
export const useGetMidotEmployeeUsersBySearchHook = () => {
  const getMidotEmployeeUsersBySearch = useCustomAxios<User[]>();

  return useCallback(
    (params?: GetMidotEmployeeUsersBySearchParams, signal?: AbortSignal) => {
      return getMidotEmployeeUsersBySearch({ url: `/v1/midotEmployeeUsers`, method: 'GET', params, signal });
    },
    [getMidotEmployeeUsersBySearch]
  );
};

export const getGetMidotEmployeeUsersBySearchQueryKey = (params?: GetMidotEmployeeUsersBySearchParams) => {
  return [`/v1/midotEmployeeUsers`, ...(params ? [params] : [])] as const;
};

export const useGetMidotEmployeeUsersBySearchQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>,
  TError = User[]
>(
  params?: GetMidotEmployeeUsersBySearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMidotEmployeeUsersBySearchQueryKey(params);

  const getMidotEmployeeUsersBySearch = useGetMidotEmployeeUsersBySearchHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>> = ({
    signal
  }) => getMidotEmployeeUsersBySearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMidotEmployeeUsersBySearchQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>
>;
export type GetMidotEmployeeUsersBySearchQueryError = User[];

/**
 * @summary Search Midot Employee users by first name, last name, or full name. Returns an empty array if no users are found.
 */

export function useGetMidotEmployeeUsersBySearch<
  TData = Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>,
  TError = User[]
>(
  params?: GetMidotEmployeeUsersBySearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetMidotEmployeeUsersBySearchHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetMidotEmployeeUsersBySearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns Midot employees. If the session user is not a Midot employee (MIDOT_ADMIN, CS, or KAM), returns an empty list.
Results are first scoped to users who share an office with the session user's visible offices (same source as GET /v1/offices: user.offices → DB slug/key set). MIDOT_ADMIN / global admin with no offices on the user document skips that gate and sees all Midot users. Optional query params can narrow further by office_slug and role_id.

Supports search across first name, last name, full name, office, email, and role.
Results are paginated.

 * @summary Get Midot users
 */
export const useGetMidotUsersHook = () => {
  const getMidotUsers = useCustomAxios<MidotUsersResponseDTO>();

  return useCallback(
    (params?: GetMidotUsersParams, signal?: AbortSignal) => {
      return getMidotUsers({ url: `/v1/midot/users`, method: 'GET', params, signal });
    },
    [getMidotUsers]
  );
};

export const getGetMidotUsersQueryKey = (params?: GetMidotUsersParams) => {
  return [`/v1/midot/users`, ...(params ? [params] : [])] as const;
};

export const useGetMidotUsersInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>,
  TError = unknown
>(
  params?: GetMidotUsersParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMidotUsersQueryKey(params);

  const getMidotUsers = useGetMidotUsersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>> = ({ signal }) =>
    getMidotUsers(params, signal);

  const customOptions = useCustomGetMidotUsersQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { params },
    { url: `/v1/midot/users` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMidotUsersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>
>;
export type GetMidotUsersInfiniteQueryError = unknown;

/**
 * @summary Get Midot users
 */

export function useGetMidotUsersInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>,
  TError = unknown
>(
  params?: GetMidotUsersParams,
  options?: {
    query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>, TError, TData>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetMidotUsersInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetMidotUsersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>,
  TError = unknown
>(
  params?: GetMidotUsersParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMidotUsersQueryKey(params);

  const getMidotUsers = useGetMidotUsersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>> = ({ signal }) =>
    getMidotUsers(params, signal);

  const customOptions = useCustomGetMidotUsersQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { params },
    { url: `/v1/midot/users` }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMidotUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>>;
export type GetMidotUsersQueryError = unknown;

/**
 * @summary Get Midot users
 */

export function useGetMidotUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>,
  TError = unknown
>(
  params?: GetMidotUsersParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMidotUsersHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetMidotUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a paginated list of Midot roles with filtering and sorting options
 * @summary Get Midot roles
 */
export const useGetRolesHook = () => {
  const getRoles = useCustomAxios<MidotRolesResponseDTO>();

  return useCallback(
    (params?: GetRolesParams, signal?: AbortSignal) => {
      return getRoles({ url: `/v1/midot/roles`, method: 'GET', params, signal });
    },
    [getRoles]
  );
};

export const getGetRolesQueryKey = (params?: GetRolesParams) => {
  return [`/v1/midot/roles`, ...(params ? [params] : [])] as const;
};

export const useGetRolesInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = MidotRolesResponseDTO
>(
  params?: GetRolesParams,
  options?: { query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRolesQueryKey(params);

  const getRoles = useGetRolesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>> = ({ signal }) =>
    getRoles(params, signal);

  const customOptions = useCustomGetMidotRolesQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { params },
    { url: `/v1/midot/roles` }
  );

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRolesInfiniteQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>>;
export type GetRolesInfiniteQueryError = MidotRolesResponseDTO;

/**
 * @summary Get Midot roles
 */

export function useGetRolesInfinite<
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = MidotRolesResponseDTO
>(
  params?: GetRolesParams,
  options?: { query?: UseInfiniteQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData> }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetRolesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetRolesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = MidotRolesResponseDTO
>(
  params?: GetRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRolesQueryKey(params);

  const getRoles = useGetRolesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>> = ({ signal }) =>
    getRoles(params, signal);

  const customOptions = useCustomGetMidotRolesQueryOptions(
    { ...queryOptions, queryKey, queryFn },
    { params },
    { url: `/v1/midot/roles` }
  );

  return customOptions as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>>;
export type GetRolesQueryError = MidotRolesResponseDTO;

/**
 * @summary Get Midot roles
 */

export function useGetRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = MidotRolesResponseDTO
>(
  params?: GetRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetRolesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve All Midot roles
 * @summary Get All Midot roles
 */
export const useGetAllRolesHook = () => {
  const getAllRoles = useCustomAxios<MidotRolesResponseDTO>();

  return useCallback(
    (params?: GetAllRolesParams, signal?: AbortSignal) => {
      return getAllRoles({ url: `/v1/midot/all-roles`, method: 'GET', params, signal });
    },
    [getAllRoles]
  );
};

export const getGetAllRolesQueryKey = (params?: GetAllRolesParams) => {
  return [`/v1/midot/all-roles`, ...(params ? [params] : [])] as const;
};

export const useGetAllRolesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
  TError = MidotRolesResponseDTO
>(
  params?: GetAllRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllRolesQueryKey(params);

  const getAllRoles = useGetAllRolesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>> = ({ signal }) =>
    getAllRoles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>>;
export type GetAllRolesQueryError = MidotRolesResponseDTO;

/**
 * @summary Get All Midot roles
 */

export function useGetAllRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>,
  TError = MidotRolesResponseDTO
>(
  params?: GetAllRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllRolesHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetAllRolesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves all messages that match the given language ID.
 * @summary Get messages by language ID
 */
export const useGetMessagesByLangHook = () => {
  const getMessagesByLang = useCustomAxios<unknown>();

  return useCallback(
    (langCode: string, signal?: AbortSignal) => {
      return getMessagesByLang({ url: `/v1/messages/lang/${langCode}`, method: 'GET', signal });
    },
    [getMessagesByLang]
  );
};

export const getGetMessagesByLangQueryKey = (langCode: string) => {
  return [`/v1/messages/lang/${langCode}`] as const;
};

export const useGetMessagesByLangQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>,
  TError = unknown
>(
  langCode: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMessagesByLangQueryKey(langCode);

  const getMessagesByLang = useGetMessagesByLangHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>> = ({ signal }) =>
    getMessagesByLang(langCode, signal);

  return { queryKey, queryFn, enabled: !!langCode, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMessagesByLangQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>
>;
export type GetMessagesByLangQueryError = unknown;

/**
 * @summary Get messages by language ID
 */

export function useGetMessagesByLang<
  TData = Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>,
  TError = unknown
>(
  langCode: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMessagesByLangHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetMessagesByLangQueryOptions(langCode, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves global messages (welcome, complete, terms, etc.) for the given locale with fallback to default locale.
 * @summary Get global messages by locale
 */
export const useGetGlobalMessagesByLocaleHook = () => {
  const getGlobalMessagesByLocale = useCustomAxios<unknown>();

  return useCallback(
    (locale: string, signal?: AbortSignal) => {
      return getGlobalMessagesByLocale({ url: `/v1/messages/global/lang/${locale}`, method: 'GET', signal });
    },
    [getGlobalMessagesByLocale]
  );
};

export const getGetGlobalMessagesByLocaleQueryKey = (locale: string) => {
  return [`/v1/messages/global/lang/${locale}`] as const;
};

export const useGetGlobalMessagesByLocaleQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>,
  TError = unknown
>(
  locale: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGlobalMessagesByLocaleQueryKey(locale);

  const getGlobalMessagesByLocale = useGetGlobalMessagesByLocaleHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>> = ({
    signal
  }) => getGlobalMessagesByLocale(locale, signal);

  return { queryKey, queryFn, enabled: !!locale, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGlobalMessagesByLocaleQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>
>;
export type GetGlobalMessagesByLocaleQueryError = unknown;

/**
 * @summary Get global messages by locale
 */

export function useGetGlobalMessagesByLocale<
  TData = Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>,
  TError = unknown
>(
  locale: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGlobalMessagesByLocaleHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetGlobalMessagesByLocaleQueryOptions(locale, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve the result of an invitation process using PASSWORD mode.
 * @summary Get Invitation Result by Password 489251 !!!!!!!!!!!!!!!!!!!!!!!
 */
export const useGetInvitationResultByPasswordHook = () => {
  const getInvitationResultByPassword = useCustomAxios<InvitationResultDTO>();

  return useCallback(
    (password: string, signal?: AbortSignal) => {
      return getInvitationResultByPassword({
        url: `/v1/invitation/password/${password}/result`,
        method: 'GET',
        signal
      });
    },
    [getInvitationResultByPassword]
  );
};

export const getGetInvitationResultByPasswordQueryKey = (password: string) => {
  return [`/v1/invitation/password/${password}/result`] as const;
};

export const useGetInvitationResultByPasswordQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>,
  TError = InvitationResultDTO
>(
  password: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvitationResultByPasswordQueryKey(password);

  const getInvitationResultByPassword = useGetInvitationResultByPasswordHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>> = ({
    signal
  }) => getInvitationResultByPassword(password, signal);

  return { queryKey, queryFn, enabled: !!password, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvitationResultByPasswordQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>
>;
export type GetInvitationResultByPasswordQueryError = InvitationResultDTO;

/**
 * @summary Get Invitation Result by Password 489251 !!!!!!!!!!!!!!!!!!!!!!!
 */

export function useGetInvitationResultByPassword<
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>,
  TError = InvitationResultDTO
>(
  password: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByPasswordHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetInvitationResultByPasswordQueryOptions(password, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve the result of an invitation process using UNIQUE_LINK or PUBLIC_LINK mode.
 * @summary Get Invitation Result by Access Key
 */
export const useGetInvitationResultByAccessKeyHook = () => {
  const getInvitationResultByAccessKey = useCustomAxios<InvitationResultDTO>();

  return useCallback(
    (key: string, signal?: AbortSignal) => {
      return getInvitationResultByAccessKey({ url: `/v1/invitation/access-key/${key}/result`, method: 'GET', signal });
    },
    [getInvitationResultByAccessKey]
  );
};

export const getGetInvitationResultByAccessKeyQueryKey = (key: string) => {
  return [`/v1/invitation/access-key/${key}/result`] as const;
};

export const useGetInvitationResultByAccessKeyQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>,
  TError = InvitationResultDTO
>(
  key: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvitationResultByAccessKeyQueryKey(key);

  const getInvitationResultByAccessKey = useGetInvitationResultByAccessKeyHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>> = ({
    signal
  }) => getInvitationResultByAccessKey(key, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvitationResultByAccessKeyQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>
>;
export type GetInvitationResultByAccessKeyQueryError = InvitationResultDTO;

/**
 * @summary Get Invitation Result by Access Key
 */

export function useGetInvitationResultByAccessKey<
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>,
  TError = InvitationResultDTO
>(
  key: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvitationResultByAccessKeyHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetInvitationResultByAccessKeyQueryOptions(key, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all industries
 */
export const useGetIndustriesHook = () => {
  const getIndustries = useCustomAxios<IndustryDTO[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getIndustries({ url: `/v1/industries`, method: 'GET', signal });
    },
    [getIndustries]
  );
};

export const getGetIndustriesQueryKey = () => {
  return [`/v1/industries`] as const;
};

export const useGetIndustriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIndustriesQueryKey();

  const getIndustries = useGetIndustriesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>> = ({ signal }) =>
    getIndustries(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIndustriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>>;
export type GetIndustriesQueryError = unknown;

/**
 * @summary Get all industries
 */

export function useGetIndustries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustriesHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetIndustriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns whether Descope is configured and shows configuration status
 * @summary Check Descope configuration
 */
export const useCheckConfigHook = () => {
  const checkConfig = useCustomAxios<CheckConfig200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return checkConfig({ url: `/v1/dev/descope/config-check`, method: 'GET', signal });
    },
    [checkConfig]
  );
};

export const getCheckConfigQueryKey = () => {
  return [`/v1/dev/descope/config-check`] as const;
};

export const useCheckConfigQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckConfigQueryKey();

  const checkConfig = useCheckConfigHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>> = ({ signal }) =>
    checkConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckConfigQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>>;
export type CheckConfigQueryError = unknown;

/**
 * @summary Check Descope configuration
 */

export function useCheckConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckConfigHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useCheckConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **⚠️ DEVELOPMENT ONLY ⚠️**

Returns a set of pre-generated JWT tokens for common test scenarios.

**Test Users:**
- **pavelb@midot.com** - Midot Admin (your account)
- **admin@midot.com** - Midot Admin
- **kam@midot.com** - Midot KAM
- **admin@client.com** - Client Admin
- **user@client.com** - Client User

**Quick Start:**
1. Copy the JWT for `pavelb@midot.com`
2. Click 'Authorize' in Swagger
3. Paste as Bearer token
4. Test folder creation endpoints

 * @summary 🎯 Get pre-generated test JWTs
 */
export const useGetTestTokensHook = () => {
  const getTestTokens = useCustomAxios<unknown>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getTestTokens({ url: `/v1/dev-jwt/test-tokens`, method: 'GET', signal });
    },
    [getTestTokens]
  );
};

export const getGetTestTokensQueryKey = () => {
  return [`/v1/dev-jwt/test-tokens`] as const;
};

export const useGetTestTokensQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTestTokensQueryKey();

  const getTestTokens = useGetTestTokensHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>> = ({ signal }) =>
    getTestTokens(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestTokensQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>>;
export type GetTestTokensQueryError = unknown;

/**
 * @summary 🎯 Get pre-generated test JWTs
 */

export function useGetTestTokens<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestTokensHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTestTokensQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **⚠️ DEVELOPMENT ONLY ⚠️**

Generates a static JWT token for testing purposes. These tokens are NOT cryptographically secure.

**How to use:**
1. Generate a JWT for your email
2. Copy the token
3. Click 'Authorize' in Swagger and paste it as Bearer token
4. Test protected endpoints

**Supported emails:**
- `pavelb@midot.com` (Midot Admin)
- `admin@midot.com` (Midot Admin)
- `kam@midot.com` (Midot KAM)
- `admin@client.com` (Client Admin)
- `user@client.com` (Client User)

 * @summary 🔧 Generate static JWT for testing
 */
export const useGenerateJwtHook = () => {
  const generateJwt = useCustomAxios<JwtResponse>();

  return useCallback(
    (params: GenerateJwtParams, signal?: AbortSignal) => {
      return generateJwt({ url: `/v1/dev-jwt/generate`, method: 'GET', params, signal });
    },
    [generateJwt]
  );
};

export const getGenerateJwtQueryKey = (params: GenerateJwtParams) => {
  return [`/v1/dev-jwt/generate`, ...(params ? [params] : [])] as const;
};

export const useGenerateJwtQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>,
  TError = unknown
>(
  params: GenerateJwtParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGenerateJwtQueryKey(params);

  const generateJwt = useGenerateJwtHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>> = ({ signal }) =>
    generateJwt(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GenerateJwtQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>>;
export type GenerateJwtQueryError = unknown;

/**
 * @summary 🔧 Generate static JWT for testing
 */

export function useGenerateJwt<TData = Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>, TError = unknown>(
  params: GenerateJwtParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGenerateJwtHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGenerateJwtQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed information about the current authenticated user
 * @summary 📋 Get current user info
 */
export const useGetCurrentUserInfoHook = () => {
  const getCurrentUserInfo = useCustomAxios<GetCurrentUserInfo200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getCurrentUserInfo({ url: `/v1/debug/auth/user-info`, method: 'GET', signal });
    },
    [getCurrentUserInfo]
  );
};

export const getGetCurrentUserInfoQueryKey = () => {
  return [`/v1/debug/auth/user-info`] as const;
};

export const useGetCurrentUserInfoQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserInfoQueryKey();

  const getCurrentUserInfo = useGetCurrentUserInfoHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>> = ({ signal }) =>
    getCurrentUserInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserInfoQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>
>;
export type GetCurrentUserInfoQueryError = unknown;

/**
 * @summary 📋 Get current user info
 */

export function useGetCurrentUserInfo<
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentUserInfoHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetCurrentUserInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Test if API key authentication is working properly
 * @summary 🧪 Test API key authentication
 */
export const useTestApiKeyHook = () => {
  const testApiKey = useCustomAxios<TestApiKey200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return testApiKey({ url: `/v1/debug/auth/test-api-key`, method: 'GET', signal });
    },
    [testApiKey]
  );
};

export const getTestApiKeyQueryKey = () => {
  return [`/v1/debug/auth/test-api-key`] as const;
};

export const useTestApiKeyQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTestApiKeyQueryKey();

  const testApiKey = useTestApiKeyHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>> = ({ signal }) =>
    testApiKey(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TestApiKeyQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>>;
export type TestApiKeyQueryError = unknown;

/**
 * @summary 🧪 Test API key authentication
 */

export function useTestApiKey<
  TData = Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTestApiKeyHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useTestApiKeyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Debug the current authentication state to troubleshoot issues.

**What this shows:**
- Current authentication method (API Key, JWT, Session)
- User information and permissions
- Spring Security context details
- Request headers

**Use this when:**
- Getting "No authenticated user" errors
- Authentication not working in Swagger
- Need to verify API key is working

 * @summary 🔍 Debug current authentication
 */
export const useDebugAuthStatusHook = () => {
  const debugAuthStatus = useCustomAxios<DebugAuthStatus200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return debugAuthStatus({ url: `/v1/debug/auth/status`, method: 'GET', signal });
    },
    [debugAuthStatus]
  );
};

export const getDebugAuthStatusQueryKey = () => {
  return [`/v1/debug/auth/status`] as const;
};

export const useDebugAuthStatusQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDebugAuthStatusQueryKey();

  const debugAuthStatus = useDebugAuthStatusHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>> = ({ signal }) =>
    debugAuthStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DebugAuthStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>>;
export type DebugAuthStatusQueryError = unknown;

/**
 * @summary 🔍 Debug current authentication
 */

export function useDebugAuthStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDebugAuthStatusHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useDebugAuthStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve the test catalog based on optional request parameters like assessment type, locale, location slug, and location type.
 * @summary Get test catalog
 */
export const useGetTestCatalogHook = () => {
  const getTestCatalog = useCustomAxios<TestCatalogResponseDTO>();

  return useCallback(
    (params: GetTestCatalogParams, signal?: AbortSignal) => {
      return getTestCatalog({ url: `/v1/catalog/test-catalog`, method: 'GET', params, signal });
    },
    [getTestCatalog]
  );
};

export const getGetTestCatalogQueryKey = (params: GetTestCatalogParams) => {
  return [`/v1/catalog/test-catalog`, ...(params ? [params] : [])] as const;
};

export const useGetTestCatalogQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>,
  TError = void
>(
  params: GetTestCatalogParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTestCatalogQueryKey(params);

  const getTestCatalog = useGetTestCatalogHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>> = ({ signal }) =>
    getTestCatalog(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestCatalogQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>>;
export type GetTestCatalogQueryError = void;

/**
 * @summary Get test catalog
 */

export function useGetTestCatalog<TData = Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>, TError = void>(
  params: GetTestCatalogParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTestCatalogHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetTestCatalogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve detailed information for a single catalog item by its ID.
 * @summary Get catalog item details
 */
export const useGetCatalogItemDetailsHook = () => {
  const getCatalogItemDetails = useCustomAxios<CatalogItemDetailsDTO>();

  return useCallback(
    (catalogItemId: string, params: GetCatalogItemDetailsParams, signal?: AbortSignal) => {
      return getCatalogItemDetails({ url: `/v1/catalog/test-catalog/${catalogItemId}`, method: 'GET', params, signal });
    },
    [getCatalogItemDetails]
  );
};

export const getGetCatalogItemDetailsQueryKey = (catalogItemId: string, params: GetCatalogItemDetailsParams) => {
  return [`/v1/catalog/test-catalog/${catalogItemId}`, ...(params ? [params] : [])] as const;
};

export const useGetCatalogItemDetailsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>,
  TError = void
>(
  catalogItemId: string,
  params: GetCatalogItemDetailsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCatalogItemDetailsQueryKey(catalogItemId, params);

  const getCatalogItemDetails = useGetCatalogItemDetailsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>> = ({ signal }) =>
    getCatalogItemDetails(catalogItemId, params, signal);

  return { queryKey, queryFn, enabled: !!catalogItemId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCatalogItemDetailsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>
>;
export type GetCatalogItemDetailsQueryError = void;

/**
 * @summary Get catalog item details
 */

export function useGetCatalogItemDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>,
  TError = void
>(
  catalogItemId: string,
  params: GetCatalogItemDetailsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCatalogItemDetailsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetCatalogItemDetailsQueryOptions(catalogItemId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetAuthenticationOptionsHook = () => {
  const getAuthenticationOptions = useCustomAxios<AuthenticationOptionsDto>();

  return useCallback(
    (params: GetAuthenticationOptionsParams, signal?: AbortSignal) => {
      return getAuthenticationOptions({ url: `/v1/auth/authentication-options`, method: 'GET', params, signal });
    },
    [getAuthenticationOptions]
  );
};

export const useGetAuthenticationOptionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAuthenticationOptionsHook>>>,
    TError,
    { params: GetAuthenticationOptionsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useGetAuthenticationOptionsHook>>>,
  TError,
  { params: GetAuthenticationOptionsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const getAuthenticationOptions = useGetAuthenticationOptionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useGetAuthenticationOptionsHook>>>,
    { params: GetAuthenticationOptionsParams }
  > = props => {
    const { params } = props ?? {};

    return getAuthenticationOptions(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAuthenticationOptionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetAuthenticationOptionsHook>>>
>;

export type GetAuthenticationOptionsMutationError = unknown;

export const useGetAuthenticationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAuthenticationOptionsHook>>>,
    TError,
    { params: GetAuthenticationOptionsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useGetAuthenticationOptionsHook>>>,
  TError,
  { params: GetAuthenticationOptionsParams },
  TContext
> => {
  const mutationOptions = useGetAuthenticationOptionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get information about available API keys and authentication methods.

**🎯 RECOMMENDED: Master Bearer Token (Industry Standard)**
`Bearer_podium_dev_master_admin_never_expires_2024`

**Usage in requests:**
- Header: `Authorization: Bearer Bearer_podium_dev_master_admin_never_expires_2024`

**🔧 Alternative: Legacy API Key**
`pk_dev_master_admin_2024_secure_key_full_access`

**Legacy Usage:**
- Header: `X-API-Key: pk_dev_master_admin_2024_secure_key_full_access`
- Header: `X-API-TOKEN: pk_dev_master_admin_2024_secure_key_full_access`
- Query: `?api_key=pk_dev_master_admin_2024_secure_key_full_access`

 * @summary 🔑 Get API key information
 */
export const useGetApiKeyInfoHook = () => {
  const getApiKeyInfo = useCustomAxios<unknown>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getApiKeyInfo({ url: `/v1/api-keys/info`, method: 'GET', signal });
    },
    [getApiKeyInfo]
  );
};

export const getGetApiKeyInfoQueryKey = () => {
  return [`/v1/api-keys/info`] as const;
};

export const useGetApiKeyInfoQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiKeyInfoQueryKey();

  const getApiKeyInfo = useGetApiKeyInfoHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>> = ({ signal }) =>
    getApiKeyInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiKeyInfoQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>>;
export type GetApiKeyInfoQueryError = unknown;

/**
 * @summary 🔑 Get API key information
 */

export function useGetApiKeyInfo<
  TData = Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetApiKeyInfoHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetApiKeyInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Validates the invitation token and activates the user account. The user status will be changed from ONBOARDING to ACTIVE after successful acceptance.
 * @summary Accept user account invitation
 */
export const useAcceptAccountHook = () => {
  const acceptAccount = useCustomAxios<string>();

  return useCallback(
    (params: AcceptAccountParams, signal?: AbortSignal) => {
      return acceptAccount({ url: `/v1/accept`, method: 'GET', params, signal });
    },
    [acceptAccount]
  );
};

export const getAcceptAccountQueryKey = (params: AcceptAccountParams) => {
  return [`/v1/accept`, ...(params ? [params] : [])] as const;
};

export const useAcceptAccountQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>,
  TError = unknown
>(
  params: AcceptAccountParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAcceptAccountQueryKey(params);

  const acceptAccount = useAcceptAccountHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>> = ({ signal }) =>
    acceptAccount(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AcceptAccountQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>>;
export type AcceptAccountQueryError = unknown;

/**
 * @summary Accept user account invitation
 */

export function useAcceptAccount<
  TData = Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>,
  TError = unknown
>(
  params: AcceptAccountParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAcceptAccountHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useAcceptAccountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetHook = () => {
  const get = useCustomAxios<Get200>();

  return useCallback(
    (params: GetParams, signal?: AbortSignal) => {
      return get({ url: `/redis/get`, method: 'GET', params, signal });
    },
    [get]
  );
};

export const getGetQueryKey = (params: GetParams) => {
  return [`/redis/get`, ...(params ? [params] : [])] as const;
};

export const useGetQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError = unknown>(
  params: GetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQueryKey(params);

  const get = useGetHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetHook>>>> = ({ signal }) =>
    get(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetHook>>>>;
export type GetQueryError = unknown;

export function useGet<TData = Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError = unknown>(
  params: GetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useExistsHook = () => {
  const exists = useCustomAxios<boolean>();

  return useCallback(
    (params: ExistsParams, signal?: AbortSignal) => {
      return exists({ url: `/redis/exists`, method: 'GET', params, signal });
    },
    [exists]
  );
};

export const getExistsQueryKey = (params: ExistsParams) => {
  return [`/redis/exists`, ...(params ? [params] : [])] as const;
};

export const useExistsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExistsHook>>>, TError = unknown>(
  params: ExistsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExistsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExistsQueryKey(params);

  const exists = useExistsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExistsHook>>>> = ({ signal }) =>
    exists(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExistsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExistsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExistsHook>>>>;
export type ExistsQueryError = unknown;

export function useExists<TData = Awaited<ReturnType<ReturnType<typeof useExistsHook>>>, TError = unknown>(
  params: ExistsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExistsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useExistsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List available OAuth2 clients for development
 * @summary 📋 Get Available Clients
 */
export const useGetClientsHook = () => {
  const getClients = useCustomAxios<GetClients200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getClients({ url: `/oauth2/clients`, method: 'GET', signal });
    },
    [getClients]
  );
};

export const getGetClientsQueryKey = () => {
  return [`/oauth2/clients`] as const;
};

export const useGetClientsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsQueryKey();

  const getClients = useGetClientsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>> = ({ signal }) =>
    getClients(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClientsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>>;
export type GetClientsQueryError = unknown;

/**
 * @summary 📋 Get Available Clients
 */

export function useGetClients<
  TData = Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetClientsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all active sessions for a user
 */
export const useGetUserSessionsHook = () => {
  const getUserSessions = useCustomAxios<UserSession[]>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return getUserSessions({ url: `/api/v1/sessions/user/${userId}`, method: 'GET', signal });
    },
    [getUserSessions]
  );
};

export const getGetUserSessionsQueryKey = (userId: string) => {
  return [`/api/v1/sessions/user/${userId}`] as const;
};

export const useGetUserSessionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>,
  TError = unknown
>(
  userId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserSessionsQueryKey(userId);

  const getUserSessions = useGetUserSessionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>> = ({ signal }) =>
    getUserSessions(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserSessionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>>;
export type GetUserSessionsQueryError = unknown;

/**
 * @summary Get all active sessions for a user
 */

export function useGetUserSessions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>,
  TError = unknown
>(
  userId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSessionsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetUserSessionsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get current user session information
 */
export const useGetCurrentSessionHook = () => {
  const getCurrentSession = useCustomAxios<UserSession>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getCurrentSession({ url: `/api/v1/sessions/current`, method: 'GET', signal });
    },
    [getCurrentSession]
  );
};

export const getGetCurrentSessionQueryKey = () => {
  return [`/api/v1/sessions/current`] as const;
};

export const useGetCurrentSessionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentSessionQueryKey();

  const getCurrentSession = useGetCurrentSessionHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>> = ({ signal }) =>
    getCurrentSession(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentSessionQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>
>;
export type GetCurrentSessionQueryError = unknown;

/**
 * @summary Get current user session information
 */

export function useGetCurrentSession<
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentSessionHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetCurrentSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetViewableOrganizationsHook = () => {
  const getViewableOrganizations = useCustomAxios<GetViewableOrganizations200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getViewableOrganizations({ url: `/api/spicedb-demo/viewable-organizations`, method: 'GET', signal });
    },
    [getViewableOrganizations]
  );
};

export const getGetViewableOrganizationsQueryKey = () => {
  return [`/api/spicedb-demo/viewable-organizations`] as const;
};

export const useGetViewableOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetViewableOrganizationsQueryKey();

  const getViewableOrganizations = useGetViewableOrganizationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>> = ({
    signal
  }) => getViewableOrganizations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetViewableOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>
>;
export type GetViewableOrganizationsQueryError = unknown;

export function useGetViewableOrganizations<
  TData = Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetViewableOrganizationsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetViewableOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetProtectedOrganizationHook = () => {
  const getProtectedOrganization = useCustomAxios<GetProtectedOrganization200>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getProtectedOrganization({
        url: `/api/spicedb-demo/protected/organizations/${id}`,
        method: 'GET',
        signal
      });
    },
    [getProtectedOrganization]
  );
};

export const getGetProtectedOrganizationQueryKey = (id: string) => {
  return [`/api/spicedb-demo/protected/organizations/${id}`] as const;
};

export const useGetProtectedOrganizationQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProtectedOrganizationQueryKey(id);

  const getProtectedOrganization = useGetProtectedOrganizationHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>> = ({
    signal
  }) => getProtectedOrganization(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProtectedOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>
>;
export type GetProtectedOrganizationQueryError = unknown;

export function useGetProtectedOrganization<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProtectedOrganizationHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProtectedOrganizationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetProtectedLocationHook = () => {
  const getProtectedLocation = useCustomAxios<GetProtectedLocation200>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getProtectedLocation({ url: `/api/spicedb-demo/protected/locations/${id}`, method: 'GET', signal });
    },
    [getProtectedLocation]
  );
};

export const getGetProtectedLocationQueryKey = (id: string) => {
  return [`/api/spicedb-demo/protected/locations/${id}`] as const;
};

export const useGetProtectedLocationQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProtectedLocationQueryKey(id);

  const getProtectedLocation = useGetProtectedLocationHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>> = ({ signal }) =>
    getProtectedLocation(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProtectedLocationQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>
>;
export type GetProtectedLocationQueryError = unknown;

export function useGetProtectedLocation<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>,
  TError = unknown
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProtectedLocationHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetProtectedLocationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useCheckPermissionHook = () => {
  const checkPermission = useCustomAxios<CheckPermission200>();

  return useCallback(
    (params: CheckPermissionParams, signal?: AbortSignal) => {
      return checkPermission({ url: `/api/spicedb-demo/check-permission`, method: 'GET', params, signal });
    },
    [checkPermission]
  );
};

export const getCheckPermissionQueryKey = (params: CheckPermissionParams) => {
  return [`/api/spicedb-demo/check-permission`, ...(params ? [params] : [])] as const;
};

export const useCheckPermissionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>,
  TError = unknown
>(
  params: CheckPermissionParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckPermissionQueryKey(params);

  const checkPermission = useCheckPermissionHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>> = ({ signal }) =>
    checkPermission(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckPermissionQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>>;
export type CheckPermissionQueryError = unknown;

export function useCheckPermission<
  TData = Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>,
  TError = unknown
>(
  params: CheckPermissionParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckPermissionHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useCheckPermissionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useCheckGlobalAdminHook = () => {
  const checkGlobalAdmin = useCustomAxios<CheckGlobalAdmin200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return checkGlobalAdmin({ url: `/api/spicedb-demo/check-global-admin`, method: 'GET', signal });
    },
    [checkGlobalAdmin]
  );
};

export const getCheckGlobalAdminQueryKey = () => {
  return [`/api/spicedb-demo/check-global-admin`] as const;
};

export const useCheckGlobalAdminQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckGlobalAdminQueryKey();

  const checkGlobalAdmin = useCheckGlobalAdminHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>> = ({ signal }) =>
    checkGlobalAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckGlobalAdminQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>>;
export type CheckGlobalAdminQueryError = unknown;

export function useCheckGlobalAdmin<
  TData = Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckGlobalAdminHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useCheckGlobalAdminQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetOrganizationSettingsHook = () => {
  const getOrganizationSettings = useCustomAxios<GetOrganizationSettings200>();

  return useCallback(
    (orgId: string, signal?: AbortSignal) => {
      return getOrganizationSettings({ url: `/api/rbac-demo/orgs/${orgId}/settings`, method: 'GET', signal });
    },
    [getOrganizationSettings]
  );
};

export const getGetOrganizationSettingsQueryKey = (orgId: string) => {
  return [`/api/rbac-demo/orgs/${orgId}/settings`] as const;
};

export const useGetOrganizationSettingsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>,
  TError = unknown
>(
  orgId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey(orgId);

  const getOrganizationSettings = useGetOrganizationSettingsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>> = ({ signal }) =>
    getOrganizationSettings(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>
>;
export type GetOrganizationSettingsQueryError = unknown;

export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>,
  TError = unknown
>(
  orgId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganizationSettingsHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrganizationSettingsQueryOptions(orgId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetReportsMenuHook = () => {
  const getReportsMenu = useCustomAxios<GetReportsMenu200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getReportsMenu({ url: `/api/rbac-demo/menu/reports`, method: 'GET', signal });
    },
    [getReportsMenu]
  );
};

export const getGetReportsMenuQueryKey = () => {
  return [`/api/rbac-demo/menu/reports`] as const;
};

export const useGetReportsMenuQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsMenuQueryKey();

  const getReportsMenu = useGetReportsMenuHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>> = ({ signal }) =>
    getReportsMenu(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportsMenuQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>>;
export type GetReportsMenuQueryError = unknown;

export function useGetReportsMenu<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportsMenuHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetReportsMenuQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetOrgSettingsMenuHook = () => {
  const getOrgSettingsMenu = useCustomAxios<GetOrgSettingsMenu200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getOrgSettingsMenu({ url: `/api/rbac-demo/menu/org-settings`, method: 'GET', signal });
    },
    [getOrgSettingsMenu]
  );
};

export const getGetOrgSettingsMenuQueryKey = () => {
  return [`/api/rbac-demo/menu/org-settings`] as const;
};

export const useGetOrgSettingsMenuQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgSettingsMenuQueryKey();

  const getOrgSettingsMenu = useGetOrgSettingsMenuHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>> = ({ signal }) =>
    getOrgSettingsMenu(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrgSettingsMenuQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>
>;
export type GetOrgSettingsMenuQueryError = unknown;

export function useGetOrgSettingsMenu<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrgSettingsMenuHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetOrgSettingsMenuQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetAdminMenuHook = () => {
  const getAdminMenu = useCustomAxios<GetAdminMenu200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getAdminMenu({ url: `/api/rbac-demo/menu/admin`, method: 'GET', signal });
    },
    [getAdminMenu]
  );
};

export const getGetAdminMenuQueryKey = () => {
  return [`/api/rbac-demo/menu/admin`] as const;
};

export const useGetAdminMenuQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMenuQueryKey();

  const getAdminMenu = useGetAdminMenuHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>> = ({ signal }) =>
    getAdminMenu(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminMenuQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>>;
export type GetAdminMenuQueryError = unknown;

export function useGetAdminMenu<
  TData = Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminMenuHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetAdminMenuQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetFolder1Hook = () => {
  const getFolder1 = useCustomAxios<GetFolder1200>();

  return useCallback(
    (folderId: string, signal?: AbortSignal) => {
      return getFolder1({ url: `/api/rbac-demo/folders/${folderId}`, method: 'GET', signal });
    },
    [getFolder1]
  );
};

export const getGetFolder1QueryKey = (folderId: string) => {
  return [`/api/rbac-demo/folders/${folderId}`] as const;
};

export const useGetFolder1QueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>,
  TError = unknown
>(
  folderId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFolder1QueryKey(folderId);

  const getFolder1 = useGetFolder1Hook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>> = ({ signal }) =>
    getFolder1(folderId, signal);

  return { queryKey, queryFn, enabled: !!folderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFolder1QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>>;
export type GetFolder1QueryError = unknown;

export function useGetFolder1<TData = Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>, TError = unknown>(
  folderId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFolder1Hook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useGetFolder1QueryOptions(folderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useDownloadPIIExportHook = () => {
  const downloadPIIExport = useCustomAxios<DownloadPIIExport200>();

  return useCallback(
    (params: DownloadPIIExportParams, signal?: AbortSignal) => {
      return downloadPIIExport({ url: `/api/rbac-demo/exports/pii`, method: 'GET', params, signal });
    },
    [downloadPIIExport]
  );
};

export const getDownloadPIIExportQueryKey = (params: DownloadPIIExportParams) => {
  return [`/api/rbac-demo/exports/pii`, ...(params ? [params] : [])] as const;
};

export const useDownloadPIIExportQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>,
  TError = unknown
>(
  params: DownloadPIIExportParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadPIIExportQueryKey(params);

  const downloadPIIExport = useDownloadPIIExportHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>> = ({ signal }) =>
    downloadPIIExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadPIIExportQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>
>;
export type DownloadPIIExportQueryError = unknown;

export function useDownloadPIIExport<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>,
  TError = unknown
>(
  params: DownloadPIIExportParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadPIIExportHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useDownloadPIIExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useDownloadBasicExportHook = () => {
  const downloadBasicExport = useCustomAxios<DownloadBasicExport200>();

  return useCallback(
    (params: DownloadBasicExportParams, signal?: AbortSignal) => {
      return downloadBasicExport({ url: `/api/rbac-demo/exports/basic`, method: 'GET', params, signal });
    },
    [downloadBasicExport]
  );
};

export const getDownloadBasicExportQueryKey = (params: DownloadBasicExportParams) => {
  return [`/api/rbac-demo/exports/basic`, ...(params ? [params] : [])] as const;
};

export const useDownloadBasicExportQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>,
  TError = unknown
>(
  params: DownloadBasicExportParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadBasicExportQueryKey(params);

  const downloadBasicExport = useDownloadBasicExportHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>> = ({ signal }) =>
    downloadBasicExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadBasicExportQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>
>;
export type DownloadBasicExportQueryError = unknown;

export function useDownloadBasicExport<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>,
  TError = unknown
>(
  params: DownloadBasicExportParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBasicExportHook>>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = useDownloadBasicExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a specific role assignment by its ID.
The operation will fail if:
- The role assignment doesn't exist (404)
- The user is the only admin on that folder (403)

 * @summary Delete a role assignment
 */
export const useDeleteRoleAssignmentHook = () => {
  const deleteRoleAssignment = useCustomAxios<void>();

  return useCallback(
    (roleAssignmentId: string) => {
      return deleteRoleAssignment({ url: `/v1/users/role-assignments/${roleAssignmentId}`, method: 'DELETE' });
    },
    [deleteRoleAssignment]
  );
};

export const useDeleteRoleAssignmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteRoleAssignmentHook>>>,
    TError,
    { roleAssignmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteRoleAssignmentHook>>>,
  TError,
  { roleAssignmentId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteRoleAssignment = useDeleteRoleAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteRoleAssignmentHook>>>,
    { roleAssignmentId: string }
  > = props => {
    const { roleAssignmentId } = props ?? {};

    return deleteRoleAssignment(roleAssignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoleAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteRoleAssignmentHook>>>
>;

export type DeleteRoleAssignmentMutationError = unknown;

/**
 * @summary Delete a role assignment
 */
export const useDeleteRoleAssignment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteRoleAssignmentHook>>>,
    TError,
    { roleAssignmentId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteRoleAssignmentHook>>>,
  TError,
  { roleAssignmentId: string },
  TContext
> => {
  const mutationOptions = useDeleteRoleAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete a sub-organization by ID
 */
export const useDeleteSubOrganizationHook = () => {
  const deleteSubOrganization = useCustomAxios<void>();

  return useCallback(
    (subOrgId: string) => {
      return deleteSubOrganization({ url: `/v1/suborganizations/${subOrgId}`, method: 'DELETE' });
    },
    [deleteSubOrganization]
  );
};

export const useDeleteSubOrganizationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteSubOrganizationHook>>>,
    TError,
    { subOrgId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteSubOrganizationHook>>>,
  TError,
  { subOrgId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteSubOrganization = useDeleteSubOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteSubOrganizationHook>>>,
    { subOrgId: string }
  > = props => {
    const { subOrgId } = props ?? {};

    return deleteSubOrganization(subOrgId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSubOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteSubOrganizationHook>>>
>;

export type DeleteSubOrganizationMutationError = void;

/**
 * @summary Delete a sub-organization by ID
 */
export const useDeleteSubOrganization = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteSubOrganizationHook>>>,
    TError,
    { subOrgId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteSubOrganizationHook>>>,
  TError,
  { subOrgId: string },
  TContext
> => {
  const mutationOptions = useDeleteSubOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * This endpoint deletes a specific test template from the process by its ID.
 * @summary Remove a test template from a process
 */
export const useRemoveTestTemplateHook = () => {
  const removeTestTemplate = useCustomAxios<string>();

  return useCallback(
    (processId: string, testTemplateId: string) => {
      return removeTestTemplate({
        url: `/v1/processes/${processId}/test-templates/${testTemplateId}`,
        method: 'DELETE'
      });
    },
    [removeTestTemplate]
  );
};

export const useRemoveTestTemplateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveTestTemplateHook>>>,
    TError,
    { processId: string; testTemplateId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRemoveTestTemplateHook>>>,
  TError,
  { processId: string; testTemplateId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const removeTestTemplate = useRemoveTestTemplateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRemoveTestTemplateHook>>>,
    { processId: string; testTemplateId: string }
  > = props => {
    const { processId, testTemplateId } = props ?? {};

    return removeTestTemplate(processId, testTemplateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTestTemplateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRemoveTestTemplateHook>>>
>;

export type RemoveTestTemplateMutationError = unknown;

/**
 * @summary Remove a test template from a process
 */
export const useRemoveTestTemplate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveTestTemplateHook>>>,
    TError,
    { processId: string; testTemplateId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRemoveTestTemplateHook>>>,
  TError,
  { processId: string; testTemplateId: string },
  TContext
> => {
  const mutationOptions = useRemoveTestTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes a file (from S3 and the database metadata) for the specified process and talent.
 * @summary Delete a file for a specific process and talent
 */
export const useDeleteFileHook = () => {
  const deleteFile = useCustomAxios<void>();

  return useCallback(
    (processId: string, talentId: string, fileId: string) => {
      return deleteFile({ url: `/v1/processes/${processId}/talents/${talentId}/files/${fileId}`, method: 'DELETE' });
    },
    [deleteFile]
  );
};

export const useDeleteFileMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFileHook>>>,
    TError,
    { processId: string; talentId: string; fileId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteFileHook>>>,
  TError,
  { processId: string; talentId: string; fileId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteFile = useDeleteFileHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteFileHook>>>,
    { processId: string; talentId: string; fileId: string }
  > = props => {
    const { processId, talentId, fileId } = props ?? {};

    return deleteFile(processId, talentId, fileId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteFileHook>>>>;

export type DeleteFileMutationError = void;

/**
 * @summary Delete a file for a specific process and talent
 */
export const useDeleteFile = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFileHook>>>,
    TError,
    { processId: string; talentId: string; fileId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteFileHook>>>,
  TError,
  { processId: string; talentId: string; fileId: string },
  TContext
> => {
  const mutationOptions = useDeleteFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes a specific catalog item from the process.
 * @summary Remove a catalog item from a process
 */
export const useRemoveCatalogItemFromProcessHook = () => {
  const removeCatalogItemFromProcess = useCustomAxios<void>();

  return useCallback(
    (processId: string, catalogItemId: string) => {
      return removeCatalogItemFromProcess({
        url: `/v1/processes/${processId}/catalog-items/${catalogItemId}`,
        method: 'DELETE'
      });
    },
    [removeCatalogItemFromProcess]
  );
};

export const useRemoveCatalogItemFromProcessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveCatalogItemFromProcessHook>>>,
    TError,
    { processId: string; catalogItemId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRemoveCatalogItemFromProcessHook>>>,
  TError,
  { processId: string; catalogItemId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const removeCatalogItemFromProcess = useRemoveCatalogItemFromProcessHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRemoveCatalogItemFromProcessHook>>>,
    { processId: string; catalogItemId: string }
  > = props => {
    const { processId, catalogItemId } = props ?? {};

    return removeCatalogItemFromProcess(processId, catalogItemId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveCatalogItemFromProcessMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRemoveCatalogItemFromProcessHook>>>
>;

export type RemoveCatalogItemFromProcessMutationError = unknown;

/**
 * @summary Remove a catalog item from a process
 */
export const useRemoveCatalogItemFromProcess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveCatalogItemFromProcessHook>>>,
    TError,
    { processId: string; catalogItemId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRemoveCatalogItemFromProcessHook>>>,
  TError,
  { processId: string; catalogItemId: string },
  TContext
> => {
  const mutationOptions = useRemoveCatalogItemFromProcessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete a folder by ID
 */
export const useDeleteFolderHook = () => {
  const deleteFolder = useCustomAxios<void>();

  return useCallback(
    (id: string) => {
      return deleteFolder({ url: `/v1/folders/${id}`, method: 'DELETE' });
    },
    [deleteFolder]
  );
};

export const useDeleteFolderMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFolderHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteFolderHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteFolder = useDeleteFolderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteFolderHook>>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteFolder(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteFolderHook>>>>;

export type DeleteFolderMutationError = void;

/**
 * @summary Delete a folder by ID
 */
export const useDeleteFolder = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFolderHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteFolderHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useDeleteFolderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const use_DeleteHook = () => {
  const _delete = useCustomAxios<void>();

  return useCallback(
    (params: _DeleteParams) => {
      return _delete({ url: `/redis/delete`, method: 'DELETE', params });
    },
    [_delete]
  );
};

export const useDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>,
    TError,
    { params: _DeleteParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>,
  TError,
  { params: _DeleteParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const _delete = use_DeleteHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>,
    { params: _DeleteParams }
  > = props => {
    const { params } = props ?? {};

    return _delete(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type _DeleteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>>;

export type _DeleteMutationError = unknown;

export const useDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>,
    TError,
    { params: _DeleteParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>,
  TError,
  { params: _DeleteParams },
  TContext
> => {
  const mutationOptions = useDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Invalidate a specific session
 */
export const useInvalidateSessionHook = () => {
  const invalidateSession = useCustomAxios<void>();

  return useCallback(
    (sessionId: string) => {
      return invalidateSession({ url: `/api/v1/sessions/${sessionId}`, method: 'DELETE' });
    },
    [invalidateSession]
  );
};

export const useInvalidateSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvalidateSessionHook>>>,
    TError,
    { sessionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInvalidateSessionHook>>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const invalidateSession = useInvalidateSessionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInvalidateSessionHook>>>,
    { sessionId: string }
  > = props => {
    const { sessionId } = props ?? {};

    return invalidateSession(sessionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvalidateSessionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInvalidateSessionHook>>>
>;

export type InvalidateSessionMutationError = unknown;

/**
 * @summary Invalidate a specific session
 */
export const useInvalidateSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvalidateSessionHook>>>,
    TError,
    { sessionId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInvalidateSessionHook>>>,
  TError,
  { sessionId: string },
  TContext
> => {
  const mutationOptions = useInvalidateSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Invalidate all sessions for a user
 */
export const useInvalidateAllUserSessionsHook = () => {
  const invalidateAllUserSessions = useCustomAxios<void>();

  return useCallback(
    (userId: string) => {
      return invalidateAllUserSessions({ url: `/api/v1/sessions/user/${userId}/all`, method: 'DELETE' });
    },
    [invalidateAllUserSessions]
  );
};

export const useInvalidateAllUserSessionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvalidateAllUserSessionsHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInvalidateAllUserSessionsHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const invalidateAllUserSessions = useInvalidateAllUserSessionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInvalidateAllUserSessionsHook>>>,
    { userId: string }
  > = props => {
    const { userId } = props ?? {};

    return invalidateAllUserSessions(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvalidateAllUserSessionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInvalidateAllUserSessionsHook>>>
>;

export type InvalidateAllUserSessionsMutationError = unknown;

/**
 * @summary Invalidate all sessions for a user
 */
export const useInvalidateAllUserSessions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvalidateAllUserSessionsHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInvalidateAllUserSessionsHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useInvalidateAllUserSessionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useDeleteOrganizationHook = () => {
  const deleteOrganization = useCustomAxios<DeleteOrganization200>();

  return useCallback(
    (orgId: string) => {
      return deleteOrganization({ url: `/api/rbac-demo/orgs/${orgId}`, method: 'DELETE' });
    },
    [deleteOrganization]
  );
};

export const useDeleteOrganizationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrganizationHook>>>,
    TError,
    { orgId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteOrganizationHook>>>,
  TError,
  { orgId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteOrganization = useDeleteOrganizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrganizationHook>>>,
    { orgId: string }
  > = props => {
    const { orgId } = props ?? {};

    return deleteOrganization(orgId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteOrganizationHook>>>
>;

export type DeleteOrganizationMutationError = unknown;

export const useDeleteOrganization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrganizationHook>>>,
    TError,
    { orgId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteOrganizationHook>>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = useDeleteOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useDeleteFolderItemHook = () => {
  const deleteFolderItem = useCustomAxios<DeleteFolderItem200>();

  return useCallback(
    (folderId: string, itemId: string) => {
      return deleteFolderItem({ url: `/api/rbac-demo/folders/${folderId}/items/${itemId}`, method: 'DELETE' });
    },
    [deleteFolderItem]
  );
};

export const useDeleteFolderItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFolderItemHook>>>,
    TError,
    { folderId: string; itemId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteFolderItemHook>>>,
  TError,
  { folderId: string; itemId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const deleteFolderItem = useDeleteFolderItemHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteFolderItemHook>>>,
    { folderId: string; itemId: string }
  > = props => {
    const { folderId, itemId } = props ?? {};

    return deleteFolderItem(folderId, itemId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFolderItemMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteFolderItemHook>>>
>;

export type DeleteFolderItemMutationError = unknown;

export const useDeleteFolderItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFolderItemHook>>>,
    TError,
    { folderId: string; itemId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteFolderItemHook>>>,
  TError,
  { folderId: string; itemId: string },
  TContext
> => {
  const mutationOptions = useDeleteFolderItemMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve test session report as a stringified PDF using TestSession ID.
 * @summary Get Report PDF
 */
export const useGetReportPdfHook = () => {
  const getReportPdf = useCustomBinaryAxios<string>();

  return useCallback(
    (testSessionId: string, params?: GetReportPdfParams, signal?: AbortSignal) => {
      return getReportPdf({ url: `/v1/test-sessions/${testSessionId}/pdf-report`, method: 'GET', params, signal });
    },
    [getReportPdf]
  );
};

export const useGetReportPdfMutationOptions = <TError = string[], TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportPdfHook>>>,
    TError,
    { testSessionId: string; params?: GetReportPdfParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useGetReportPdfHook>>>,
  TError,
  { testSessionId: string; params?: GetReportPdfParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const getReportPdf = useGetReportPdfHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useGetReportPdfHook>>>,
    { testSessionId: string; params?: GetReportPdfParams }
  > = props => {
    const { testSessionId, params } = props ?? {};

    return getReportPdf(testSessionId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetReportPdfMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportPdfHook>>>>;

export type GetReportPdfMutationError = string[];

/**
 * @summary Get Report PDF
 */
export const useGetReportPdf = <TError = string[], TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportPdfHook>>>,
    TError,
    { testSessionId: string; params?: GetReportPdfParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useGetReportPdfHook>>>,
  TError,
  { testSessionId: string; params?: GetReportPdfParams },
  TContext
> => {
  const mutationOptions = useGetReportPdfMutationOptions(options);

  return useMutation(mutationOptions);
};
